<template>
  <div class="content_son">
    <!-- 左侧患者列表 -->
    <consultationControlClass
      :classData="classData"
      :currentChatId="itemCacheChatData?.chatId || ''"
      :dataOrigin="'2'"
      @clickChatClass="handlePatientSelect"
      @refreshData="refreshData"
      @statusBtn="handleStatusBtn"
      class="chatClass"
      ref="chatClass"
      :style="{ width: leftPanelWidth - 10 + 'px' }"
    />

    <!-- 左中面板分隔符 -->
    <div
      class="panel-divider"
      @mousedown="startResize('left')"
      :style="{ left: leftPanelWidth + 'px' }"
    >
      <div class="divider-handle"></div>
    </div>

    <!-- 中间：住院病历区域 -->
    <div
      class="medical_record"
      :style="{
        left: leftPanelWidth + 10 + 'px',
        right: rightPanelWidth + 10 + 'px'
      }"
    >
      <!-- 顶部操作栏 -->
      <div class="top">
        <div class="tabs-wrapper" v-if="itemCacheChatData && itemCacheChatData.id">
          <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs-in-top">
            <el-tab-pane
              v-for="tab in availableTabs"
              :key="tab.name"
              :label="tab.label"
              :name="tab.name"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div v-else></div>
        <div class="right">
          <el-tooltip
            class="item"
            :open-delay="800"
            effect="dark"
            content="复制当前签页全部内容"
            placement="top"
          >
            <div class="hisbtn" style="margin-right: 8px;" @click="copyCurrentTabContent">
              <i class="el-icon-document-copy"></i>复制本页
            </div>
          </el-tooltip>
          <el-tooltip
            class="item"
            :open-delay=800
            effect="dark"
            content="提交病历到HIS系统"
            placement="top"
          >
            <div class="hisbtn" @click="submitToHis">
              <i class="el-icon-upload2"></i>HIS提交
            </div>
          </el-tooltip>
        </div>
      </div>

      <!-- 空态：未选择患者时 -->
      <div class="center center-empty" v-if="!itemCacheChatData || !itemCacheChatData.id">
        <div class="icoBox " style="margin-top:2rem">
          <div class="ico">
            <i class="el-icon-warning-outline"></i>
          </div>
        </div>
        <div class="text">请从左侧选择一位患者</div>
        <div class="text2">选择患者后查看病历详情</div>
      </div>

      <!-- Tab 内容：选择患者后显示 -->
      <div class="center center-with-content" v-else>
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs-content">
          <!-- 动态渲染标签，不再写死 -->
          <el-tab-pane
            v-for="tab in availableTabs"
            :key="tab.name"
            :label="tab.label"
            :name="tab.name"
          >
            <!-- 入院记录 -->
            <AdmissionRecord
              v-if="tab.name === 'admission'"
              ref="admissionRecord"
              :patientData="itemCacheChatData"
              v-model="admissionData"
              @save="handleFieldSave"
            />
            <!-- 病程记录 -->
            <ProgressRecord
              v-else-if="tab.name === 'progress'"
              ref="progressRecord"
              :patientData="itemCacheChatData"
              v-model="progressData"
              @save="handleFieldSave"
            />
            <!-- 首次病程 -->
            <ProgressRecord
              v-else-if="tab.name === 'first_progress'"
              ref="firstProgressRecord"
              :patientData="itemCacheChatData"
              v-model="firstProgressData"
              @save="handleFieldSave"
            />
            <!-- 日常病程 -->
            <ProgressRecord
              v-else-if="tab.name === 'daily_progress'"
              ref="dailyProgressRecord"
              :patientData="itemCacheChatData"
              v-model="dailyProgressData"
              @save="handleFieldSave"
            />
            <!-- 上级医师查房记录 -->
            <ProgressRecord
              v-else-if="tab.name === 'doctor_progress'"
              ref="doctorProgressRecord"
              :patientData="itemCacheChatData"
              v-model="doctorProgressData"
              @save="handleFieldSave"
            />
            <!-- 出院记录 -->
            <DischargeRecord
              v-else-if="tab.name === 'discharge'"
              ref="dischargeRecord"
              :patientData="itemCacheChatData"
              v-model="dischargeData"
              @save="handleFieldSave"
            />
            <!-- 体格检查（暂时隐藏） -->
            <PhysicalExam
              v-else-if="tab.name === 'physical'"
              ref="physicalExam"
              :patientData="itemCacheChatData"
              v-model="physicalExamData"
              @save="handleFieldSave"
            />
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 底部按钮 -->
      <div class="bottom">
        <div class="btn">
          <el-button
            size="small"
            @click="openHistoryModal"
            style="margin-right: 8px;"
          >
            <i class="el-icon-time"></i>历史病历
          </el-button>
          <el-popover
            ref="historyPopover"
            placement="top"
            v-model="historyVisible"
            trigger="click"
            @show="onHistoryPopoverShow"
            :append-to-body="false"
          >
            <div class="history-list">
              <template v-if="historyData && historyData.length > 0">
                <div
                  v-for="(item, index) in historyData"
                  :key="index"
                  class="history-item"
                  @click="selectHistoryItem(item)"
                >
                  <div class="date">{{getHistoryDate(item)}}</div>
                  <div class="diagnosis">{{getHistoryContent(item)}}</div>
                </div>
              </template>
              <div v-else class="history-item-empty">
                <div class="empty-text">暂无病历历史</div>
              </div>
            </div>
            <template #reference>
              <el-tooltip
                class="item"
                :open-delay=800
                effect="dark"
                content="查看病历历史记录"
                placement="top"
              >
                <button>
                  <i class="el-icon-time"></i>操作记录
                </button>
              </el-tooltip>
            </template>
          </el-popover>
          <el-popover placement="top" v-model="clearVisible">
            <div class="popover-content">
              <div class="title">
                <i class="el-icon-warning"></i>确认新建病历？
              </div>
              <div class="txt">此操作将清空现有病历内容，请谨慎操作！</div>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="clearVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="clearCurrentTab">确定</el-button>
            </div>
            <template #reference>
              <el-tooltip
                class="item"
                :open-delay=800
                effect="dark"
                content="清空现有病历，请谨慎操作"
                placement="top"
              >
                <el-button
                  size="small"
                  class="del-btn-like-reject"
                >
                  <i class="el-icon-delete"></i>新建病历
                </el-button>
              </el-tooltip>
            </template>
          </el-popover>
        </div>
        <!-- 全部接受和全部拒绝按钮 - 固定在右下角 -->
        <div class="accept-reject-buttons" v-if="hasSuggestions">
          <el-tooltip
            class="item"
            :open-delay=800
            effect="dark"
            content="接受所有AI建议的修改"
            placement="top"
          >
            <button @click="handleAcceptAll" class="accept-all-btn">
              <i class="el-icon-check"></i>全部接受
            </button>
          </el-tooltip>
          <el-tooltip
            class="item"
            :open-delay=800
            effect="dark"
            content="拒绝所有AI建议的修改"
            placement="top"
          >
            <button @click="handleRejectAll" class="reject-all-btn">
              <i class="el-icon-close"></i>全部拒绝
            </button>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- 中右面板分隔符 -->
    <div
      class="panel-divider"
      @mousedown="startResize('middle')"
      :style="{ right: rightPanelWidth + 'px' }"
    >
      <div class="divider-handle"></div>
    </div>

    <!-- 右侧AI对话 -->
    <div
      class="chatBox_dom"
      :style="{ width: rightPanelWidth - 10 + 'px' }"
    >
      <div class="soundRecording">
        <SoundRecording
          ref="soundRecording"
          :medmstrId="itemCacheChatData?.id"
          :chatGroup="currentChatGroup"
          @uploadRecording="handleUploadRecording"
          @handleShibie="handleShibie"
          @selectTemplate="handleSelectTemplate"
          @recordingStateChange="handleRecordingStateChange"
          @loadRecordingHistory="handleLoadRecordingHistory"
          @selectRecordingHistory="handleSelectRecordingHistory"
          @switchToConversation="handleSwitchToConversation"
          @startNewConversation="handleStartNewConversation"
          @ocrFileSelect="handleOcrFileSelect"
        />
      </div>
      <ChatBoxDoctor
        ref="chatBoxDoctor"
        :chatData="chatData_doctor"
        :selectedTemplate="selectedTemplateName"
        :recordingState="recordingState"
        @sendBtn="handleSendMessage"
        @createByOneBtn="handleCreateByOneBtn"
        @updateBtn="updateBtn"
      />
    </div>

    <!-- HIS提交确认弹窗 -->
    <el-dialog title="确认提交到HIS系统" :visible.sync="hisSub" width="30%">
      <div class="hisDia">
        <p>您确定要将当前病历提交到HIS系统吗？</p>
        <span>提交后将无法撤销，请确认内容已核对无误。</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hisSub = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmHisSubmit" size="small" :loading="hisSubmitLoading">确认提交</el-button>
      </span>
    </el-dialog>

    <!-- 录音内容弹窗（住院病历使用，按钮与门诊保持一致） -->
    <el-dialog
      title="录音内容"
      :visible.sync="dialogFormVisible"
      width="45%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :modal="false"
      :append-to-body="true"
      custom-class="recording-dialog"
      @close="clearAudioPath"
    >
      <!-- 音频播放控件和重试按钮 -->
      <div v-if="currentAudioFilePath" class="audio-section" style="margin-bottom: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 8px; display: flex; align-items: center; gap: 12px;">
        <audio :src="currentAudioFilePath" controls style="flex: 1;"></audio>
        <el-button
          type="warning"
          size="small"
          icon="el-icon-refresh"
          @click="handleRetryRecording"
          :loading="audioRetryLoading"
        >
          重新上传音频
        </el-button>
      </div>

      <div class="editBox">
        <el-input
          type="textarea"
          :rows="12"
          placeholder="请输入内容"
          v-model="extractedMessage"
          style="width: 100%; font-size: 19.5px; font-weight: bold;"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRecordingApplyToMedical" :loading="recordingApplyLoading" class="sub">
          确定并引用到病历
        </el-button>
        <el-button type="success" @click="handleRecordingAcceptAllAndSubmit" :loading="recordingSubmitLoading" class="accept-all-submit-btn">
          <i class="el-icon-check"></i>全部接受并提交HIS
        </el-button>
      </div>
    </el-dialog>

    <!-- 病历历史确认弹窗 -->
    <el-dialog
      :title="getHistoryDialogTitle()"
      :visible.sync="medicalHistoryConfirmVisible"
      width="80%"
      custom-class="medical-history-dialog"
      :modal="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="onMedicalHistoryDialogOpen">
      <div class="history-confirm-dialog">
        <div class="dialog-content">
          <!-- 左侧：病历历史列表 -->
          <div class="history-list-panel">
            <h4>{{getHistoryListTitle()}}</h4>
            <!-- 来源筛选：HIS / 本地 -->
            <div class="history-source-filter">
              <el-checkbox v-model="historySourceHisChecked" @change="handleHistorySourceChange">
                HIS
              </el-checkbox>
              <el-checkbox v-model="historySourceLocalChecked" @change="handleHistorySourceChange">
                本地
              </el-checkbox>
            </div>
            <div class="history-scroll-list">
              <div
                v-for="(item, index) in historyData"
                :key="index"
                class="history-item-in-dialog"
                :class="{ active: selectedHistoryItem && selectedHistoryItem.id === item.id }"
                @click="switchToMedicalHistory(item)"
              >
                <div class="date">{{getHistoryDate(item)}}</div>
                <div class="preview">{{getHistoryContent(item)}}</div>
                <div class="source" v-if="item.source">来源：{{item.source || '未知'}}</div>
              </div>
            </div>
          </div>

          <!-- 右侧：病历内容显示 -->
          <div class="history-content-panel">
            <h4>病历内容</h4>
            <!-- 生成病历附加说明 -->
            <div class="history-attach-input">
              <el-input
                type="textarea"
                :rows="3"
                v-model="attachContent"
                placeholder="请输入需要附加在病历中的说明（可选）"
              />
            </div>
            <div class="content-display" v-if="selectedHistoryItem">
              <div class="medical-record-content" v-if="historyDialogDetailData && Object.keys(historyDialogDetailData).length > 0">
                <!-- 入院记录详情 -->
                <template v-if="activeTab === 'admission'">
                  <!-- 动态字段展示 -->
                  <template v-if="historyDialogDetailData.fields && Array.isArray(historyDialogDetailData.fields) && historyDialogDetailData.fields.length > 0">
                    <div class="field-item" v-for="(field, index) in historyDialogDetailData.fields" :key="index">
                      <div class="field-label">{{field.label || field.key}}：</div>
                      <div class="field-value">{{field.value || '-'}}</div>
                    </div>
                  </template>
                  <!-- 兼容旧数据格式（如果没有 fields 数组，使用硬编码字段） -->
                  <template v-else>
                    <div class="field-item" v-if="historyDialogDetailData.chiefComplaint">
                      <div class="field-label">主诉：</div>
                      <div class="field-value">{{historyDialogDetailData.chiefComplaint || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.presentIllness">
                      <div class="field-label">现病史：</div>
                      <div class="field-value">{{historyDialogDetailData.presentIllness || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.pastHistory">
                      <div class="field-label">既往史：</div>
                      <div class="field-value">{{historyDialogDetailData.pastHistory || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.allergyHistory">
                      <div class="field-label">过敏史：</div>
                      <div class="field-value">{{historyDialogDetailData.allergyHistory || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.familyHistory">
                      <div class="field-label">家族史：</div>
                      <div class="field-value">{{historyDialogDetailData.familyHistory || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.vitalSigns">
                      <div class="field-label">生命体征：</div>
                      <div class="field-value">{{historyDialogDetailData.vitalSigns || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.physicalExamination">
                      <div class="field-label">体格检查：</div>
                      <div class="field-value">{{historyDialogDetailData.physicalExamination || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.primaryDiagnosis">
                      <div class="field-label">诊断：</div>
                      <div class="field-value">{{historyDialogDetailData.primaryDiagnosis || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.treatmentPlan">
                      <div class="field-label">治疗计划：</div>
                      <div class="field-value">{{historyDialogDetailData.treatmentPlan || '-'}}</div>
                    </div>
                  </template>
                </template>

                <!-- 病程记录详情 -->
                <template v-if="activeTab === 'progress' || activeTab === 'first_progress' || activeTab === 'daily_progress' || activeTab === 'doctor_progress'">
                  <!-- 动态字段展示 -->
                  <template v-if="historyDialogDetailData.fields && Array.isArray(historyDialogDetailData.fields) && historyDialogDetailData.fields.length > 0">
                    <div class="field-item" v-for="(field, index) in historyDialogDetailData.fields" :key="index">
                      <div class="field-label">{{field.label || field.key}}：</div>
                      <div class="field-value">{{isDateField(field.key) ? formatDate(field.value) : (field.value || '-')}}</div>
                    </div>
                  </template>
                  <!-- 兼容旧数据：如果没有 fields 数组，显示固定字段 -->
                  <template v-else>
                    <div class="field-item" v-if="historyDialogDetailData.noteTime">
                      <div class="field-label">记录时间：</div>
                      <div class="field-value">{{historyDialogDetailData.noteTime || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.title">
                      <div class="field-label">标题：</div>
                      <div class="field-value">{{historyDialogDetailData.title || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.content">
                      <div class="field-label">内容：</div>
                      <div class="field-value">{{historyDialogDetailData.content || '-'}}</div>
                    </div>
                  </template>
                </template>

                <!-- 出院记录详情 -->
                <template v-if="activeTab === 'discharge'">
                  <!-- 动态字段展示 -->
                  <template v-if="historyDialogDetailData.fields && Array.isArray(historyDialogDetailData.fields) && historyDialogDetailData.fields.length > 0">
                    <div class="field-item" v-for="(field, index) in historyDialogDetailData.fields" :key="index">
                      <div class="field-label">{{field.label || field.key}}：</div>
                      <div class="field-value">
                        <template v-if="isDateField(field.key)">
                          {{formatDate(field.value) || '-'}}
                        </template>
                        <template v-else>
                          {{field.value || '-'}}
                        </template>
                      </div>
                    </div>
                  </template>
                  <!-- 兼容旧数据格式 -->
                  <template v-else>
                    <div class="field-item" v-if="historyDialogDetailData.dischargeTime">
                      <div class="field-label">出院时间：</div>
                      <div class="field-value">{{formatDate(historyDialogDetailData.dischargeTime) || '-'}}</div>
                    </div>
                    <div class="field-item" v-if="historyDialogDetailData.content">
                      <div class="field-label">出院描述：</div>
                      <div class="field-value">{{historyDialogDetailData.content || '-'}}</div>
                    </div>
                  </template>
                </template>

                <!-- 体格检查详情 -->
                <template v-if="activeTab === 'physical'">
                  <div class="field-item" v-if="historyDialogDetailData.recordTime">
                    <div class="field-label">记录时间：</div>
                    <div class="field-value">{{formatDate(historyDialogDetailData.recordTime) || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.temperatureC !== undefined && historyDialogDetailData.temperatureC !== null">
                    <div class="field-label">体温(℃)：</div>
                    <div class="field-value">{{historyDialogDetailData.temperatureC || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.pulseBpm !== undefined && historyDialogDetailData.pulseBpm !== null">
                    <div class="field-label">脉搏(次/分)：</div>
                    <div class="field-value">{{historyDialogDetailData.pulseBpm || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.respirationBpm !== undefined && historyDialogDetailData.respirationBpm !== null">
                    <div class="field-label">呼吸(次/分)：</div>
                    <div class="field-value">{{historyDialogDetailData.respirationBpm || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.bloodPressure">
                    <div class="field-label">血压：</div>
                    <div class="field-value">{{historyDialogDetailData.bloodPressure || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.heightCm !== undefined && historyDialogDetailData.heightCm !== null">
                    <div class="field-label">身高(cm)：</div>
                    <div class="field-value">{{historyDialogDetailData.heightCm || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.weightKg !== undefined && historyDialogDetailData.weightKg !== null">
                    <div class="field-label">体重(kg)：</div>
                    <div class="field-value">{{historyDialogDetailData.weightKg || '-'}}</div>
                  </div>
                  <div class="field-item" v-if="historyDialogDetailData.description">
                    <div class="field-label">描述：</div>
                    <div class="field-value">{{historyDialogDetailData.description || '-'}}</div>
                  </div>
                </template>
              </div>
              <div class="medical-record-content" v-else>
                <div class="no-selection">正在加载病例详情...</div>
              </div>
            </div>
            <div class="content-display" v-else>
              <div class="no-selection">请从左侧选择病历历史记录</div>
            </div>
          </div>
        </div>

        <div class="confirm-action">
          <p><i class="el-icon-warning"></i> 重新启用此病历记录将替换当前正在编辑的病历内容，是否确认？</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUseMedicalHistory" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmUseMedicalHistory" size="small">重新启用此历史病历</el-button>
      </span>
    </el-dialog>

    <!-- 历史病历弹窗 -->
    <el-dialog
      title="历史病历"
      :visible.sync="historyModalVisible"
      :width="''"
      top="2vh"
      custom-class="history-modal-dialog"
      :modal="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :before-close="handleHistoryModalBeforeClose"
      @open="initDialogDrag"
    >
      <div class="history-modal-content">
        <!-- 顶部：科室和急诊号选择 -->
        <div class="history-modal-header">
          <div class="header-left">
            <el-select v-model="selectedDepartment" placeholder="选择科室" style="width: 200px; margin-right: 12px;" @change="handleDepartmentChange">
              <el-option
                v-for="dept in historyModalDepartments"
                :key="dept.id"
                :label="dept.departmentName"
                :value="dept.id"
              ></el-option>
            </el-select>
            <el-tooltip
              :content="(historyModalVisitNumbers.find(v => v.visitNum === selectedVisitNum) || {}).displayText || ''"
              placement="top"
              :disabled="!selectedVisitNum"
              effect="dark"
            >
              <el-select
                v-model="selectedVisitNum"
                placeholder="选择急诊号"
                class="history-visitnum-select"
                popper-class="history-visitnum-popper"
                style="width: 420px; max-width: 45vw;"
                @change="handleVisitNumChange"
              >
                <el-option
                  v-for="visit in historyModalVisitNumbers"
                  :key="visit.visitNum"
                  :label="visit.displayText"
                  :value="visit.visitNum"
                >
                  <div class="history-visitnum-option">{{ visit.displayText }}</div>
                </el-option>
              </el-select>
            </el-tooltip>
          </div>
          <div class="header-right">
            <div class="patient-info">
              <span>患者姓名：{{ itemCacheChatData?.realname || itemCacheChatData?.name || '-' }}</span>
              <span style="margin-left: 16px;">性别：{{ itemCacheChatData?.sexText || itemCacheChatData?.gender || '-' }}</span>
              <span style="margin-left: 16px;">年龄：{{ itemCacheChatData?.age ? (itemCacheChatData.age + '岁') : '-' }}</span>
              <span style="margin-left: 16px;">就诊科室：{{ itemCacheChatData?.departmentName || '-' }}</span>
              <span style="margin-left: 16px;">就诊日期：{{ formatDate(itemCacheChatData?.clinicCheckinTime || itemCacheChatData?.visitDate) || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 主体内容：左侧导航、中间详情、右侧购物车 -->
        <div class="history-modal-body">
          <!-- 左侧：病例导航（树形结构） -->
          <div class="history-modal-left" :style="{ width: dlgLeftWidth + 'px' }">
            <!-- 工具栏：搜索 + 排序 -->
            <div class="nav-toolbar">
              <div class="nav-search">
                <el-input
                  v-model="navSearchKeyword"
                  placeholder="搜索病历..."
                  prefix-icon="el-icon-search"
                  size="mini"
                  clearable
                ></el-input>
              </div>
              <!-- 来源筛选：HIS / 本地 -->
              <div class="nav-source-filter">
                <el-checkbox v-model="historySourceHisChecked" @change="handleHistorySourceChange" size="mini">
                  HIS
                </el-checkbox>
                <el-checkbox v-model="historySourceLocalChecked" @change="handleHistorySourceChange" size="mini">
                  本地
                </el-checkbox>
              </div>
              <button
                class="sort-toggle-btn"
                @click="navSortOrder = navSortOrder === 'desc' ? 'asc' : 'desc'"
                :title="navSortOrder === 'desc' ? '当前：最新在前，点击切换为最旧在前' : '当前：最旧在前，点击切换为最新在前'"
              >
                <i :class="navSortOrder === 'desc' ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i>
              </button>
            </div>

            <div class="navigation-tree">
              <!-- 门诊病历 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('outpatient')"
                >
                  <i :class="historyModalCategories.outpatient.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-document category-icon"></i>
                  <span class="category-label">门诊病历</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.outpatientList, 'outpatient') }}</span>/{{ historyModalNavigation.outpatientList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.outpatientList.length }})</span>
                </div>
                <div v-show="historyModalCategories.outpatient.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.outpatientList, 'outpatient')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'outpatient')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.primaryDiagnosis || '门诊病历' }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'outpatient') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.outpatientList, 'outpatient').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 入院记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('admission')"
                >
                  <i :class="historyModalCategories.admission.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-document category-icon"></i>
                  <span class="category-label">入院记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.admissionList, 'admission') }}</span>/{{ historyModalNavigation.admissionList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.admissionList.length }})</span>
                </div>
                <div v-show="historyModalCategories.admission.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.admissionList, 'admission')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'admission')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.primaryDiagnosis || '入院记录' }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'admission') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.admissionList, 'admission').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 首次病程记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('firstProgress')"
                >
                  <i :class="historyModalCategories.firstProgress.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-edit-outline category-icon"></i>
                  <span class="category-label">首次病程记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.firstProgressList, 'firstProgress') }}</span>/{{ historyModalNavigation.firstProgressList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.firstProgressList.length }})</span>
                </div>
                <div v-show="historyModalCategories.firstProgress.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.firstProgressList, 'firstProgress')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'firstProgress')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.content || `${formatDateForHistory(item.noteTime)}首次病程记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'firstProgress') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.firstProgressList, 'firstProgress').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 日常病程记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('dailyProgress')"
                >
                  <i :class="historyModalCategories.dailyProgress.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-edit-outline category-icon"></i>
                  <span class="category-label">日常病程记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.dailyProgressList, 'dailyProgress') }}</span>/{{ historyModalNavigation.dailyProgressList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.dailyProgressList.length }})</span>
                </div>
                <div v-show="historyModalCategories.dailyProgress.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.dailyProgressList, 'dailyProgress')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'dailyProgress')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.content || `${formatDateForHistory(item.noteTime)}日常病程记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'dailyProgress') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.dailyProgressList, 'dailyProgress').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 上级医师查房记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('doctorProgress')"
                >
                  <i :class="historyModalCategories.doctorProgress.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-edit-outline category-icon"></i>
                  <span class="category-label">上级医师查房记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.doctorProgressList, 'doctorProgress') }}</span>/{{ historyModalNavigation.doctorProgressList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.doctorProgressList.length }})</span>
                </div>
                <div v-show="historyModalCategories.doctorProgress.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.doctorProgressList, 'doctorProgress')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'doctorProgress')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.content || `${formatDateForHistory(item.noteTime)}上级医师查房记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'doctorProgress') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.doctorProgressList, 'doctorProgress').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 出院记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('discharge')"
                >
                  <i :class="historyModalCategories.discharge.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-document category-icon"></i>
                  <span class="category-label">出院记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.dischargeList, 'discharge') }}</span>/{{ historyModalNavigation.dischargeList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.dischargeList.length }})</span>
                </div>
                <div v-show="historyModalCategories.discharge.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.dischargeList, 'discharge')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'discharge')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.content || `${formatDateForHistory(item.dischargeTime)}出院记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'discharge') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.dischargeList, 'discharge').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 检验报告 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('test')"
                >
                  <i :class="historyModalCategories.test.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-document category-icon"></i>
                  <span class="category-label">检验报告</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.testList, 'test') }}</span>/{{ historyModalNavigation.testList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.testList.length }})</span>
                </div>
                <div v-show="historyModalCategories.test.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.testList, 'test')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'test')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.testType || '检验报告' }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'test') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.testList, 'test').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 录音记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('recording')"
                >
                  <i :class="historyModalCategories.recording.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-microphone category-icon"></i>
                  <span class="category-label">录音记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.recordingList, 'recording') }}</span>/{{ historyModalNavigation.recordingList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.recordingList.length }})</span>
                </div>
                <div v-show="historyModalCategories.recording.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.recordingList, 'recording')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'recording')"
                  >
                    <span class="nav-item-label">{{ item.displayName || `${formatRecordingDateTime(item.createTime)}录音记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'recording') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.recordingList, 'recording').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>

              <!-- 图片记录 -->
              <div class="navigation-category">
                <div
                  class="category-header"
                  @click="toggleCategory('image')"
                >
                  <i :class="historyModalCategories.image.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                  <i class="el-icon-picture category-icon"></i>
                  <span class="category-label">图片记录</span>
                  <span class="category-count" v-if="navSearchKeyword">(<span class="count-filtered">{{ getFilteredCount(historyModalNavigation.imageList, 'image') }}</span>/{{ historyModalNavigation.imageList.length }})</span>
                  <span class="category-count" v-else>({{ historyModalNavigation.imageList.length }})</span>
                </div>
                <div v-show="historyModalCategories.image.expanded" class="category-items">
                  <div
                    v-for="item in getNavList(historyModalNavigation.imageList, 'image')"
                    :key="item.id"
                    class="navigation-item"
                    :class="{ active: historyModalDetail && historyModalDetail.id === item.id }"
                    @click="loadHistoryModalDetail(item, 'image')"
                  >
                    <span class="nav-item-label">{{ item.displayName || item.title || `${formatDateForHistory(item.createTime)}图片记录` }}</span>
                    <span class="nav-item-time">{{ getItemTimeDisplay(item, 'image') }}</span>
                  </div>
                  <div v-if="getNavList(historyModalNavigation.imageList, 'image').length === 0" class="navigation-item-empty">
                    {{ navSearchKeyword ? '无匹配结果' : '暂无数据' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 左调节柄 -->
          <div class="dlg-resize-handle" @mousedown.stop.prevent="startDlgResize('left', $event)"></div>

          <!-- 中间：病例详情 -->
          <div class="history-modal-center" :class="{ 'cart-collapsed': cartCollapsed }">
            <!-- 购物车收起时显示的展开按钮 -->
            <div v-if="cartCollapsed" class="cart-expand-btn" @click="toggleCart" title="展开购物车">
              <i class="el-icon-d-arrow-left"></i>
              <span>购物车</span>
            </div>
            <div v-if="historyModalDetail" class="detail-content">
              <div class="detail-header">
                <h3>{{ historyModalDetail.displayName || historyModalDetail.type || '病历详情' }}</h3>
                <!-- 录音记录：根据识别状态切换按钮 -->
                <template v-if="historyModalDetail.type === '录音记录'">
                  <!-- 0/1 识别中：不展示按钮 -->
                  <span v-if="getRecordingUiState(historyModalDetail) === 'recognizing'" class="status-text">
                    识别中...
                  </span>
                  <!-- 3 识别失败：显示“重新识别” -->
                  <el-button
                    v-else-if="getRecordingUiState(historyModalDetail) === 'failed'"
                    type="primary"
                    size="small"
                    @click="handleRecordingReIdentify(historyModalDetail)"
                  >
                    重新识别
                  </el-button>
                  <!-- 2 成功：正常加入购物车 -->
                  <el-button
                    v-else-if="getRecordingUiState(historyModalDetail) === 'success'"
                    type="primary"
                    size="small"
                    @click="addToCart(historyModalDetail)"
                    icon="el-icon-shopping-cart-full"
                  >
                    加入购物车
                  </el-button>
                </template>

                <!-- 图片记录：根据识别状态切换按钮 -->
                <template v-else-if="historyModalDetail.type === '图片记录'">
                  <!-- 0/1 识别中：不展示按钮，只显示状态 -->
                  <span
                    v-if="historyModalDetail.ocrStatus === 0 || historyModalDetail.ocrStatus === 1"
                    class="status-text"
                  >
                    识别中...
                  </span>
                  <!-- 2 识别成功：正常加入购物车 -->
                  <el-button
                    v-else-if="historyModalDetail.ocrStatus === 2"
                    type="primary"
                    size="small"
                    @click="addToCart(historyModalDetail)"
                    icon="el-icon-shopping-cart-full"
                  >
                    加入购物车
                  </el-button>
                  <!-- 3 识别失败：显示“重新识别” -->
                  <el-button
                    v-else-if="historyModalDetail.ocrStatus === 3"
                    type="primary"
                    size="small"
                    @click="handleReIdentify(historyModalDetail)"
                  >
                    重新识别
                  </el-button>
                </template>

                <!-- 其他类型：一律加入购物车 -->
                <template v-else>
                  <el-button
                    type="primary"
                    size="small"
                    @click="addToCart(historyModalDetail)"
                    icon="el-icon-shopping-cart-full"
                  >
                    加入购物车
                  </el-button>
                </template>
              </div>
              <div class="detail-body">
                <!-- 录音记录特殊处理：显示录音播放器和内容 -->
                <template v-if="historyModalDetail.type === '录音记录'">
                  <!-- 识别状态提示 -->
                  <div class="detail-field" v-if="getRecordingUiState(historyModalDetail) === 'recognizing'">
                    <div class="field-label">识别状态：</div>
                    <div class="field-value">识别中，请稍后在历史病历中刷新查看结果。</div>
                  </div>
                  <div class="detail-field" v-else-if="getRecordingUiState(historyModalDetail) === 'failed'">
                    <div class="field-label">识别状态：</div>
                    <div class="field-value">识别失败，请点击右上角“重新识别”按钮重试。</div>
                  </div>
                  <!-- 识别成功：录音播放（无文件时占位，不可播放） -->
                  <div
                    v-if="getRecordingUiState(historyModalDetail) === 'success'"
                    class="detail-field recording-player"
                  >
                    <div class="field-label">录音播放：</div>
                    <div class="field-value">
                      <audio
                        v-if="hasPlayableRecordingAudio(historyModalDetail)"
                        :src="getAudioUrl(historyModalDetail.localAudioFilePath || historyModalDetail.audioFilePath)"
                        controls
                        style="width: 100%;"
                        class="recording-audio-player"
                      ></audio>
                      <audio
                        v-else
                        controls
                        disabled
                        style="width: 100%;"
                        class="recording-audio-player recording-audio-placeholder"
                      ></audio>
                    </div>
                  </div>
                  <!-- 录音内容（识别成功且有文本时展示） -->
                  <div
                    v-if="getRecordingUiState(historyModalDetail) === 'success' && getRecordingContentText(historyModalDetail)"
                    class="detail-field recording-content"
                  >
                    <div class="field-label">录音内容：</div>
                    <div class="field-value recording-text">{{ getRecordingContentText(historyModalDetail) }}</div>
                  </div>
                </template>
                <!-- 图片记录特殊处理：显示图片和OCR内容 -->
                <template v-else-if="historyModalDetail.type === '图片记录'">
                  <!-- 识别中：不展示图片预览和内容，仅提示 -->
                  <template v-if="historyModalDetail.ocrStatus === 0 || historyModalDetail.ocrStatus === 1">
                    <div class="detail-field">
                      <div class="field-label">识别状态：</div>
                      <div class="field-value">识别中，请稍后在历史病历中刷新查看结果。</div>
                    </div>
                  </template>
                  <!-- 识别失败：不展示图片预览，仅提示 -->
                  <template v-else-if="historyModalDetail.ocrStatus === 3">
                    <div class="detail-field">
                      <div class="field-label">识别状态：</div>
                      <div class="field-value">识别失败，请点击右上角“重新识别”按钮重试。</div>
                    </div>
                  </template>
                  <!-- 识别成功：正常展示图片和OCR内容 -->
                  <template v-else>
                    <!-- 图片预览 -->
                    <div v-if="historyModalDetail.pcImagePath || historyModalDetail.localImagePath || historyModalDetail.imageUrl" class="detail-field image-preview">
                      <div class="field-label">图片预览：</div>
                      <div class="field-value">
                        <img :src="getImageUrl(historyModalDetail.pcImagePath || historyModalDetail.localImagePath || historyModalDetail.imageUrl)" alt="图片" class="preview-image" />
                      </div>
                    </div>
                    <!-- OCR识别内容 -->
                    <div v-if="historyModalDetail.content" class="detail-field ocr-content">
                      <div class="field-label">OCR识别内容：</div>
                      <div class="field-value" v-html="formatOcrContent(historyModalDetail.content)"></div>
                    </div>
                    <!-- 其他字段（排除 content 本身） -->
                    <div
                      v-for="(field, index) in historyModalDetail.fields"
                      :key="index"
                      class="detail-field"
                      v-if="field.key !== 'content'"
                    >
                      <div class="field-label">{{ field.label }}：</div>
                      <div class="field-value">{{ field.value || '-' }}</div>
                    </div>
                  </template>
                </template>
                <!-- 其他类型正常显示 -->
                <template v-else>
                  <div v-for="(field, index) in historyModalDetail.fields" :key="index" class="detail-field">
                    <div class="field-label">{{ field.label }}：</div>
                    <div class="field-value">{{ field.value || '-' }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div v-else class="detail-empty">
              <i class="el-icon-document"></i>
              <div class="empty-text">请从左侧选择病历记录</div>
            </div>
          </div>

          <!-- 右调节柄（购物车展开时才显示） -->
          <div v-if="!cartCollapsed" class="dlg-resize-handle" @mousedown.stop.prevent="startDlgResize('right', $event)"></div>

          <!-- 右侧：购物车 -->
          <div class="history-modal-right" :class="{ 'collapsed': cartCollapsed }" :style="cartCollapsed ? {} : { width: dlgRightWidth + 'px' }">
            <div class="cart-header">
              <h4>购物车</h4>
              <el-button
                type="text"
                :icon="cartCollapsed ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
                @click="toggleCart"
                class="cart-toggle-btn"
                title="收起/展开"
              ></el-button>
            </div>
            <div v-show="!cartCollapsed" class="cart-body">
              <div v-if="referenceCart.length > 0" class="cart-list">
                <div
                  v-for="(item, index) in referenceCart"
                  :key="index"
                  class="cart-item"
                >
                  <div class="cart-item-content">
                    <div class="cart-item-line1">
                      {{ item.type || item.pageName || '病历记录' }}->{{ item.title || (formatDateForHistory(item.time) + (item.pageName || '')) }}
                    </div>
                    <div class="cart-item-line2">
                      {{ formatCartCreateTime(item.createTime || item.time) }}
                    </div>
                  </div>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="removeFromCart(index)"
                    class="cart-item-delete"
                    :disabled="generateDocumentLoading"
                  ></el-button>
                </div>
              </div>
              <div v-else class="cart-empty">
                <i class="el-icon-shopping-cart-2"></i>
                <div class="empty-text">购物车为空</div>
              </div>
            </div>
            <div v-show="!cartCollapsed" class="cart-footer">
              <!-- 附加信息输入框 -->
              <div class="cart-attach-input">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="attachContent"
                  placeholder="请输入需要附加在病历中的说明（可选）"
                />
              </div>
              <!-- 病历模板 -->
              <div class="cart-template-select" v-loading="templateOptionsLoading">
                <div class="cart-template-label-row">
                  <span class="cart-template-label">病历模板</span>
                  <a
                    href="javascript:;"
                    class="cart-template-preview-link"
                    :class="{ 'is-disabled': !canPreviewTemplate || templatePreviewLoading }"
                    @click.prevent="previewSelectedTemplate"
                  >
                    <i v-if="templatePreviewLoading" class="el-icon-loading"></i>
                    <span v-else>预览</span>
                  </a>
                </div>
                <el-select
                  v-model="selectedTemplateId"
                  placeholder="请选择模板"
                  style="width: 100%;"
                  size="small"
                  :disabled="generateDocumentLoading"
                  @change="onDocumentTemplateChange"
                >
                  <el-option
                    v-for="opt in documentTemplateOptions"
                    :key="`${opt.itemType}-${opt.id}`"
                    :label="opt.templateName"
                    :value="opt.id"
                  />
                </el-select>
              </div>
              <el-button
                type="primary"
                :disabled="!canGenerateDocument"
                :loading="generateDocumentLoading"
                @click="generateDocument"
                style="width: 100%;"
              >
                生成病历
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 模板预览弹窗 -->
    <el-dialog
      title="模板预览"
      :visible.sync="templatePreviewVisible"
      width="640px"
      append-to-body
      class="template-preview-dialog"
    >
      <div
        v-loading="templatePreviewLoading"
        class="template-preview-content"
      >{{ templatePreviewText || '暂无预览内容' }}</div>
    </el-dialog>
  </div>
</template>

<script>
import consultationControlClass from "@/components/consultationControl_class";
import ChatBoxDoctor from "@/components/chatBox_doctor";
import SoundRecording from "@/components/soundRecording/index.vue";
import { request } from "@/utils/request";
import { mapState } from "vuex";
import { sendMessageLy, createConversationLy } from "@/services/conversation/index";
import { commonRecord } from "@/view/management/aiService/consultationControl/data";
import { BASE_URL } from "@/config";

// 导入子组件
import AdmissionRecord from "./components/AdmissionRecord.vue";
import ProgressRecord from "./components/ProgressRecord.vue";
import DischargeRecord from "./components/DischargeRecord.vue";
import PhysicalExam from "./components/PhysicalExam.vue";

/** generateDocument 返回的 record 字段中文名补充 */
const GENERATE_RECORD_LABELS = {
  content: '内容',
  vital_signs: '生命体征',
  auxiliary_examination: '辅助检查',
  general_examination: '一般检查',
  specialized_examination: '专科检查',
  maternal_pregnancy_history: '孕产史',
  gpal_history: 'GPAL史'
};

const formatDateTime = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  // 与后端日期格式保持一致，使用到秒：yyyy-MM-dd HH:mm:ss
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const createEmptyProgressFields = (noteTime = '') => ([
  { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null },
  // 移除 title 字段，病程记录不需要标题
  { key: 'content', label: '内容', value: '', suggestedValue: null }
]);

const createEmptyProgressData = () => {
  const noteTime = formatDateTime();
  return {
    noteTime,
    // 移除 title 字段
    content: '',
    fields: createEmptyProgressFields(noteTime)
  };
};

const createEmptyPhysicalFields = () => ([
  { key: 'temperatureC', label: '体温(℃)', value: '', suggestedValue: null },
  { key: 'pulseBpm', label: '脉搏(次/分)', value: '', suggestedValue: null },
  { key: 'respirationBpm', label: '呼吸(次/分)', value: '', suggestedValue: null },
  { key: 'bloodPressure', label: '血压', value: '', suggestedValue: null },
  { key: 'heightCm', label: '身高(cm)', value: '', suggestedValue: null },
  { key: 'weightKg', label: '体重(kg)', value: '', suggestedValue: null },
  { key: 'description', label: '描述', value: '', suggestedValue: null }
]);

const createEmptyPhysicalExamData = () => ({
  temperature: '',
  pulse: '',
  respiration: '',
  bloodPressure: '',
  height: '',
  weight: '',
  description: '',
  fields: createEmptyPhysicalFields()
});

export default {
  name: 'InpatientRecord',
  components: {
    consultationControlClass,
    ChatBoxDoctor,
    SoundRecording,
    AdmissionRecord,
    ProgressRecord,
    PhysicalExam,
    DischargeRecord
  },
  async mounted() {
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
    // 清除防抖定时器
    if (this.saveDebounceTimer) {
      clearTimeout(this.saveDebounceTimer);
      this.saveDebounceTimer = null;
    }
  },
  data() {
    return {
      // 面板宽度
      leftPanelWidth: 400,
      rightPanelWidth: 400,
      isResizing: false,
      resizeType: null,
      startX: 0,
      startLeftWidth: 0,
      startRightWidth: 0,

      // 历史病历弹层三栏宽度（与主面板完全独立）
      dlgLeftWidth: 380,
      dlgRightWidth: 280,

      // 患者数据
      classData: [],
      itemCacheChatData: {},

      // Tab相关
      activeTab: 'admission',
      availableTabs: [], // 动态从接口加载，不再写死
      lastLoadedDepartmentId: null, // 记录上次加载标签的科室ID，避免重复调用

      // 各tab的数据
      admissionData: {
        chiefComplaint: '',
        presentIllness: '',
        pastHistory: ''
      },

      progressRecords: [],
      // 病程记录数据（单个记录，支持编辑）
      progressData: createEmptyProgressData(),
      // 首次病程记录数据
      firstProgressData: createEmptyProgressData(),
      // 日常病程记录数据
      dailyProgressData: createEmptyProgressData(),
      // 上级医师查房记录数据
      doctorProgressData: createEmptyProgressData(),

      physicalExamData: createEmptyPhysicalExamData(),

      dischargeData: {
        dischargeTime: '',
        content: '',
        fields: []
      },

      // 聊天相关
      chatData_doctor: [],
      selectedTemplateName: '通用模板',
      recordingState: {
        isRecording: false,
        duration: 0
      },

      // 录音相关文本及弹窗（用于重新提取内容）
      audioMessage: '',        // 原始录音转写文本
      extractedMessage: '',    // 优化/提取后的文本
      dialogFormVisible: false, // 录音内容弹窗
      currentAudioFilePath: '', // 当前音频文件路径（用于播放）
      audioRetryLoading: false, // 重新上传音频加载状态
      extractLoading: false,    // 重新提取加载状态
      recordingApplyLoading: false, // 录音"引用到病历"加载状态
      recordingSubmitLoading: false, // 录音"全部接受并提交HIS"加载状态

      // 状态
      isSaving: false,
      hisSub: false,
      hisSubmitLoading: false,
      historyVisible: false,
      clearVisible: false,
      // 操作记录（中间区域的记录列表）
      historyData: [],
      // 当前选中的历史记录项
      selectedHistoryItem: null,
      // 病历历史确认弹窗
      medicalHistoryConfirmVisible: false,
      // 历史记录详情数据（主区域使用）
      historyDetailData: {},
      // 弹层独立的数据变量（用于操作记录弹层，与主病历区域隔离）
      historyDialogDetailData: {},
      // 正在加载的历史记录详情ID（用于防止重复加载）
      loadingHistoryDetailId: null,
      // 保存防抖定时器
      saveDebounceTimer: null,
      // 跟踪每个标签的数据是否被修改过（用于切换标签时判断是否需要保存）
      tabModifiedFlags: {
        admission: false,
        progress: false,
        first_progress: false,
        daily_progress: false,
        doctor_progress: false,
        physical: false,
        discharge: false
      },
      // 历史病历弹窗相关
      historyModalVisible: false,
      historyModalDepartments: [],
      historyModalVisitNumbers: [],
      selectedDepartment: null,
      selectedVisitNum: null,
      historyModalNavigation: {
        activeTab: 'outpatient',
        outpatientList: [],      // 门诊病历
        admissionList: [],        // 入院记录
        firstProgressList: [],    // 首次病程记录
        dailyProgressList: [],    // 日常病程记录
        doctorProgressList: [],   // 上级医师查房记录
        dischargeList: [],        // 出院记录
        testList: [],             // 检验报告
        recordingList: [],        // 录音记录
        imageList: []             // 图片记录
      },
      historyModalCategories: {
        outpatient: { expanded: true },
        admission: { expanded: true },
        firstProgress: { expanded: false },
        dailyProgress: { expanded: false },
        doctorProgress: { expanded: false },
        discharge: { expanded: false },
        test: { expanded: false },
        recording: { expanded: false },
        image: { expanded: false }
      },
      historyModalDetail: null,
      referenceCart: [], // 购物车数据
      cartCollapsed: false, // 购物车是否收起
      generateDocumentLoading: false, // 生成病历加载状态
      navSearchKeyword: '', // 导航搜索关键词
      navSortOrder: 'desc', // 导航排序：desc=最新在前，asc=最旧在前
      // 历史病历来源筛选：HIS / 本地（默认都勾选）
      historySourceHisChecked: true,
      historySourceLocalChecked: true,
      // 生成病历时的附加说明内容
      attachContent: '',
      // 生成病历模板选项
      documentTemplateOptions: [],
      selectedTemplateId: '',
      templateOptionsLoading: false,
      templatePreviewVisible: false,
      templatePreviewText: '',
      templatePreviewLoading: false,
      // 录音详情轮询相关
      recordingDetailPollTimer: null,
      recordingDetailPollId: null,
      recordingDetailPollCount: 0,
      recordingDetailPollMax: 10,
      // 切换患者的请求版本号，避免旧请求回写新患者数据
      patientSwitchToken: 0
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    currentChatGroup() {
      const map = {
        admission: 1,
        first_progress: 2, // 首次病程，chatGroup = 2，dataOrigin = 2
        daily_progress: 3, // 日常病程，chatGroup = 3，dataOrigin = 3
        doctor_progress: 4, // 上级医师查房记录，chatGroup = 4，dataOrigin = 4
        physical: 6,
        discharge: 5
      };
      return map[this.activeTab] || 1;
    },
    // 检查是否有AI建议
    hasSuggestions() {
      let fields = [];
      if (this.activeTab === 'admission') {
        fields = this.admissionData.fields || [];
      } else if (this.activeTab === 'progress') {
        fields = this.progressData.fields || [];
      } else if (this.activeTab === 'first_progress') {
        fields = this.firstProgressData.fields || [];
      } else if (this.activeTab === 'daily_progress') {
        fields = this.dailyProgressData.fields || [];
      } else if (this.activeTab === 'doctor_progress') {
        fields = this.doctorProgressData.fields || [];
      } else if (this.activeTab === 'physical') {
        fields = this.physicalExamData.fields || [];
      } else if (this.activeTab === 'discharge') {
        fields = this.dischargeData.fields || [];
      }
      return fields.some(f => {
        const suggestion = Object.prototype.hasOwnProperty.call(f, 'isEdit_newValue')
          ? f.isEdit_newValue
          : f.suggestedValue;
        return suggestion && suggestion !== '未提供';
      });
    },
    /** 当前住院标签对应的 medicalType（与 chatGroup 一致） */
    currentMedicalType() {
      return String(this.currentChatGroup);
    },
    selectedDocumentTemplate() {
      if (!this.selectedTemplateId || !this.documentTemplateOptions.length) {
        return null;
      }
      return this.documentTemplateOptions.find((opt) => opt.id === this.selectedTemplateId) || null;
    },
    canPreviewTemplate() {
      const opt = this.selectedDocumentTemplate;
      return !!(opt && opt.itemType && opt.itemType !== 'UNUSED');
    },
    /** 生成病历：已选有效模板或购物车有材料时可点击 */
    canGenerateDocument() {
      if (this.generateDocumentLoading) {
        return false;
      }
      return this.referenceCart.length > 0 || this.canPreviewTemplate;
    }
  },
  watch: {
    historyModalVisible(val) {
      if (!val) {
        this.navSearchKeyword = '';
        this.documentTemplateOptions = [];
        this.selectedTemplateId = '';
        this.templatePreviewVisible = false;
        this.templatePreviewText = '';
        // 关闭弹窗时停止录音详情轮询
        this.stopRecordingDetailPolling && this.stopRecordingDetailPolling();
      }
    }
  },
  methods: {
    getCurrentTabRefName() {
      const refNameMap = {
        admission: "admissionRecord",
        progress: "progressRecord",
        first_progress: "firstProgressRecord",
        daily_progress: "dailyProgressRecord",
        doctor_progress: "doctorProgressRecord",
        discharge: "dischargeRecord",
        physical: "physicalExam"
      };
      return refNameMap[this.activeTab] || "";
    },
    getRefInstance(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    async copyCurrentTabContent() {
      const refName = this.getCurrentTabRefName();
      const instance = refName ? this.getRefInstance(refName) : null;
      if (!instance || typeof instance.getCopyLines !== "function") {
        this.$message.warning("当前页面暂无可复制内容");
        return;
      }
      const lines = instance.getCopyLines();
      if (!Array.isArray(lines) || lines.length === 0) {
        this.$message.warning("当前页面暂无可复制内容");
        return;
      }
      const copyText = lines.join("\n");
      try {
        await navigator.clipboard.writeText(copyText);
        this.$message.success("已复制本页内容");
      } catch (error) {
        const textArea = document.createElement("textarea");
        textArea.value = copyText;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.$message.success("已复制本页内容");
      }
    },
    // 子组件回传患者列表与状态
    handleStatusBtn(payload) {
      this.classData = Array.isArray(payload?.patientList) ? payload.patientList : [];
    },
    // ========== 患者列表相关 ==========
    async loadPatientList() {
      // 加载患者列表，由consultationControlClass组件处理
      // 这里可以触发子组件的刷新
      if (this.$refs.chatClass) {
        this.$refs.chatClass.refreshData();
      }
    },

    getFirstAvailableTabName() {
      if (Array.isArray(this.availableTabs) && this.availableTabs.length > 0) {
        return this.availableTabs[0].name;
      }
      return 'admission';
    },

    isSamePatient(a, b) {
      if (a === null || a === undefined || b === null || b === undefined) {
        return false;
      }
      return String(a) === String(b);
    },

    resetTabModifiedFlags() {
      this.tabModifiedFlags = {
        admission: false,
        progress: false,
        first_progress: false,
        daily_progress: false,
        doctor_progress: false,
        physical: false,
        discharge: false
      };
    },

    resetAllMedicalTabData() {
      this.admissionData = {
        chiefComplaint: '',
        presentIllness: '',
        pastHistory: '',
        fields: []
      };
      this.progressData = createEmptyProgressData();
      this.firstProgressData = createEmptyProgressData();
      this.dailyProgressData = createEmptyProgressData();
      this.doctorProgressData = createEmptyProgressData();
      this.physicalExamData = createEmptyPhysicalExamData();
      this.dischargeData = {
        dischargeTime: '',
        content: '',
        fields: []
      };
      this.resetTabModifiedFlags();
    },

    async handlePatientSelect(item) {
      const switchToken = ++this.patientSwitchToken;
      const isCurrentSwitch = () => switchToken === this.patientSwitchToken;

      // ========== 切换患者：清空与患者强绑定的缓存，避免跨患者残留 ==========
      // 1) 历史病历弹窗与购物车
      this.referenceCart = [];
      this.cartCollapsed = false;
      this.historyModalDetail = null;
      this.historyModalVisible = false;
      this.historyModalDepartments = [];
      this.historyModalVisitNumbers = [];
      this.selectedDepartment = null;
      this.selectedVisitNum = null;
      if (this.historyModalNavigation) {
        this.historyModalNavigation = {
          activeTab: 'outpatient',
          outpatientList: [],
          admissionList: [],
          firstProgressList: [],
          dailyProgressList: [],
          doctorProgressList: [],
          dischargeList: [],
          testList: [],
          recordingList: [],
          imageList: []
        };
      }

      // 2) 顶部“操作记录”下拉也顺带关闭，避免 UI 悬挂
      this.historyVisible = false;
      this.selectedHistoryItem = null;

      // 切换患者时强制回到首个标签，避免停留在上一个患者的标签页
      this.activeTab = this.getFirstAvailableTabName();
      // 切换患者时，清空所有病历tab数据和修改状态，避免跨患者残留
      this.resetAllMedicalTabData();
      this.chatData_doctor = [];

      this.itemCacheChatData = item;
      console.log('点击左边患者列表,加载数据', item);

      // 加载标签列表（如果科室ID变化了才重新加载，避免重复调用）
      const currentDepartmentId = this.itemCacheChatData?.departmentId;
      if (currentDepartmentId && currentDepartmentId !== this.lastLoadedDepartmentId) {
        await this.loadTabs();
        if (!isCurrentSwitch()) return;
        this.lastLoadedDepartmentId = currentDepartmentId;
      }
      // 患者切换后，无论科室是否变化，都定位到该患者可用标签中的第一个
      this.activeTab = this.getFirstAvailableTabName();

      // 判断是否需要创建会话
      if (!this.itemCacheChatData?.chatId) {
        try {
          console.log('chatId为空，需要创建会话');
          const result = await createConversationLy({
            medmstrId: this.itemCacheChatData?.id,
            professionalId: localStorage.getItem('userId') || this.userInfo?.id,
            departmentId: this.itemCacheChatData?.departmentId || '',
            dataOrigin: '2', // 住院病历标识
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
            chatGroup: this.currentChatGroup
          });

          if (result.success && result.code === 200) {
            // 同步chatId到itemCacheChatData
            this.itemCacheChatData.chatId = result.result.chatId;

            // 同时更新classData中对应患者的chatId，确保子组件数据同步
            const patientIndex = this.classData.findIndex(patient => patient.id === this.itemCacheChatData.id);
            if (patientIndex !== -1) {
              this.$set(this.classData[patientIndex], 'chatId', result.result.chatId);
            }

            console.log('会话创建成功，chatId:', result.result.chatId);

            // 创建会话后，加载历史记录列表
            await this.loadHistoryList(item?.id);
            if (!isCurrentSwitch()) return;
            // 同时加载最新入院记录详情（只触发一次 pageNum=1,pageSize=1）
            await this.loadLatestAdmissionDetail();
            if (!isCurrentSwitch()) return;
            // 新创建的会话没有聊天记录，所以不需要加载会话详情
            this.chatData_doctor = [];
          } else {
            this.$message.error(result.message || "创建会话失败");
            return;
          }
        } catch (error) {
          console.error("创建会话失败：", error);
          this.$message.error("创建会话失败，请重试");
          return;
        }
      } else {
        // chatId不为空，调用所有相关接口
        console.log('chatId已存在，调用相关接口');
        // 1) 操作记录列表（pageNum=1,pageSize=20）
        await this.loadHistoryList(item?.id);
        if (!isCurrentSwitch()) return;
        // 2) 最新入院记录详情（pageNum=1,pageSize=1）
        await this.loadLatestAdmissionDetail();
        if (!isCurrentSwitch()) return;
        // 3) 会话详情（右侧对话框）
        await this.loadConversationDetail(item?.chatId);
      }
    },

    // 避免与子组件相互触发导致的循环刷新，这里不再调用子组件刷新
    refreshData() {
      // no-op: 子组件已完成刷新和事件通知
    },

    // ========== 数据加载和保存 ==========
    async loadAdmissionDetail(recordId, expectedPatientId = null) {
      if (!recordId) {
        this.admissionData = { chiefComplaint: '', presentIllness: '', pastHistory: '', fields: [] };
        return;
      }
      const patientId = expectedPatientId || this.itemCacheChatData?.id;
      try {
        // 如果在历史病历弹窗中调用，使用 selectedDepartment；否则使用 itemCacheChatData?.departmentId
        const departmentId = this.selectedDepartment || this.itemCacheChatData?.departmentId || '';
        const res = await request({
          url: '/ly/archive/history/detail',
          method: 'POST',
          data: {
            recordId,
            departmentId,
            // 住院：按当前Tab传 chatGroup（入院=1）
            chatGroup: this.currentChatGroup
          }
        });
        if (patientId && !this.isSamePatient(patientId, this.itemCacheChatData?.id)) {
          return;
        }
        if (res.success && res.result) {
          const result = res.result || {};
          // 优先从 medicalDetail 中读取，如果没有则从 fields 中读取
          const medicalDetail = result.medicalDetail || {};
          const fields = result.fields || [];

          // 如果 fields 有数据，优先使用 fields
          if (fields.length > 0) {
            const fieldMap = {};
            fields.forEach(f => {
              if (f.key && f.value) {
                fieldMap[f.key] = f.value;
              }
            });
            // 合并 fields 和 medicalDetail，支持引用推荐
            this.admissionData = {
              chiefComplaint: fieldMap.chiefComplaint || medicalDetail.chiefComplaint || '',
              presentIllness: fieldMap.presentIllness || medicalDetail.presentIllness || '',
              pastHistory: fieldMap.pastHistory || medicalDetail.pastHistory || '',
              // 保存 fields 用于引用推荐（包含 suggestedValue）
              fields: fields.map(f => ({
                key: f.key,
                label: f.label,
                value: f.value || '',
                suggestedValue: f.suggestedValue || null
              }))
            };
          } else {
            // 使用 medicalDetail，从模板获取字段格式
            const templateFields = await this.getFieldTemplate(1); // 入院记录的 chatGroup 是 1
            if (templateFields.length > 0) {
              // 使用模板字段，填充 medicalDetail 的值
              this.admissionData = {
                chiefComplaint: medicalDetail.chiefComplaint || '',
                presentIllness: medicalDetail.presentIllness || '',
                pastHistory: medicalDetail.pastHistory || '',
                fields: templateFields.map(f => ({
                  ...f,
                  value: medicalDetail[f.key] || f.value || '',
                  suggestedValue: null
                }))
              };
            } else {
              // 如果模板为空，保持 fields 为空数组，避免显示默认字段导致闪现
              // 后续如果需要显示字段，会在其他地方（如 mergeSuggestionsToAdmission）加载模板
              this.admissionData = {
                chiefComplaint: medicalDetail.chiefComplaint || '',
                presentIllness: medicalDetail.presentIllness || '',
                pastHistory: medicalDetail.pastHistory || '',
                fields: [] // 保持为空，不显示默认字段
              };
            }
          }
        } else {
          this.admissionData = { chiefComplaint: '', presentIllness: '', pastHistory: '', fields: [] };
        }
      } catch (e) {
        console.error('加载入院记录详情失败:', e);
        if (patientId && !this.isSamePatient(patientId, this.itemCacheChatData?.id)) {
          return;
        }
        this.admissionData = { chiefComplaint: '', presentIllness: '', pastHistory: '', fields: [] };
      }
    },

    /* 加载病程记录详情 */
    async loadProgressDetail(recordId) {
      if (!recordId) {
        // 根据当前标签设置对应的空数据
        if (this.activeTab === 'first_progress') {
          this.firstProgressData = createEmptyProgressData();
        } else if (this.activeTab === 'daily_progress') {
          this.dailyProgressData = createEmptyProgressData();
        } else if (this.activeTab === 'doctor_progress') {
          this.doctorProgressData = createEmptyProgressData();
        } else {
          this.progressData = createEmptyProgressData();
        }
        return;
      }

      try {
        // 获取 departmentId 和 chatGroup
        const departmentId = this.itemCacheChatData?.departmentId || '';
        const chatGroup = this.currentChatGroup;

        const resp = await request({
          url: '/ly/lyInpatientCourseNotes/history/detail',
          method: 'POST',
          data: {
            recordId,
            departmentId,
            chatGroup
          }
        });

        if (resp && resp.success) {
          const result = resp.result || {};
          // 根据当前标签确定要更新的数据对象
          let targetData;
          if (this.activeTab === 'first_progress') {
            targetData = this.firstProgressData;
          } else if (this.activeTab === 'daily_progress') {
            targetData = this.dailyProgressData;
          } else if (this.activeTab === 'doctor_progress') {
            targetData = this.doctorProgressData;
          } else {
            targetData = this.progressData;
          }

          // 优先使用 fields，否则使用 inpatientCourseDetail
          if (Array.isArray(result.fields) && result.fields.length) {
            const fieldMap = {};
            result.fields.forEach(f => {
              if (f.key && f.value) {
                fieldMap[f.key] = f.value;
              }
            });
            // 合并 fields 和 inpatientCourseDetail，支持引用推荐
            const progressDataObj = {
              noteTime: fieldMap.noteTime || result.inpatientCourseDetail?.noteTime || '',
              // 移除 title 字段
              content: fieldMap.content || result.inpatientCourseDetail?.content || '',
              // 保存 fields 用于引用推荐（包含 suggestedValue），过滤掉 title 字段
              fields: result.fields.filter(f => f.key !== 'title').map(f => ({
                key: f.key,
                label: f.label,
                value: f.value || '',
                suggestedValue: f.suggestedValue || null
              }))
            };
            // 根据当前标签更新对应的数据
            if (this.activeTab === 'first_progress') {
              this.firstProgressData = progressDataObj;
            } else if (this.activeTab === 'daily_progress') {
              this.dailyProgressData = progressDataObj;
            } else if (this.activeTab === 'doctor_progress') {
              this.doctorProgressData = progressDataObj;
            } else {
              this.progressData = progressDataObj;
            }
          } else {
            // 使用 inpatientCourseDetail，转换为 fields 格式
            const detail = result.inpatientCourseDetail || {};
            const progressDataObj = {
              noteTime: detail.noteTime || '',
              // 移除 title 字段
              content: detail.content || '',
              fields: [
                { key: 'noteTime', label: '记录时间', value: detail.noteTime || '', suggestedValue: null },
                // 移除 title 字段
                { key: 'content', label: '内容', value: detail.content || '', suggestedValue: null }
              ]
            };
            // 根据当前标签更新对应的数据
            if (this.activeTab === 'first_progress') {
              this.firstProgressData = progressDataObj;
            } else if (this.activeTab === 'daily_progress') {
              this.dailyProgressData = progressDataObj;
            } else if (this.activeTab === 'doctor_progress') {
              this.doctorProgressData = progressDataObj;
            } else {
              this.progressData = progressDataObj;
            }
          }
        } else {
          this.progressData = createEmptyProgressData();
        }
      } catch (error) {
        console.error('加载病程记录详情失败:', error);
        this.progressData = createEmptyProgressData();
      }
    },

    /* 加载体格检查详情（通过 recordId） */
    async loadPhysicalDetailById(recordId) {
      if (!recordId) {
        this.physicalExamData = createEmptyPhysicalExamData();
        return;
      }

      try {
        const resp = await request({
          url: '/ly/lyPhysicalExam/history/detail',
          method: 'POST',
          data: { recordId }
        });

        if (resp && resp.success) {
          const result = resp.result || {};
          // 优先使用 fields，否则使用 physicalExamItem
          if (Array.isArray(result.fields) && result.fields.length) {
            const fieldMap = {};
            result.fields.forEach(f => {
              if (f.key && f.value) {
                fieldMap[f.key] = f.value;
              }
            });
            const item = result.physicalExamItem || {};
            // 合并 fields 和 physicalExamItem，支持引用推荐
            this.physicalExamData = {
              temperature: fieldMap.temperatureC || item.temperatureC || '',
              pulse: fieldMap.pulseBpm || item.pulseBpm || '',
              respiration: fieldMap.respirationBpm || item.respirationBpm || '',
              bloodPressure: fieldMap.bloodPressure || item.bloodPressure || '',
              height: fieldMap.heightCm || item.heightCm || '',
              weight: fieldMap.weightKg || item.weightKg || '',
              description: fieldMap.description || item.description || '',
              // 保存 fields 用于引用推荐（包含 suggestedValue）
              fields: result.fields.map(f => ({
                key: f.key,
                label: f.label,
                value: f.value || '',
                suggestedValue: f.suggestedValue || null
              }))
            };
          } else {
            // 使用 physicalExamItem，转换为 fields 格式
            const item = result.physicalExamItem || {};
            this.physicalExamData = {
              temperature: item.temperatureC || '',
              pulse: item.pulseBpm || '',
              respiration: item.respirationBpm || '',
              bloodPressure: item.bloodPressure || '',
              height: item.heightCm || '',
              weight: item.weightKg || '',
              description: item.description || '',
              fields: [
                { key: 'temperatureC', label: '体温(℃)', value: item.temperatureC || '', suggestedValue: null },
                { key: 'pulseBpm', label: '脉搏(次/分)', value: item.pulseBpm || '', suggestedValue: null },
                { key: 'respirationBpm', label: '呼吸(次/分)', value: item.respirationBpm || '', suggestedValue: null },
                { key: 'bloodPressure', label: '血压', value: item.bloodPressure || '', suggestedValue: null },
                { key: 'heightCm', label: '身高(cm)', value: item.heightCm || '', suggestedValue: null },
                { key: 'weightKg', label: '体重(kg)', value: item.weightKg || '', suggestedValue: null },
                { key: 'description', label: '描述', value: item.description || '', suggestedValue: null }
              ]
            };
          }
        } else {
          this.physicalExamData = createEmptyPhysicalExamData();
        }
      } catch (error) {
        console.error('加载体格检查详情失败:', error);
        this.physicalExamData = createEmptyPhysicalExamData();
      }
    },

    async loadHistoryList(medmstrId) {
      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        const resp = await request({
          url: '/ly/archive/history',
          method: 'POST',
          data: {
            medmstrId,
            onlyMine: true,
            professionalId: userId,
            pageNum: 1,
            pageSize: 20,
            medicalSource: 1,
            dataOrigin: '2',
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          }
        });
        if (!this.isSamePatient(medmstrId, this.itemCacheChatData?.id)) {
          return;
        }
        this.historyData = Array.isArray(resp?.result) ? resp.result : [];
      } catch (e) {
        if (!this.isSamePatient(medmstrId, this.itemCacheChatData?.id)) {
          return;
        }
        this.historyData = [];
        this.admissionData = { chiefComplaint: '', presentIllness: '', pastHistory: '' };
      }
    },

    /* 仅加载病历历史列表（用于操作记录按钮，根据当前标签页调用不同接口） */
    async loadHistoryListOnly() {
      if (!this.itemCacheChatData?.id) {
        this.historyData = [];
        return;
      }

      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        let resp;

        // 根据当前标签页调用不同的接口
        if (this.activeTab === 'admission') {
          // 入院记录：调用 /ly/archive/history
          resp = await request({
            url: '/ly/archive/history',
            method: 'POST',
            data: {
              medmstrId: this.itemCacheChatData.id,
              onlyMine: true,
              professionalId: userId,
              pageNum: 1,
              pageSize: 20,
              dataOrigin: '2',
              visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
            }
          });
        } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
          // 病程记录：调用 /ly/lyInpatientCourseNotes/history
          // 根据不同的病程类型设置 dataOrigin：首次病程=2，日常病程=2，上级医师查房记录=4
          let dataOrigin = '2'; // 默认值
          if (this.activeTab === 'doctor_progress') {
            dataOrigin = '4';
          } else if (this.activeTab === 'daily_progress'){
            dataOrigin = '3'; // first_progress 和 progress 都是 2
          }

          resp = await request({
            url: '/ly/lyInpatientCourseNotes/history',
            method: 'POST',
            data: {
              medmstrId: this.itemCacheChatData.id,
              professionalId: userId,
              pageNum: 1,
              pageSize: 20,
              dataOrigin: dataOrigin,
              visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
            }
          });
        } else if (this.activeTab === 'physical') {
          // 体格检查：调用 /ly/lyPhysicalExam/history
          resp = await request({
            url: '/ly/lyPhysicalExam/history',
            method: 'POST',
            data: {
              medmstrId: this.itemCacheChatData.id,
              professionalId: userId,
              pageNum: 1,
              pageSize: 20
            }
          });
        } else if (this.activeTab === 'discharge') {
          // 出院记录：调用 /ly/lyInpatientDischargeNotes/history
          resp = await request({
            url: '/ly/lyInpatientDischargeNotes/history',
            method: 'POST',
            data: {
              medmstrId: this.itemCacheChatData.id,
              professionalId: userId,
              pageNum: 1,
              pageSize: 20,
              visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
            }
          });
        } else {
          this.historyData = [];
          return;
        }

        if (resp && resp.success && Array.isArray(resp.result)) {
          this.historyData = resp.result;
        } else {
          this.historyData = [];
        }
      } catch (error) {
        console.error('加载病历历史失败:', error);
        this.historyData = [];
      }
    },

    // 操作记录 Popover 打开时的统一入口：先加载数据，再刷新 Popper 定位
    async onHistoryPopoverShow() {
      await this.loadHistoryListOnly();
      this.$nextTick(() => {
        const pop = this.$refs.historyPopover;
        if (pop && typeof pop.updatePopper === 'function') {
          pop.updatePopper();
        }
      });
    },

    /* 获取历史记录的日期（根据标签页不同，字段不同） */
    getHistoryDate(item) {
      if (!item) return '未知日期';

      if (this.activeTab === 'admission') {
        // 入院记录：使用 visitDate
        return this.formatDate(item.visitDate);
      } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
        // 病程记录：使用 noteTime，直接显示完整时间，不格式化（因为有多条记录需要区分）
        return item.noteTime || '未知日期';
      } else if (this.activeTab === 'physical') {
        // 体格检查：使用 recordTime
        return this.formatDate(item.recordTime);
      } else if (this.activeTab === 'discharge') {
        // 出院记录：使用 dischargeTime
        return this.formatDate(item.dischargeTime);
      }
      return '未知日期';
    },

    /* 获取历史记录的内容（根据标签页不同，字段不同） */
    getHistoryContent(item) {
      if (!item) return '无内容';

      if (this.activeTab === 'admission') {
        // 入院记录：使用 primaryDiagnosis 或诊断信息
        const text = item.primaryDiagnosis || '病历记录';
        return text.length > 20 ? text.substring(0, 20) + '...' : text;
      } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
        // 病程记录：使用 content（不再使用 title）
        const text = item.content || '病程记录';
        return text.length > 20 ? text.substring(0, 20) + '...' : text;
      } else if (this.activeTab === 'physical') {
        // 体格检查：使用 description
        const text = item.description || '体格检查记录';
        return text.length > 20 ? text.substring(0, 20) + '...' : text;
      } else if (this.activeTab === 'discharge') {
        // 出院记录：使用 content（主诉）
        const text = item.content || '出院记录';
        return text.length > 20 ? text.substring(0, 20) + '...' : text;
      }
      return '无内容';
    },

    /* 格式化日期 */
    formatDate(dateString) {
      if (!dateString) return '未知日期';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    /* 判断是否为日期字段 */
    isDateField(key) {
      return ['admission_time', 'discharge_time'].includes(key);
    },

    /* 选择历史记录项 - 打开详细记录弹窗 */
    selectHistoryItem(item) {
      this.selectedHistoryItem = item;
      this.historyVisible = false; // 关闭下拉菜单
      this.medicalHistoryConfirmVisible = true; // 显示确认弹窗
      // 不在这里调用详情接口，让 onMedicalHistoryDialogOpen 统一处理
    },

    /* 弹窗打开时，自动展示第一条病历详情 */
    async onMedicalHistoryDialogOpen() {
      // 清空弹层数据
      this.historyDialogDetailData = {};
      // 清空加载标记，避免影响后续加载
      this.loadingHistoryDetailId = null;
      if (this.historyData && this.historyData.length > 0) {
        // 优先使用已选中的项目，否则使用第一条
        const targetItem = this.selectedHistoryItem || this.historyData[0];
        this.selectedHistoryItem = targetItem;
        if (targetItem && targetItem.id) {
          await this.loadHistoryDetail(targetItem.id, true); // 传入 isDialog=true，使用弹层独立变量
        }
      }
    },

    // 获取字段模板（带缓存，按 chatGroup & 科室 & 医生）
    async getFieldTemplate(chatGroup = null) {
      const userId = localStorage.getItem('userId') || this.userInfo?.id;
      const departmentId = this.itemCacheChatData?.departmentId || '';
      const targetChatGroup = chatGroup !== null ? chatGroup : this.currentChatGroup;

      if (!userId) {
        console.warn('未找到医生ID，无法加载字段模板');
        return [];
      }

      try {
        const resp = await request({
          url: '/ly/archive/fields/template',
          method: 'POST',
          data: {
            professionalId: userId,
            departmentId,
            // 住院：按当前Tab传 chatGroup（1入院、2病程、3体格检查）
            chatGroup: targetChatGroup
          }
        });

        if (resp && resp.success) {
          const result = resp.result || {};
          const fields = Array.isArray(result.fields) ? result.fields : [];
          return fields.map(f => {
            // 后端模板中可能使用 note_time 作为键，这里统一转换为前端使用的 noteTime
            if (f.key === 'note_time') {
              return {
                key: 'noteTime',
                label: f.label || '记录时间',
                value: f.value || '',
                suggestedValue: f.suggestedValue || null
              };
            }
            return {
              key: f.key,
              label: f.label,
              value: f.value || '',
              suggestedValue: f.suggestedValue || null
            };
          });
        }
        return [];
      } catch (error) {
        console.error('获取字段模板失败:', error);
        return [];
      }
    },

    // 加载字段模板（住院：按 chatGroup & 科室 & 医生）
    async loadFieldTemplateForCurrentTab() {
      try {
        const fields = await this.getFieldTemplate();
        if (fields.length === 0) {
          return;
        }

        // 所有病程类记录统一：如果模板中包含 key 为 noteTime 的字段，则在新建时强制使用当前时间并置为只读展示
        const nowDateTime = this.getCurrentDateTimeString();
        const withNoteTimeValue = (sourceFields) => sourceFields.map(f => {
          if (f.key === 'noteTime') {
            return {
              ...f,
              value: nowDateTime
            };
          }
          return f;
        });

        if (this.activeTab === 'admission') {
          // 入院：映射到 admissionData.fields
          this.admissionData = {
            chiefComplaint: '',
            presentIllness: '',
            pastHistory: '',
            fields: fields
          };
        } else if (this.activeTab === 'progress') {
          // 病程：映射到 progressData.fields
          const noteTime = nowDateTime;
          this.progressData = {
            noteTime,
            // 移除 title 字段
            content: '',
            fields: fields.length ? withNoteTimeValue(fields) : [
              { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null },
              // 移除 title 字段
              { key: 'content', label: '内容', value: '', suggestedValue: null }
            ]
          };
        } else if (this.activeTab === 'first_progress') {
          // 首次病程：映射到 firstProgressData.fields
          const noteTime = nowDateTime;
          this.firstProgressData = {
            noteTime,
            content: '',
            fields: fields.length ? withNoteTimeValue(fields) : [
              { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null },
              { key: 'content', label: '内容', value: '', suggestedValue: null }
            ]
          };
        } else if (this.activeTab === 'daily_progress') {
          // 日常病程：映射到 dailyProgressData.fields
          const noteTime = nowDateTime;
          this.dailyProgressData = {
            noteTime,
            content: '',
            fields: fields.length ? withNoteTimeValue(fields) : [
              { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null },
              { key: 'content', label: '内容', value: '', suggestedValue: null }
            ]
          };
        } else if (this.activeTab === 'doctor_progress') {
          // 上级医师查房记录：映射到 doctorProgressData.fields
          const noteTime = nowDateTime;
          this.doctorProgressData = {
            noteTime,
            content: '',
            fields: fields.length ? withNoteTimeValue(fields) : [
              { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null },
              { key: 'content', label: '内容', value: '', suggestedValue: null }
            ]
          };
        } else if (this.activeTab === 'physical') {
          // 体检：映射到 physicalExamData.fields
          this.physicalExamData = {
            temperature: '',
            pulse: '',
            respiration: '',
            bloodPressure: '',
            height: '',
            weight: '',
            description: '',
            fields: fields.length ? fields : [
              { key: 'temperatureC', label: '体温(℃)', value: '', suggestedValue: null },
              { key: 'pulseBpm', label: '脉搏(次/分)', value: '', suggestedValue: null },
              { key: 'respirationBpm', label: '呼吸(次/分)', value: '', suggestedValue: null },
              { key: 'bloodPressure', label: '血压', value: '', suggestedValue: null },
              { key: 'heightCm', label: '身高(cm)', value: '', suggestedValue: null },
              { key: 'weightKg', label: '体重(kg)', value: '', suggestedValue: null },
              { key: 'description', label: '描述', value: '', suggestedValue: null }
            ]
          };
        } else if (this.activeTab === 'discharge') {
          // 出院记录：映射到 dischargeData.fields
          this.dischargeData = {
            dischargeTime: '',
            content: '',
            fields: fields.length ? fields : [
              { key: 'dischargeTime', label: '出院时间', value: '', suggestedValue: null },
              { key: 'content', label: '治疗经历', value: '', suggestedValue: null }
            ]
          };
        }
      } catch (error) {
        console.error('加载字段模板失败:', error);
      }
    },

    /* 加载历史记录详情（根据标签页调用不同接口） */
    async loadHistoryDetail(recordId, isDialog = false) {
      if (!recordId) {
        if (isDialog) {
          this.historyDialogDetailData = {};
        } else {
          this.historyDetailData = {};
        }
        return;
      }

      // 防止重复加载：如果正在加载相同的记录ID（弹窗模式），则跳过
      if (isDialog && this.loadingHistoryDetailId === recordId) {
        console.log('正在加载相同的记录ID，跳过重复调用:', recordId);
        return;
      }

      // 如果弹窗模式下已有该记录的数据，且不是强制刷新，则跳过
      if (isDialog && this.historyDialogDetailData && this.historyDialogDetailData.medmstrId) {
        // 检查是否已经有对应的数据（通过比较 recordId 或其他标识）
        // 这里暂时不跳过，因为 recordId 可能不同，需要重新加载
      }

      // 记录当前正在加载的记录ID
      this.loadingHistoryDetailId = recordId;

      try {
        let resp;
        let detailData = {};

        // 根据当前标签页调用不同的详情接口
        if (this.activeTab === 'admission') {
          // 入院记录：调用 /ly/archive/history/detail
          // 如果在历史病历弹窗中调用，使用 selectedDepartment；否则使用 itemCacheChatData?.departmentId
          const departmentId = isDialog
            ? (this.selectedDepartment || this.itemCacheChatData?.departmentId || '')
            : (this.itemCacheChatData?.departmentId || '');
          resp = await request({
            url: '/ly/archive/history/detail',
            method: 'POST',
            data: {
              recordId,
              departmentId,
              // 住院：按当前Tab传 chatGroup（入院=1）
              chatGroup: this.currentChatGroup
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            // 优先使用 fields，否则使用 medicalDetail
            if (Array.isArray(result.fields) && result.fields.length) {
              const fieldMap = {};
              result.fields.forEach(f => {
                if (f && f.key) {
                  const val = f.value;
                  // 原始 key（一般为下划线命名）- 保存所有字段，包括空值
                  fieldMap[f.key] = val !== undefined && val !== null ? val : '';
                  // 同时生成驼峰命名的 key，便于前端模板直接使用
                  const camelKey = f.key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
                  if (camelKey && camelKey !== f.key) {
                    fieldMap[camelKey] = val !== undefined && val !== null ? val : '';
                  }
                }
              });
              detailData = {
                ...result.medicalDetail,
                ...fieldMap,
                // 保存 fields 数组，用于动态展示
                fields: result.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value !== undefined && f.value !== null ? f.value : '',
                  suggestedValue: f.suggestedValue || null
                }))
              };
            } else {
              detailData = {
                ...(result.medicalDetail || result || {}),
                fields: []
              };
            }
          }
        } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
          // 病程记录：调用 /ly/lyInpatientCourseNotes/history/detail
          // 如果在历史病历弹窗中调用，使用 selectedDepartment；否则使用 itemCacheChatData?.departmentId
          const departmentId = isDialog
            ? (this.selectedDepartment || this.itemCacheChatData?.departmentId || '')
            : (this.itemCacheChatData?.departmentId || '');
          resp = await request({
            url: '/ly/lyInpatientCourseNotes/history/detail',
            method: 'POST',
            data: {
              recordId,
              departmentId,
              // 病程：按当前Tab传 chatGroup（首次病程=2，日常病程=3，上级医师查房记录=4）
              chatGroup: this.currentChatGroup
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            // 优先使用 fields，否则使用 inpatientCourseDetail
            if (Array.isArray(result.fields) && result.fields.length) {
              const fieldMap = {};
              result.fields.forEach(f => {
                if (f && f.key) {
                  const val = f.value;
                  // 原始 key（一般为下划线命名）- 保存所有字段，包括空值
                  fieldMap[f.key] = val !== undefined && val !== null ? val : '';
                  // 同时生成驼峰命名的 key，便于前端模板直接使用
                  const camelKey = f.key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
                  if (camelKey && camelKey !== f.key) {
                    fieldMap[camelKey] = val !== undefined && val !== null ? val : '';
                  }
                }
              });
              detailData = {
                ...result.inpatientCourseDetail,
                ...fieldMap,
                // 保存 fields 数组，用于动态展示
                fields: result.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value !== undefined && f.value !== null ? f.value : '',
                  suggestedValue: f.suggestedValue || null
                }))
              };
            } else {
              detailData = {
                ...(result.inpatientCourseDetail || result || {}),
                fields: []
              };
            }
          }
        } else if (this.activeTab === 'physical') {
          // 体格检查：调用 /ly/lyPhysicalExam/history/detail
          resp = await request({
            url: '/ly/lyPhysicalExam/history/detail',
            method: 'POST',
            data: { recordId }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            // 优先使用 fields，否则使用 physicalExamItem
            if (Array.isArray(result.fields) && result.fields.length) {
              const fieldMap = {};
              result.fields.forEach(f => {
                if (f.key && f.value) {
                  fieldMap[f.key] = f.value;
                }
              });
              detailData = {
                ...result.physicalExamItem,
                ...fieldMap
              };
            } else {
              detailData = result.physicalExamItem || {};
            }
          }
        } else if (this.activeTab === 'discharge') {
          // 出院记录：调用 /ly/lyInpatientDischargeNotes/history/detail
          const departmentId = isDialog
            ? (this.selectedDepartment || this.itemCacheChatData?.departmentId || '')
            : (this.itemCacheChatData?.departmentId || '');
          resp = await request({
            url: '/ly/lyInpatientDischargeNotes/history/detail',
            method: 'POST',
            data: {
              recordId,
              departmentId,
              chatGroup: this.currentChatGroup
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            // 优先使用 fields，否则使用 dischargeDetail
            if (Array.isArray(result.fields) && result.fields.length) {
              detailData = {
                fields: result.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value || '',
                  suggestedValue: f.suggestedValue || null
                }))
              };
            } else {
              detailData = {
                dischargeTime: result.dischargeDetail?.dischargeTime || '',
                content: result.dischargeDetail?.content || '',
                fields: []
              };
            }
          }
        }

        // 根据 isDialog 参数决定更新哪个变量
        if (isDialog) {
          this.historyDialogDetailData = detailData;
        } else {
          this.historyDetailData = detailData;
        }
      } catch (error) {
        console.error('加载历史记录详情失败:', error);
        if (isDialog) {
          this.historyDialogDetailData = {};
        } else {
          this.historyDetailData = {};
        }
      } finally {
        // 清除正在加载的记录ID标记
        if (this.loadingHistoryDetailId === recordId) {
          this.loadingHistoryDetailId = null;
        }
      }
    },

    /* 在确认窗口中切换到其他病历历史 */
    async switchToMedicalHistory(item) {
      // 如果点击的是已经选中的记录，且已有数据，不重复加载
      if (this.selectedHistoryItem && this.selectedHistoryItem.id === item.id) {
        // 如果已经有数据，直接返回
        if (this.historyDialogDetailData && Object.keys(this.historyDialogDetailData).length > 0) {
          return;
        }
      }
      this.selectedHistoryItem = item;
      if (item && item.id) {
        await this.loadHistoryDetail(item.id, true); // 传入 isDialog=true，使用弹层独立变量
      }
    },

    /* 确认重新启用历史病历 */
    async confirmUseMedicalHistory() {
      if (this.selectedHistoryItem) {
        try {
          // 根据不同的标签页同步数据到对应的表单（使用弹层数据）
          if (this.activeTab === 'admission') {
            // 同步到入院记录，从模板获取字段格式
            const templateFields = await this.getFieldTemplate(1); // 入院记录的 chatGroup 是 1
            if (templateFields.length > 0) {
              // 使用模板字段，填充历史数据的值
              this.admissionData = {
                chiefComplaint: this.historyDialogDetailData.chiefComplaint || '',
                presentIllness: this.historyDialogDetailData.presentIllness || '',
                pastHistory: this.historyDialogDetailData.pastHistory || '',
                fields: templateFields.map(f => ({
                  ...f,
                  value: this.historyDialogDetailData[f.key] || f.value || '',
                  suggestedValue: null
                }))
              };
            } else {
              // 如果模板为空，使用默认字段（兜底）
              this.admissionData = {
                chiefComplaint: this.historyDialogDetailData.chiefComplaint || '',
                presentIllness: this.historyDialogDetailData.presentIllness || '',
                pastHistory: this.historyDialogDetailData.pastHistory || '',
                fields: [
                  { key: 'chiefComplaint', label: '主诉', value: this.historyDialogDetailData.chiefComplaint || '', suggestedValue: null },
                  { key: 'presentIllness', label: '现病史', value: this.historyDialogDetailData.presentIllness || '', suggestedValue: null },
                  { key: 'pastHistory', label: '既往史', value: this.historyDialogDetailData.pastHistory || '', suggestedValue: null }
                ]
              };
            }
          }  else if (this.activeTab === 'first_progress') {
            // 同步到首次病程记录，转换为 fields 格式
            // 优先使用 fields，否则使用固定字段
            if (this.historyDialogDetailData.fields && Array.isArray(this.historyDialogDetailData.fields) && this.historyDialogDetailData.fields.length > 0) {
              this.firstProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: this.historyDialogDetailData.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value || '',
                  suggestedValue: null
                }))
              };
            } else {
              this.firstProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: [
                  { key: 'noteTime', label: '记录时间', value: this.historyDialogDetailData.noteTime || '', suggestedValue: null },
                  { key: 'content', label: '内容', value: this.historyDialogDetailData.content || '', suggestedValue: null }
                ]
              };
            }
          } else if (this.activeTab === 'daily_progress') {
            // 同步到日常病程记录，转换为 fields 格式
            // 优先使用 fields，否则使用固定字段
            if (this.historyDialogDetailData.fields && Array.isArray(this.historyDialogDetailData.fields) && this.historyDialogDetailData.fields.length > 0) {
              this.dailyProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: this.historyDialogDetailData.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value || '',
                  suggestedValue: null
                }))
              };
            } else {
              this.dailyProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: [
                  { key: 'noteTime', label: '记录时间', value: this.historyDialogDetailData.noteTime || '', suggestedValue: null },
                  { key: 'content', label: '内容', value: this.historyDialogDetailData.content || '', suggestedValue: null }
                ]
              };
            }
          } else if (this.activeTab === 'doctor_progress') {
            // 同步到上级医师查房记录，转换为 fields 格式
            // 优先使用 fields，否则使用固定字段
            if (this.historyDialogDetailData.fields && Array.isArray(this.historyDialogDetailData.fields) && this.historyDialogDetailData.fields.length > 0) {
              this.doctorProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: this.historyDialogDetailData.fields.map(f => ({
                  key: f.key,
                  label: f.label,
                  value: f.value || '',
                  suggestedValue: null
                }))
              };
            } else {
              this.doctorProgressData = {
                noteTime: this.historyDialogDetailData.noteTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: [
                  { key: 'noteTime', label: '记录时间', value: this.historyDialogDetailData.noteTime || '', suggestedValue: null },
                  { key: 'content', label: '内容', value: this.historyDialogDetailData.content || '', suggestedValue: null }
                ]
              };
            }
          } else if (this.activeTab === 'discharge') {
            // 同步到出院记录，转换为 fields 格式
            // 优先使用 fields，否则使用固定字段
            if (this.historyDialogDetailData.fields && Array.isArray(this.historyDialogDetailData.fields) && this.historyDialogDetailData.fields.length > 0) {
              // 从 fields 中提取 dischargeTime
              let dischargeTime = '';
              const fields = this.historyDialogDetailData.fields.map(f => {
                if (f.key === 'discharge_time' || f.key === 'dischargeTime') {
                  dischargeTime = f.value || '';
                }
                return {
                  key: f.key,
                  label: f.label,
                  value: f.value || '',
                  suggestedValue: null
                };
              });
              this.dischargeData = {
                dischargeTime: dischargeTime || this.historyDialogDetailData.dischargeTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: fields
              };
            } else {
              this.dischargeData = {
                dischargeTime: this.historyDialogDetailData.dischargeTime || '',
                content: this.historyDialogDetailData.content || '',
                fields: [
                  { key: 'discharge_time', label: '出院时间', value: this.historyDialogDetailData.dischargeTime || '', suggestedValue: null },
                  { key: 'content', label: '内容', value: this.historyDialogDetailData.content || '', suggestedValue: null }
                ]
              };
            }
          } else if (this.activeTab === 'physical') {
            // 同步到体格检查，转换为 fields 格式
            this.physicalExamData = {
              temperature: this.historyDialogDetailData.temperatureC || '',
              pulse: this.historyDialogDetailData.pulseBpm || '',
              respiration: this.historyDialogDetailData.respirationBpm || '',
              bloodPressure: this.historyDialogDetailData.bloodPressure || '',
              height: this.historyDialogDetailData.heightCm || '',
              weight: this.historyDialogDetailData.weightKg || '',
              description: this.historyDialogDetailData.description || '',
              fields: [
                { key: 'temperatureC', label: '体温(℃)', value: this.historyDialogDetailData.temperatureC || '', suggestedValue: null },
                { key: 'pulseBpm', label: '脉搏(次/分)', value: this.historyDialogDetailData.pulseBpm || '', suggestedValue: null },
                { key: 'respirationBpm', label: '呼吸(次/分)', value: this.historyDialogDetailData.respirationBpm || '', suggestedValue: null },
                { key: 'bloodPressure', label: '血压', value: this.historyDialogDetailData.bloodPressure || '', suggestedValue: null },
                { key: 'heightCm', label: '身高(cm)', value: this.historyDialogDetailData.heightCm || '', suggestedValue: null },
                { key: 'weightKg', label: '体重(kg)', value: this.historyDialogDetailData.weightKg || '', suggestedValue: null },
                { key: 'description', label: '描述', value: this.historyDialogDetailData.description || '', suggestedValue: null }
              ]
            };
          }

          // 调用保存接口，copyFlag 设置为 true（不会将病历同步给AI）
          await this.saveRecord(true);

          // 保存成功后，调用创建会话接口同步病历给 AI
          try {
            const createResult = await createConversationLy({
              medmstrId: this.itemCacheChatData?.id,
              professionalId: localStorage.getItem('userId') || this.userInfo?.id,
              departmentId: this.itemCacheChatData?.departmentId || '',
              dataOrigin: '2', // 住院病历标识
              visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
              chatGroup: this.currentChatGroup
            });

            if (createResult.success && createResult.code === 200) {
              // 清空当前对话记录（与门诊页面保持一致）
              this.chatData_doctor = [];

              // 更新 chatId
              this.itemCacheChatData.chatId = createResult.result.chatId;

              // 同时更新classData中对应患者的chatId，确保子组件数据同步
              const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
              if (patientIndex !== -1) {
                this.$set(this.classData[patientIndex], 'chatId', createResult.result.chatId);
              }

              console.log('重新启用历史病历后创建会话成功，chatId:', createResult.result.chatId);
            } else {
              console.warn('重新启用历史病历后创建会话失败:', createResult.message);
            }
          } catch (error) {
            console.error('重新启用历史病历后创建会话失败:', error);
          }

          this.medicalHistoryConfirmVisible = false;
          const dateText = this.getHistoryDate(this.selectedHistoryItem);
          this.$message.success(`已重新启用 ${dateText} 的病历记录`);
          this.selectedHistoryItem = null;
          this.historyDialogDetailData = {};
        } catch (error) {
          console.error('重新启用病历失败:', error);
          this.$message.error('重新启用病历失败，请重试');
        }
      }
    },

    /* 取消启用历史病历 */
    cancelUseMedicalHistory() {
      this.medicalHistoryConfirmVisible = false;
      this.selectedHistoryItem = null;
      this.historyDetailData = {};
    },

    /* 获取弹窗标题 */
    getHistoryDialogTitle() {
      const titleMap = {
        'admission': '重新启用历史病历',
        'progress': '查看病程记录',
        'first_progress': '查看首次病程记录',
        'daily_progress': '查看日常病程记录',
        'doctor_progress': '查看上级医师查房记录',
        'physical': '查看体格检查记录'
      };
      return titleMap[this.activeTab] || '查看历史记录';
    },

    /* 获取列表标题 */
    getHistoryListTitle() {
      const titleMap = {
        'admission': '病历历史记录',
        'progress': '病程记录历史',
        'first_progress': '首次病程记录历史',
        'daily_progress': '日常病程记录历史',
        'doctor_progress': '上级医师查房记录历史',
        'physical': '体格检查历史'
      };
      return titleMap[this.activeTab] || '历史记录';
    },

    async loadProgressRecords(medmstrId) {
      // 模拟数据，实际应该调用接口
      // const res = await request({
      //   url: '/ly/archive/progress/list',
      //   method: 'GET',
      //   params: { medmstrId, tabType: '病程记录' }
      // });
      // if (res.success) {
      //   this.progressRecords = res.result || [];
      // }
    },

    async saveRecord(copyFlag = false, shouldReload = true) {
      // 防重复调用检查
      if (this.isSaving) {
        console.log('病历正在保存中，跳过重复调用');
        return;
      }

      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      this.isSaving = true;
      try {
        const data = this.getCurrentTabData();
        let response;

        if (this.activeTab === 'admission') {
          // 入院记录：调用 /ly/archive/add，使用 content 字段（JSON格式）
          // 从 admissionData.fields 构建 content JSON 对象（动态字段）
          const contentObj = {};
          if (data.fields && data.fields.length > 0) {
            data.fields.forEach(f => {
              // 字段的 key 保持原样（下划线命名，如 chief_complaint），直接使用
              // 包含所有字段，即使值为空，保持数据结构完整
              contentObj[f.key] = f.value || '';
            });
          }

          // 构建 payload
          const payload = {
            medmstrId: this.itemCacheChatData.id,
            professionalId: this.userInfo?.id,
            departmentId: this.itemCacheChatData?.departmentId || '',
            dataOrigin: '2',
            // 住院病历：按当前Tab传 chatGroup
            chatGroup: this.currentChatGroup,
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
            copyFlag: copyFlag, // 标识是否为创建副本
            content: JSON.stringify(contentObj) // 动态字段的 JSON
          };

          // 如果 chatId 不为空，则添加到请求参数中
          if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          // 添加调试信息
          console.log('保存入院记录数据:', {
            fields: data.fields,
            contentObj: contentObj,
            payload: payload
          });

          response = await request({
            url: '/ly/archive/add',
            method: 'POST',
            data: payload
          });

        } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
          // 病程记录：调用 /ly/lyInpatientCourseNotes/addAndUpdate
          // 根据不同的病程类型设置 dataOrigin：首次病程=2，日常病程=2，上级医师查房记录=4
          let dataOrigin = '2'; // 默认值
          if (this.activeTab === 'doctor_progress') {
            dataOrigin = '4';
          } else if (this.activeTab === 'daily_progress') {
            dataOrigin = '3';
          }

          const payload = {
            medmstrId: this.itemCacheChatData.id,
            professionalId: this.userInfo?.id,
            noteTime: '',
            title: '',
            content: '',
            dataOrigin: dataOrigin, // 添加 dataOrigin 字段
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          };

          // 弹窗“重新启用此历史病历”场景需要带 copyFlag=true，其余场景不传
          if (copyFlag) {
            payload.copyFlag = true;
          }

          // 如果 chatId 不为空，则添加到请求参数中
          if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          // 从 fields 或固定字段构建数据，content 需要存 JSON（保留原始下划线 key，空值用空串）
          const contentObj = {};

          if (data.fields && data.fields.length > 0) {
            data.fields.forEach(f => {
              if (!f || !f.key) return;
              if (f.key === 'noteTime') {
                payload.noteTime = f.value || '';
              } else {
                // 保留原始 key（下划线），值允许为空串
                contentObj[f.key] = f.value !== undefined && f.value !== null ? f.value : '';
              }
            });
          } else {
            payload.noteTime = data.noteTime || '';
            // 固定字段兜底：只存 content 字段
            contentObj.content = data.content || '';
          }

          if (!payload.noteTime) {
            payload.noteTime = this.getCurrentDateTimeString();
          }

          // 将 contentObj 写入 content（JSON字符串）
          payload.content = JSON.stringify(contentObj);

          response = await request({
            url: '/ly/lyInpatientCourseNotes/addAndUpdate',
            method: 'POST',
            data: payload
          });

        } else if (this.activeTab === 'physical') {
          // 体格检查：调用 /ly/lyPhysicalExam/addAndUpdate
          const payload = {
            medmstrId: this.itemCacheChatData.id,
            professionalId: this.userInfo?.id,
            temperatureC: 0,
            pulseBpm: 0,
            respirationBpm: 0,
            bloodPressure: '',
            heightCm: 0,
            weightKg: 0,
            description: ''
          };

          // 如果 chatId 不为空，则添加到请求参数中
          if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          // 从 fields 或固定字段构建数据
          if (data.fields && data.fields.length > 0) {
            data.fields.forEach(f => {
              const fieldValue = f.value || '';
              switch(f.key) {
                case 'temperatureC':
                  payload.temperatureC = fieldValue ? parseFloat(fieldValue) : 0;
                  break;
                case 'pulseBpm':
                  payload.pulseBpm = fieldValue ? parseInt(fieldValue) : 0;
                  break;
                case 'respirationBpm':
                  payload.respirationBpm = fieldValue ? parseInt(fieldValue) : 0;
                  break;
                case 'bloodPressure':
                  payload.bloodPressure = fieldValue;
                  break;
                case 'heightCm':
                  payload.heightCm = fieldValue ? parseFloat(fieldValue) : 0;
                  break;
                case 'weightKg':
                  payload.weightKg = fieldValue ? parseFloat(fieldValue) : 0;
                  break;
                case 'description':
                  payload.description = fieldValue;
                  break;
              }
            });
          } else {
            // 使用固定字段
            payload.temperatureC = data.temperature ? parseFloat(data.temperature) : 0;
            payload.pulseBpm = data.pulse ? parseInt(data.pulse) : 0;
            payload.respirationBpm = data.respiration ? parseInt(data.respiration) : 0;
            payload.bloodPressure = data.bloodPressure || '';
            payload.heightCm = data.height ? parseFloat(data.height) : 0;
            payload.weightKg = data.weight ? parseFloat(data.weight) : 0;
            payload.description = data.description || '';
          }

          response = await request({
            url: '/ly/lyPhysicalExam/addAndUpdate',
            method: 'POST',
            data: payload
          });

        } else if (this.activeTab === 'discharge') {
          // 出院记录：调用 /ly/lyInpatientDischargeNotes/addAndUpdate
          // 优先从子组件获取最新数据
          let dischargeDataToUse = data;
          if (this.$refs.dischargeRecord && typeof this.$refs.dischargeRecord.getData === 'function') {
            const componentData = this.$refs.dischargeRecord.getData();
            if (componentData && (componentData.fields || componentData.dischargeTime || componentData.content)) {
              dischargeDataToUse = componentData;
            }
          }

          const payload = {
            medmstrId: this.itemCacheChatData.id,
            professionalId: this.userInfo?.id,
            admissionTime: null,
            dischargeTime: null,
            hospitalizationDays: null,
            content: '{}', // 默认空 JSON
            sourceType: 1 // 表示录音添加
          };

          // 弹窗“重新启用此历史病历”场景需要带 copyFlag=true，其余场景不传
          if (copyFlag) {
            payload.copyFlag = true;
          }

          // 如果 chatId 不为空，则添加到请求参数中
          if (this.itemCacheChatData?.chatId && this.itemCacheChatData.chatId.trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          // 构建 content JSON（所有病例字段统一存储在 content 中）
          const contentJson = {};
          let dischargeTime = null;
          let admissionTime = null;
          let hospitalizationDays = null;

          // 从 fields 构建数据
          if (dischargeDataToUse.fields && dischargeDataToUse.fields.length > 0) {
            dischargeDataToUse.fields.forEach(f => {
              const key = f.key;
              const value = f.value || '';

              // 业务标识字段单独处理（不存储到 content JSON 中）
              if (key === 'discharge_time') {
                dischargeTime = value;
              } else if (key === 'admission_time') {
                admissionTime = value;
              } else if (key === 'hospitalization_days') {
                hospitalizationDays = value ? parseInt(value) : null;
              } else {
                // 其他字段存储到 content JSON 中
                if (value) {
                  contentJson[key] = value;
                }
              }
            });
          } else {
            // 兼容旧数据格式
            dischargeTime = dischargeDataToUse.dischargeTime || '';
            if (dischargeDataToUse.content) {
              try {
                const parsedContent = JSON.parse(dischargeDataToUse.content);
                // 从旧数据中提取业务标识字段
                if (parsedContent.admission_time) {
                  admissionTime = parsedContent.admission_time;
                  delete parsedContent.admission_time;
                }
                if (parsedContent.discharge_time) {
                  dischargeTime = parsedContent.discharge_time;
                  delete parsedContent.discharge_time;
                }
                if (parsedContent.hospitalization_days) {
                  hospitalizationDays = parsedContent.hospitalization_days;
                  delete parsedContent.hospitalization_days;
                }
                Object.assign(contentJson, parsedContent);
              } catch (e) {
                console.warn('解析 content JSON 失败:', e);
              }
            }
          }

          // 如果仍然没有数据，尝试从 this.dischargeData 直接获取
          if (!dischargeTime && !Object.keys(contentJson).length) {
            dischargeTime = this.dischargeData.dischargeTime || '';
            if (this.dischargeData.content) {
              try {
                const parsedContent = JSON.parse(this.dischargeData.content);
                // 从旧数据中提取业务标识字段
                if (parsedContent.admission_time) {
                  admissionTime = parsedContent.admission_time;
                  delete parsedContent.admission_time;
                }
                if (parsedContent.discharge_time) {
                  dischargeTime = parsedContent.discharge_time;
                  delete parsedContent.discharge_time;
                }
                if (parsedContent.hospitalization_days) {
                  hospitalizationDays = parsedContent.hospitalization_days;
                  delete parsedContent.hospitalization_days;
                }
                Object.assign(contentJson, parsedContent);
              } catch (e) {
                console.warn('解析 content JSON 失败:', e);
              }
            }
          }

          // 设置业务标识字段（转换为后端能识别的日期格式：yyyy-MM-dd）
          if (dischargeTime) {
            const date = new Date(dischargeTime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            payload.dischargeTime = `${year}-${month}-${day}`;
          }
          if (admissionTime) {
            const date = new Date(admissionTime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            payload.admissionTime = `${year}-${month}-${day}`;
          }
          payload.hospitalizationDays = hospitalizationDays;

          // 设置 content JSON（不包含业务标识字段）
          payload.content = JSON.stringify(contentJson);

          // 添加其他必要字段
          payload.departmentId = this.itemCacheChatData?.departmentId || '';
          payload.visitNum = this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '';

          response = await request({
            url: '/ly/lyInpatientDischargeNotes/addAndUpdate',
            method: 'POST',
            data: payload
          });
        } else {
          this.isSaving = false;
          return;
        }

        if (response && response.success) {
          // 标记当前标签的数据已保存（清除修改标记）
          this.markTabAsSaved();
          // 只有在 shouldReload 为 true 时才显示成功提示（失焦保存时不显示，避免干扰用户）
          if (shouldReload) {
            this.$message.success('保存成功');
          }
          // 当 copyFlag 为 true 时（重新启用历史病历），不重新加载数据，避免重复调用接口
          // 因为重新启用历史病历后，会调用 createConversationLy 创建新会话，然后会重新加载数据
          // 当 shouldReload 为 false 时（失焦保存），不重新加载数据，避免刷新其他正在编辑的字段
          if (!copyFlag && shouldReload) {
            // 保存成功后，重新加载最新数据
            if (this.activeTab === 'admission') {
              await this.loadLatestAdmissionDetail();
            } else if (this.activeTab === 'progress' || this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
              await this.loadLatestProgressDetail();
            } else if (this.activeTab === 'physical') {
              await this.loadLatestPhysicalDetail();
            } else if (this.activeTab === 'discharge') {
              await this.loadLatestDischargeDetail();
            }
          }
        } else {
          this.$message.error(response?.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败');
      } finally {
        this.isSaving = false;
      }
    },

    getTabType() {
      const tabMap = {
        admission: '入院记录',
        progress: '病程记录',
        first_progress: '首次病程记录',
        daily_progress: '日常病程记录',
        doctor_progress: '上级医师查房记录',
        physical: '体格检查',
        discharge: '出院记录'
      };
      return tabMap[this.activeTab] || '';
    },

    getCurrentTabData() {
      if (this.activeTab === 'admission') {
        return { ...this.admissionData };
      } else if (this.activeTab === 'progress') {
        return { ...this.progressData };
      } else if (this.activeTab === 'first_progress') {
        return { ...this.firstProgressData };
      } else if (this.activeTab === 'daily_progress') {
        return { ...this.dailyProgressData };
      } else if (this.activeTab === 'doctor_progress') {
        return { ...this.doctorProgressData };
      } else if (this.activeTab === 'physical') {
        return { ...this.physicalExamData };
      } else if (this.activeTab === 'discharge') {
        return { ...this.dischargeData };
      }
      return {};
    },

    // ========== Tab切换 ==========
    async handleTabClick(tab) {
      // 切换标签前，检查当前标签是否有未保存的修改
      const hasUnsavedChanges = this.hasUnsavedAcceptedChanges();
      // 检查是否还有未处理的AI建议（需要在切换前检查，因为切换后 activeTab 会改变）
      const hasUnprocessedSuggestions = this.hasSuggestions;

      // 添加调试日志
      console.log('切换标签检查:', {
        activeTab: this.activeTab,
        targetTab: tab.name,
        hasUnsavedChanges,
        hasUnprocessedSuggestions,
        tabModifiedFlags: { ...this.tabModifiedFlags }
      });

      if (hasUnsavedChanges) {
        if (hasUnprocessedSuggestions) {
          // 如果还有未处理的AI建议，说明用户可能还在操作中，提示用户
          try {
            await this.$confirm(
              '当前有未处理的AI建议，切换标签将保存已接受的修改，是否继续？',
              '提示',
              {
                confirmButtonText: '继续切换',
                cancelButtonText: '取消',
                type: 'warning'
              }
            );

            // 用户确认继续切换，保存已接受的修改（切换标签时重新加载数据）
            await this.saveRecord(false, true);
            this.$message.success('已自动保存当前修改');
          } catch (error) {
            // 用户点击取消或关闭对话框
            if (error === 'cancel' || error === 'close') {
              return; // 取消切换标签
            }
            console.error('切换标签前保存失败:', error);
            // 即使保存失败，也继续切换标签（避免阻塞用户操作）
          }
        } else {
          // 如果所有AI建议都已处理，说明用户操作已完成，自动保存（切换标签时重新加载数据）
          try {
            await this.saveRecord(false, true);
            this.$message.success('已自动保存当前修改');
          } catch (error) {
            console.error('切换标签前保存失败:', error);
            // 即使保存失败，也继续切换标签（避免阻塞用户操作）
          }
        }
      }

      // 切换标签时统一重置操作记录 Popover，避免状态在不同标签之间互相影响
      this.historyVisible = false;
      this.historyData = [];
      if (this.$refs.historyPopover && typeof this.$refs.historyPopover.doClose === 'function') {
        this.$refs.historyPopover.doClose();
      }

      this.activeTab = tab.name;

      // 切换标签时重新调用会话详情接口
      if (this.itemCacheChatData?.chatId) {
        await this.loadConversationDetail(this.itemCacheChatData.chatId);
      }

      // 根据标签页加载对应的最新详情
      if (this.itemCacheChatData?.id) {
        if (tab.name === 'admission') {
          await this.loadLatestAdmissionDetail();
        } else if (tab.name === 'progress') {
          await this.loadLatestProgressDetail();
        } else if (tab.name === 'first_progress') {
          await this.loadLatestProgressDetail(); // 首次病程使用相同的加载逻辑
        } else if (tab.name === 'daily_progress') {
          await this.loadLatestProgressDetail(); // 日常病程使用相同的加载逻辑
        } else if (tab.name === 'doctor_progress') {
          await this.loadLatestProgressDetail(); // 上级医师查房记录使用相同的加载逻辑
        } else if (tab.name === 'physical') {
          await this.loadLatestPhysicalDetail();
        } else if (tab.name === 'discharge') {
          await this.loadLatestDischargeDetail();
        }
      }
    },

    /* 加载最新入院记录详情（方案A：先查列表，再查详情） */
    async loadLatestAdmissionDetail() {
      const patientId = this.itemCacheChatData?.id;
      if (!patientId) {
        this.admissionData = { chiefComplaint: '', presentIllness: '', pastHistory: '', fields: [] };
        return;
      }

      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        // 1. 先查列表
        const resp = await request({
          url: '/ly/archive/history',
          method: 'POST',
          data: {
            medmstrId: patientId,
            onlyMine: true,
            professionalId: userId,
            pageNum: 1,
            pageSize: 1,
            dataOrigin: '2',
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          }
        });
        if (!this.isSamePatient(patientId, this.itemCacheChatData?.id)) {
          return;
        }

        // 2. 取第一条记录的 id
        const latestRecord = Array.isArray(resp?.result) && resp.result.length > 0 ? resp.result[0] : null;
        if (latestRecord?.id) {
          // 3. 调用详情接口
          await this.loadAdmissionDetail(latestRecord.id, patientId);
        } else {
          if (!this.isSamePatient(patientId, this.itemCacheChatData?.id)) {
            return;
          }
          // 4. 无历史记录时：拉取字段模板（带 chatGroup）
          this.activeTab = 'admission';
          await this.loadFieldTemplateForCurrentTab();
        }
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.admission = false;
      } catch (error) {
        console.error('加载最新入院记录详情失败:', error);
        if (!this.isSamePatient(patientId, this.itemCacheChatData?.id)) {
          return;
        }
        // 出错时也尝试拉取模板
        this.activeTab = 'admission';
        await this.loadFieldTemplateForCurrentTab();
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.admission = false;
      }
    },

    /* 加载最新病程记录详情（方案A：先查列表，再查详情） */
    async loadLatestProgressDetail() {
      if (!this.itemCacheChatData?.id) {
        // 根据当前标签设置对应的空数据
        if (this.activeTab === 'first_progress') {
          this.firstProgressData = createEmptyProgressData();
        } else if (this.activeTab === 'daily_progress') {
          this.dailyProgressData = createEmptyProgressData();
        } else if (this.activeTab === 'doctor_progress') {
          this.doctorProgressData = createEmptyProgressData();
        } else {
          this.progressData = createEmptyProgressData();
        }
        return;
      }

      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        // 根据不同的病程类型设置 dataOrigin：首次病程=2，日常病程=2，上级医师查房记录=4
        let dataOrigin = '2'; // 默认值
        if (this.activeTab === 'doctor_progress') {
          dataOrigin = '4';
        } else if (this.activeTab === 'daily_progress'){
          dataOrigin = '3';
        }

        // 1. 先查列表
        const resp = await request({
          url: '/ly/lyInpatientCourseNotes/history',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            professionalId: userId,
            pageNum: 1,
            pageSize: 1,
            dataOrigin: dataOrigin,
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          }
        });

        // 2. 取第一条记录的 id
        const latestRecord = Array.isArray(resp?.result) && resp.result.length > 0 ? resp.result[0] : null;
        if (latestRecord?.id) {
          // 3. 调用详情接口
          await this.loadProgressDetail(latestRecord.id);
        } else {
          // 无历史记录时：拉取字段模板（保持当前 activeTab 不变）
          await this.loadFieldTemplateForCurrentTab();
        }
        // 数据加载完成后，重置修改标记
        if (this.activeTab === 'first_progress') {
          this.tabModifiedFlags.first_progress = false;
        } else if (this.activeTab === 'daily_progress') {
          this.tabModifiedFlags.daily_progress = false;
        } else if (this.activeTab === 'doctor_progress') {
          this.tabModifiedFlags.doctor_progress = false;
        } else {
          this.tabModifiedFlags.progress = false;
        }
      } catch (error) {
        console.error('加载最新病程记录详情失败:', error);
        // 出错时也尝试拉取模板（保持当前 activeTab 不变）
        await this.loadFieldTemplateForCurrentTab();
        // 数据加载完成后，重置修改标记
        if (this.activeTab === 'first_progress') {
          this.tabModifiedFlags.first_progress = false;
        } else if (this.activeTab === 'daily_progress') {
          this.tabModifiedFlags.daily_progress = false;
        } else if (this.activeTab === 'doctor_progress') {
          this.tabModifiedFlags.doctor_progress = false;
        } else {
          this.tabModifiedFlags.progress = false;
        }
      }
    },

    /* 加载最新出院记录详情（方案A：先查列表，再查详情） */
    async loadLatestDischargeDetail() {
      if (!this.itemCacheChatData?.id) {
        this.dischargeData = { dischargeTime: '', content: '', fields: [] };
        return;
      }

      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        // 1. 先查列表
        const resp = await request({
          url: '/ly/lyInpatientDischargeNotes/history',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            professionalId: userId,
            pageNum: 1,
            pageSize: 1,
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          }
        });

        // 2. 取第一条记录的 id
        const latestRecord = Array.isArray(resp?.result) && resp.result.length > 0 ? resp.result[0] : null;
        if (latestRecord?.id) {
          // 3. 调用详情接口
          await this.loadDischargeDetail(latestRecord.id);
        } else {
          // 无历史记录时：拉取字段模板
          this.activeTab = 'discharge';
          await this.loadFieldTemplateForCurrentTab();
        }
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.discharge = false;
      } catch (error) {
        console.error('加载最新出院记录详情失败:', error);
        // 出错时也尝试拉取模板
        this.activeTab = 'discharge';
        await this.loadFieldTemplateForCurrentTab();
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.discharge = false;
      }
    },

    /* 加载出院记录详情 */
    async loadDischargeDetail(recordId) {
      if (!recordId) {
        this.dischargeData = { dischargeTime: '', content: '', fields: [] };
        return;
      }

      try {
        const departmentId = this.itemCacheChatData?.departmentId || '';
        const resp = await request({
          url: '/ly/lyInpatientDischargeNotes/history/detail',
          method: 'POST',
          data: {
            recordId,
            departmentId,
            chatGroup: this.currentChatGroup
          }
        });

        if (resp && resp.success) {
          const result = resp.result || {};
          // 优先使用 fields，否则使用 dischargeDetail
          if (Array.isArray(result.fields) && result.fields.length) {
            // 保存 fields 用于引用推荐（包含 suggestedValue）
            this.dischargeData = {
              dischargeTime: '',
              content: '',
              fields: result.fields.map(f => ({
                key: f.key,
                label: f.label,
                value: f.value || '',
                suggestedValue: f.suggestedValue || null
              }))
            };
          } else {
            const detail = result.dischargeDetail || {};
            this.dischargeData = {
              dischargeTime: detail.dischargeTime || '',
              content: detail.content || '',
              fields: [
                { key: 'discharge_time', label: '出院时间', value: detail.dischargeTime || '', suggestedValue: null },
                { key: 'content', label: '出院描述', value: detail.content || '', suggestedValue: null }
              ]
            };
          }
        } else {
          this.dischargeData = { dischargeTime: '', content: '', fields: [] };
        }
      } catch (error) {
        console.error('加载出院记录详情失败:', error);
        this.dischargeData = { dischargeTime: '', content: '', fields: [] };
      }
    },

    /* 加载最新体格检查详情（方案A：先查列表，再查详情） */
    async loadLatestPhysicalDetail() {
      if (!this.itemCacheChatData?.id) {
        this.physicalExamData = createEmptyPhysicalExamData();
        return;
      }

      try {
        const userId = localStorage.getItem('userId') || this.userInfo?.id;
        // 1. 先查列表
        const resp = await request({
          url: '/ly/lyPhysicalExam/history',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            professionalId: userId,
            pageNum: 1,
            pageSize: 1
          }
        });

        // 2. 取第一条记录的 id
        const latestRecord = Array.isArray(resp?.result) && resp.result.length > 0 ? resp.result[0] : null;
        if (latestRecord?.id) {
          // 3. 调用详情接口
          await this.loadPhysicalDetailById(latestRecord.id);
        } else {
          // 无历史记录时：拉取字段模板
          this.activeTab = 'physical';
          await this.loadFieldTemplateForCurrentTab();
        }
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.physical = false;
      } catch (error) {
        console.error('加载最新体格检查详情失败:', error);
        // 出错时也尝试拉取模板
        this.activeTab = 'physical';
        await this.loadFieldTemplateForCurrentTab();
        // 数据加载完成后，重置修改标记
        this.tabModifiedFlags.physical = false;
      }
    },

    // ========== HIS提交 ==========
    submitToHis() {
      this.hisSub = true;
    },

    async confirmHisSubmit() {
      this.hisSubmitLoading = true;
      try {
        const response = await request({
          url: '/ly/archive/addLogForHisCommitBefore',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData?.id,
            tabType: this.getTabType()
          }
        });

        if (response.success) {
          this.$message.success('提交成功');
          this.hisSub = false;
        } else {
          this.$message.error(response.message || '提交失败');
        }
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('提交失败');
      } finally {
        this.hisSubmitLoading = false;
      }
    },
    // ========== 清空病历（当前Tab + 调用后端清空接口） ==========
    async clearCurrentTab() {
      this.clearVisible = false;

      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      let hasContent = false;

      // 1. 根据当前 Tab 清空前端数据
      if (this.activeTab === 'admission') {
        if (this.admissionData && Object.keys(this.admissionData).length) {
          const fields = this.admissionData.fields || [];
          // 判断是否有内容
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '') {
              hasContent = true;
            }
          });

          // 保留字段结构，只清空字段值（参考门诊页面的实现）
          if (fields && fields.length > 0) {
            // 保留原有字段结构，只清空值
            this.admissionData.fields = fields.map(field => ({
              ...field,
              value: '', // 清空字段内容
              isEdit: false, // 确保不在编辑状态
              isEdit_newValue: null, // 清空AI建议
              suggestedValue: null // 清空建议值
            }));
            // 同时清空旧的字段值（兼容旧格式）
            this.admissionData.chiefComplaint = '';
            this.admissionData.presentIllness = '';
            this.admissionData.pastHistory = '';
          } else {
            // 如果没有字段结构，保持原有结构但清空值
            this.admissionData = {
              chiefComplaint: '',
              presentIllness: '',
              pastHistory: '',
              fields: []
            };
          }
        } else {
          // 如果 admissionData 为空，保持原有结构
          this.admissionData = {
            chiefComplaint: '',
            presentIllness: '',
            pastHistory: '',
            fields: []
          };
        }
      } else if (this.activeTab === 'progress') {
        if (this.progressData) {
          const fields = this.progressData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.progressData.fields) && this.progressData.fields.length) {
          const currentNoteTime = this.getCurrentDateTimeString();
          this.progressData = {
            ...this.progressData,
            noteTime: currentNoteTime,
            // 移除 title 字段
            content: '',
            fields: this.progressData.fields.map(field => ({
              ...field,
              value: field.key === 'noteTime' ? currentNoteTime : '',
              suggestedValue: null
            }))
          };
        } else {
          this.progressData = createEmptyProgressData();
        }
      } else if (this.activeTab === 'first_progress') {
        if (this.firstProgressData) {
          const fields = this.firstProgressData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '' && f.key !== 'noteTime') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.firstProgressData.fields) && this.firstProgressData.fields.length) {
          const currentNoteTime = this.getCurrentDateTimeString();
          this.firstProgressData = {
            ...this.firstProgressData,
            noteTime: currentNoteTime,
            content: '',
            fields: this.firstProgressData.fields.map(field => ({
              ...field,
              value: field.key === 'noteTime' ? currentNoteTime : '',
              suggestedValue: null
            }))
          };
        } else {
          this.firstProgressData = createEmptyProgressData();
        }
      } else if (this.activeTab === 'daily_progress') {
        if (this.dailyProgressData) {
          const fields = this.dailyProgressData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '' && f.key !== 'noteTime') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.dailyProgressData.fields) && this.dailyProgressData.fields.length) {
          const currentNoteTime = this.getCurrentDateTimeString();
          this.dailyProgressData = {
            ...this.dailyProgressData,
            noteTime: currentNoteTime,
            content: '',
            fields: this.dailyProgressData.fields.map(field => ({
              ...field,
              value: field.key === 'noteTime' ? currentNoteTime : '',
              suggestedValue: null
            }))
          };
        } else {
          this.dailyProgressData = createEmptyProgressData();
        }
      } else if (this.activeTab === 'doctor_progress') {
        if (this.doctorProgressData) {
          const fields = this.doctorProgressData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '' && f.key !== 'noteTime') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.doctorProgressData.fields) && this.doctorProgressData.fields.length) {
          const currentNoteTime = this.getCurrentDateTimeString();
          this.doctorProgressData = {
            ...this.doctorProgressData,
            noteTime: currentNoteTime,
            content: '',
            fields: this.doctorProgressData.fields.map(field => ({
              ...field,
              value: field.key === 'noteTime' ? currentNoteTime : '',
              suggestedValue: null
            }))
          };
        } else {
          this.doctorProgressData = createEmptyProgressData();
        }
      } else if (this.activeTab === 'discharge') {
        if (this.dischargeData) {
          // 检查 content 字段
          if (this.dischargeData.content && String(this.dischargeData.content).trim() !== '') {
            hasContent = true;
          }
          // 检查 dischargeTime 字段
          if (this.dischargeData.dischargeTime && String(this.dischargeData.dischargeTime).trim() !== '') {
            hasContent = true;
          }
          // 检查 fields 中的内容
          const fields = this.dischargeData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.dischargeData.fields) && this.dischargeData.fields.length) {
          this.dischargeData = {
            ...this.dischargeData,
            dischargeTime: '',
            content: '',
            fields: this.dischargeData.fields.map(field => ({
              ...field,
              value: '',
              suggestedValue: null
            }))
          };
        } else {
          // 如果 dischargeData 没有 fields，初始化一个空的数据结构
          this.dischargeData = {
            dischargeTime: '',
            content: '',
            fields: []
          };
        }
      } else if (this.activeTab === 'physical') {
        if (this.physicalExamData) {
          const fields = this.physicalExamData.fields || [];
          fields.forEach(f => {
            if (f.value && String(f.value).trim() !== '') {
              hasContent = true;
            }
          });
        }
        if (Array.isArray(this.physicalExamData.fields) && this.physicalExamData.fields.length) {
          this.physicalExamData = {
            ...this.physicalExamData,
            temperature: '',
            pulse: '',
            respiration: '',
            bloodPressure: '',
            height: '',
            weight: '',
            description: '',
            fields: this.physicalExamData.fields.map(field => ({
              ...field,
              value: '',
              suggestedValue: null
            }))
          };
        } else {
          this.physicalExamData = createEmptyPhysicalExamData();
        }
      }

      // 2. 调用后端清空接口（根据不同的 tab 调用不同的接口）
      if (hasContent) {
        try {
          const payload = {
            medmstrId: this.itemCacheChatData.id,
            professionalId: this.userInfo?.id || localStorage.getItem('userId'),
            departmentId: this.itemCacheChatData?.departmentId || '',
            // 住院病历：按当前Tab传 chatGroup
            chatGroup: this.currentChatGroup,
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
            // 住院病历标识
            dataOrigin: '2'
          };

          if (this.itemCacheChatData?.chatId && String(this.itemCacheChatData.chatId).trim() !== '') {
            payload.chatId = this.itemCacheChatData.chatId;
          }

          // 根据不同的 tab 调用不同的清空接口
          let clearUrl = '';
          if (this.activeTab === 'admission') {
            // 入院记录：调用 /ly/archive/clear
            clearUrl = '/ly/archive/clear';
          } else if (this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress' || this.activeTab === 'progress') {
            // 病程记录（首次病程、日常病程、上级医师查房记录）：调用 /ly/lyInpatientCourseNotes/clear
            clearUrl = '/ly/lyInpatientCourseNotes/clear';
          } else if (this.activeTab === 'discharge') {
            // 出院记录：调用 /ly/lyInpatientDischargeNotes/clear
            clearUrl = '/ly/lyInpatientDischargeNotes/clear';
          } else {
            // 其他标签暂不支持清空
            this.$message.warning('当前标签暂不支持清空操作');
            return;
          }

          const resp = await request({
            url: clearUrl,
            method: 'POST',
            data: payload
          });

          if (resp && resp.success) {
            this.$message.success('已清空当前病历内容');

            // 清空病历成功后，创建新会话
            await this.createNewConversationAfterClear();
          } else {
            this.$message.error(resp?.message || '清空病历失败');
          }
        } catch (error) {
          console.error('清空病历失败:', error);
          this.$message.error('网络错误，清空病历失败');
        }
      } else {
        // 如果没有内容，静默处理，不显示提示（新建病历时本来就没有内容）
        // 但仍然需要创建新会话，确保是一个全新的会话
        await this.createNewConversationAfterClear();
      }
    },

    /* 创建新会话（新建病历后调用） */
    async createNewConversationAfterClear() {
      try {
        const createResult = await createConversationLy({
          medmstrId: this.itemCacheChatData?.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.itemCacheChatData?.departmentId || '',
          dataOrigin: '2', // 住院病历标识
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
          chatGroup: this.currentChatGroup
        });

        if (createResult.success && createResult.code === 200) {
          // 更新chatId
          this.itemCacheChatData.chatId = createResult.result.chatId;

          // 同时更新classData中对应患者的chatId，确保子组件数据同步
          const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
          if (patientIndex !== -1) {
            this.$set(this.classData[patientIndex], 'chatId', createResult.result.chatId);
          }

          // 清空右侧会话内容（因为这是一个新的会话id了）
          this.chatData_doctor = [];

          console.log('新建病历后新会话创建成功，chatId:', createResult.result.chatId);

          // 如果是入院记录标签，且字段为空，则重新加载字段模板（确保字段不丢失）
          if (this.activeTab === 'admission' && (!this.admissionData.fields || this.admissionData.fields.length === 0)) {
            await this.loadFieldTemplateForCurrentTab();
          }
        } else {
          console.error('新建病历后创建新会话失败:', createResult.message);
        }
      } catch (error) {
        console.error('新建病历后创建新会话失败:', error);
      }
    },

    // ========== AI对话相关 ==========
    async handleSendMessage(content) {
      try {
        const tabType = this.getTabType();

        // 格式化当前时间为 "YYYY-MM-DD HH:mm:ss" 格式
        const getCurrentTimeString = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const response = await sendMessageLy({
          chatId: this.itemCacheChatData?.chatId,
          message: content, // 改为 message 参数
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.itemCacheChatData?.departmentId || '',
          // 住院病历特有的参数
          tabType: tabType,
          chatGroup: this.currentChatGroup,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        });

        if (response.success) {
          // 构建用户消息数据，包含时间戳
          const userMessage = {
            role: 'user',
            content: content,
            createTime: getCurrentTimeString(),
            senderType: 'doctor'
          };
          this.chatData_doctor.push(userMessage);

          // 处理AI回复
          if (response.result) {
            const aiMessage = {
              role: 'assistant',
              content: response.result.aiReturnMsg || response.result.content || '收到您的消息',
              createTime: getCurrentTimeString(),
              senderType: 'ai',
              id: response.result.messageId
            };
            this.chatData_doctor.push(aiMessage);
          }

          // 确保视图更新并滚动到底部
          this.$nextTick(() => {
            if (this.$refs.chatBoxDoctor && this.$refs.chatBoxDoctor.$refs.chat_dom) {
              const chatDom = this.$refs.chatBoxDoctor.$refs.chat_dom;
              chatDom.scrollTop = chatDom.scrollHeight;
            }
          });
        }
      } catch (error) {
        console.error('发送消息失败:', error);
        this.$message.error('发送失败');
      }
    },

    // 会话详情（右侧对话），基于 chatId
    async loadConversationDetail(conversationId) {
      if (!conversationId) {
        console.log('没有chatId，无法加载聊天记录');
        this.chatData_doctor = [];
        return;
      }

      try {
        console.log('加载患者聊天记录，chatId:', conversationId);

        // 调用详情接口获取聊天记录
        const resp = await request({
          url: '/ly/conversation/detail',
          method: 'POST',
          data: {
            conversationId,
            // 住院病历：按当前Tab传 chatGroup
            chatGroup: this.currentChatGroup
          }
        });

        if (resp && resp.success && resp.result) {
          const messages = resp.result.conversationData || [];
          console.log('获取到的患者聊天记录:', messages);

          // 转换为chatData_doctor格式，与门诊病历保持一致
          this.chatData_doctor = messages.map(m => ({
            role: m.senderType === 'doctor' ? 'user' : 'assistant',
            content: m.content,
            createTime: m.createTime,
            senderType: m.senderType,
            id: m.id,
            audioFilePath: m.audioFilePath || '' // 加载音频文件路径，支持重新编辑时播放
          }));

          console.log('加载患者聊天记录条数:', this.chatData_doctor.length);
        } else {
          console.log('获取患者聊天记录失败:', resp?.message);
          this.chatData_doctor = [];
        }
      } catch (e) {
        console.error('加载患者聊天记录失败:', e);
        this.chatData_doctor = [];
      }
    },
    /* 引用AI回复到病历 */
    async handleCreateByOneBtn(item) {
      if (!this.itemCacheChatData?.chatId) {
        return this.$message.warning("请选择会话");
      }

      try {
        const tabType = this.getTabType();
        // 组装引用接口入参，content 字段直接传递文本内容，不使用 JSON 格式
        const contentText = item.content || '';
        if (!contentText) {
          return this.$message.warning("请选择要引用的内容");
        }
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: contentText,
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          departmentId: this.itemCacheChatData?.departmentId || '',
          tabType: tabType,
          dataOrigin: '2',
          // 住院病历：按当前Tab传 chatGroup
          chatGroup: this.currentChatGroup,
          includeMedicalRecords: true,
          includeTestReports: false,
          includeHistoryChat: false,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        };

        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          console.log('API返回的建议字段:', suggestionFields);

          // 合并AI建议到当前标签页的数据
          this.mergeSuggestionsToCurrentTab(suggestionFields);
          this.$message.success('已根据AI建议更新病历内容');
        } else {
          this.$message.error(resp?.message || '引用失败');
        }
      } catch (e) {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        console.error('引用失败:', e);
        this.$message.error('引用失败，请重试');
      }
    },

    /* 合并AI建议到当前标签页的数据 */
    async mergeSuggestionsToCurrentTab(suggestionFields) {
      if (!suggestionFields || suggestionFields.length === 0) {
        return;
      }

      // 根据当前标签页合并建议
      if (this.activeTab === 'admission') {
        await this.mergeSuggestionsToAdmission(suggestionFields);
      } else if (this.activeTab === 'progress') {
        // 通用病程记录
        await this.mergeSuggestionsToProgress(suggestionFields, 'progress');
      } else if (this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
        // 首次病程 / 日常病程 / 上级医师查房记录
        const tabType = this.activeTab;
        await this.mergeSuggestionsToProgress(suggestionFields, tabType);
      } else if (this.activeTab === 'physical') {
        await this.mergeSuggestionsToPhysical(suggestionFields);
      } else if (this.activeTab === 'discharge') {
        await this.mergeSuggestionsToDischarge(suggestionFields);
      }
    },

    /* 合并AI建议到入院记录 */
    async mergeSuggestionsToAdmission(suggestionFields) {
      // 如果当前没有 fields，先从模板获取字段
      if (!this.admissionData.fields || this.admissionData.fields.length === 0) {
        const templateFields = await this.getFieldTemplate(1); // 入院记录的 chatGroup 是 1
        if (templateFields.length > 0) {
          // 使用模板字段，并保留现有值
          this.admissionData.fields = templateFields.map(f => ({
            ...f,
            value: this.admissionData[f.key] || f.value || '',
            isEdit_newValue: null
          }));
        } else {
          // 如果模板为空，保持 fields 为空数组，避免显示默认字段
          // 这种情况应该很少见，因为字段模板应该已经配置
          this.admissionData.fields = [];
        }
      }

      // 创建字段映射
      const fieldMap = new Map();
      this.admissionData.fields.forEach(f => {
        fieldMap.set(f.key, f);
      });

      // 处理AI建议 - 设置 isEdit_newValue 以显示建议替换效果
      suggestionFields.forEach(sf => {
        const fieldKey = sf.key;
        const suggestedValue = sf.suggestedValue || sf.value || '';
        const field = fieldMap.get(fieldKey);

        if (field) {
          // 设置建议值到 isEdit_newValue，用于显示建议替换效果
          this.$set(field, 'isEdit_newValue', suggestedValue);
          // 同时保留 suggestedValue 用于其他用途
          field.suggestedValue = suggestedValue;
        } else {
          // 如果找不到匹配的字段，创建新字段
          this.admissionData.fields.push({
            key: fieldKey,
            label: sf.label || fieldKey,
            value: '',
            suggestedValue: suggestedValue,
            isEdit_newValue: suggestedValue
          });
        }
      });

      // 触发视图更新
      this.$forceUpdate();
    },

    /* 合并AI建议到病程记录 */
    async mergeSuggestionsToProgress(suggestionFields, tabType = 'progress') {
      console.log('合并AI建议到病程记录:', suggestionFields, 'tabType:', tabType);
      // 根据 tabType 确定要更新的数据对象
      let targetData;
      let chatGroup = null;
      if (tabType === 'first_progress') {
        targetData = this.firstProgressData;
        chatGroup = 2; // 首次病程记录的 chatGroup 是 2
      } else if (tabType === 'daily_progress') {
        targetData = this.dailyProgressData;
        chatGroup = 3; // 日常病程记录的 chatGroup 是 3
      } else if (tabType === 'doctor_progress') {
        targetData = this.doctorProgressData;
        chatGroup = 4; // 上级医师查房记录的 chatGroup 是 4
      } else {
        targetData = this.progressData;
        chatGroup = 2; // 通用病程记录的 chatGroup 是 2
      }

      // 如果当前没有 fields，从模板获取字段
      if (!targetData.fields || targetData.fields.length === 0) {
        console.log('从模板获取字段:', chatGroup);
        const templateFields = await this.getFieldTemplate(chatGroup);
        if (templateFields.length > 0) {
          const nowDateTime = this.getCurrentDateTimeString();
          // 如果模板中包含 noteTime 字段，则优先使用当前系统时间填充，确保有记录时间且为只读展示
          targetData.fields = templateFields.map(f => {
            const key = f.key;
            let value = targetData[key] || f.value || '';
            if (key === 'noteTime' && !value) {
              value = nowDateTime;
              // 同步更新顶层的 noteTime 字段，保持数据一致
              targetData.noteTime = targetData.noteTime || nowDateTime;
            }
            return {
              ...f,
              value,
              isEdit_newValue: null
            };
          });
        } else {
          // 如果模板为空，保持 fields 为空数组
          targetData.fields = [];
        }
      }

      // 创建字段映射
      const fieldMap = new Map();
      targetData.fields.forEach(f => {
        fieldMap.set(f.key, f);
      });

      // 处理AI建议 - 设置 isEdit_newValue 以显示建议替换效果
      // 只处理模板中已存在的字段，忽略不在模板中的字段（如主诉、现病史等不应该出现在病程记录中的字段）
      suggestionFields.filter(sf => {
        // 过滤掉 title 字段
        if (sf.key === 'title') {
          return false;
        }
        // 只处理模板中已存在的字段，不创建新字段
        return fieldMap.has(sf.key);
      }).forEach(sf => {
        const fieldKey = sf.key;
        const suggestedValue = sf.suggestedValue || sf.value || '';
        const field = fieldMap.get(fieldKey);

        if (field) {
          // 设置建议值到 isEdit_newValue，用于显示建议替换效果
          this.$set(field, 'isEdit_newValue', suggestedValue);
          // 同时保留 suggestedValue 用于其他用途
          field.suggestedValue = suggestedValue;
        }
        // 移除了 else 分支，不再自动创建新字段，避免显示不应该出现的字段（如主诉等）
      });

      // 触发视图更新
      this.$forceUpdate();
    },

    /* 合并AI建议到出院记录 */
    async mergeSuggestionsToDischarge(suggestionFields) {
      // 如果当前没有 fields，从模板获取字段（chatGroup=5）
      if (!this.dischargeData.fields || this.dischargeData.fields.length === 0) {
        const templateFields = await this.getFieldTemplate(5); // 出院记录的 chatGroup 是 5
        if (templateFields.length > 0) {
          this.dischargeData.fields = templateFields.map(f => ({
            ...f,
            value: this.dischargeData[f.key] || f.value || '',
            isEdit_newValue: null
          }));
        } else {
          // 如果模板为空，保持 fields 为空数组
          this.dischargeData.fields = [];
        }
      }

      // 创建字段映射
      const fieldMap = new Map();
      this.dischargeData.fields.forEach(f => {
        fieldMap.set(f.key, f);
      });

      // 处理AI建议 - 设置 isEdit_newValue 以显示建议替换效果
      suggestionFields.forEach(sf => {
        const fieldKey = sf.key;
        const suggestedValue = sf.suggestedValue || sf.value || '';
        const field = fieldMap.get(fieldKey);

        if (field) {
          // 设置建议值到 isEdit_newValue，用于显示建议替换效果
          this.$set(field, 'isEdit_newValue', suggestedValue);
          // 同时保留 suggestedValue 用于其他用途
          field.suggestedValue = suggestedValue;
        } else {
          // 如果找不到匹配的字段，创建新字段
          this.dischargeData.fields.push({
            key: fieldKey,
            label: sf.label || fieldKey,
            value: '',
            suggestedValue: suggestedValue,
            isEdit_newValue: suggestedValue
          });
        }
      });

      // 触发视图更新
      this.$forceUpdate();
    },

    /* 处理字段失焦保存（防抖保存，不重新加载数据，避免刷新其他编辑框） */
    handleFieldSave() {
      // 标记当前标签的数据已被修改
      this.markTabAsModified();

      // 清除之前的防抖定时器
      if (this.saveDebounceTimer) {
        clearTimeout(this.saveDebounceTimer);
      }

      // 设置防抖定时器，500ms 后保存（避免频繁保存）
      this.saveDebounceTimer = setTimeout(async () => {
        try {
          // 失焦保存时不重新加载数据，避免刷新其他正在编辑的字段
          await this.saveRecord(false, false);

          // 保存成功后，检查是否还有未处理的AI建议
          // 如果没有未处理的建议了，说明这是最后一个操作，显示提示
          // 如果有未处理的建议，说明用户还在操作中，不显示提示（避免干扰）
          if (!this.hasSuggestions) {
            this.$message.success('已保存');
          }
        } catch (err) {
          console.error('失焦自动保存失败:', err);
          // 保存失败时不提示，避免干扰用户操作
        }
        this.saveDebounceTimer = null;
      }, 500);
    },

    /* 检查当前标签是否有已接受但未保存的修改 */
    hasUnsavedAcceptedChanges() {
      if (!this.itemCacheChatData?.id) {
        return false;
      }
      // 直接使用修改标记来判断，而不是检查内容
      return this.tabModifiedFlags[this.activeTab] || false;
    },

    /* 标记当前标签的数据已被修改 */
    markTabAsModified() {
      if (this.activeTab && this.tabModifiedFlags.hasOwnProperty(this.activeTab)) {
        this.tabModifiedFlags[this.activeTab] = true;
      }
    },

    /* 标记当前标签的数据已保存（清除修改标记） */
    markTabAsSaved() {
      if (this.activeTab && this.tabModifiedFlags.hasOwnProperty(this.activeTab)) {
        this.tabModifiedFlags[this.activeTab] = false;
      }
    },

    /* 检查是否没有病历数据 */
    checkHasNoMedicalData() {
      if (this.activeTab === 'admission') {
        const fields = this.admissionData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'progress') {
        const fields = this.progressData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'first_progress') {
        const fields = this.firstProgressData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'daily_progress') {
        const fields = this.dailyProgressData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'doctor_progress') {
        const fields = this.doctorProgressData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'physical') {
        const fields = this.physicalExamData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      } else if (this.activeTab === 'discharge') {
        const fields = this.dischargeData.fields || [];
        return fields.length === 0 || fields.every(f => !f.value || String(f.value).trim() === '');
      }
      return true;
    },

    /* 创建空字段并填充AI建议 */
    async createEmptyFieldsWithSuggestions(suggestionFields) {
      if (this.activeTab === 'admission') {
        // 从模板获取字段
        const templateFields = await this.getFieldTemplate(1); // 入院记录的 chatGroup 是 1
        if (templateFields.length > 0) {
          this.admissionData.fields = templateFields.map(f => ({
            ...f,
            value: '',
            isEdit_newValue: null
          }));
        } else {
          // 如果模板为空，使用默认字段（兜底）
          this.admissionData.fields = [
            { key: 'chiefComplaint', label: '主诉', value: '', suggestedValue: null, isEdit_newValue: null },
            { key: 'presentIllness', label: '现病史', value: '', suggestedValue: null, isEdit_newValue: null },
            { key: 'pastHistory', label: '既往史', value: '', suggestedValue: null, isEdit_newValue: null }
          ];
        }
        // 填充建议
        await this.mergeSuggestionsToAdmission(suggestionFields);
      } else if (this.activeTab === 'progress') {
        const noteTime = this.getCurrentDateTimeString();
        this.progressData.fields = [
          { key: 'noteTime', label: '记录时间', value: noteTime, suggestedValue: null, isEdit_newValue: null },
          // 移除 title 字段
          { key: 'content', label: '内容', value: '', suggestedValue: null, isEdit_newValue: null }
        ];
        await this.mergeSuggestionsToProgress(suggestionFields);
      } else if (this.activeTab === 'first_progress' || this.activeTab === 'daily_progress' || this.activeTab === 'doctor_progress') {
        // 三个新病程标签使用相同的逻辑，从模板获取字段（chatGroup=2，3,4）
        const chatGroup = this.activeTab === 'first_progress' ? 2 : this.activeTab === 'daily_progress' ? 3 : 4;
        const templateFields = await this.getFieldTemplate(chatGroup); // 首次病程、日常病程、上级医师查房记录的 chatGroup 是 2，3,4
        if (templateFields.length > 0) {
          const fields = templateFields.map(f => ({
            ...f,
            value: '',
            isEdit_newValue: null
          }));
          if (this.activeTab === 'first_progress') {
            this.firstProgressData.fields = fields;
            await this.mergeSuggestionsToProgress(suggestionFields, 'first_progress');
          } else if (this.activeTab === 'daily_progress') {
            this.dailyProgressData.fields = fields;
            await this.mergeSuggestionsToProgress(suggestionFields, 'daily_progress');
          } else if (this.activeTab === 'doctor_progress') {
            this.doctorProgressData.fields = fields;
            await this.mergeSuggestionsToProgress(suggestionFields, 'doctor_progress');
          }
        } else {
          // 如果模板为空，使用空数组（避免显示错误的字段）
          if (this.activeTab === 'first_progress') {
            this.firstProgressData.fields = [];
          } else if (this.activeTab === 'daily_progress') {
            this.dailyProgressData.fields = [];
          } else if (this.activeTab === 'doctor_progress') {
            this.doctorProgressData.fields = [];
          }
        }
      } else if (this.activeTab === 'physical') {
        this.physicalExamData.fields = [
          { key: 'temperatureC', label: '体温(℃)', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'pulseBpm', label: '脉搏(次/分)', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'respirationBpm', label: '呼吸(次/分)', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'bloodPressure', label: '血压', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'heightCm', label: '身高(cm)', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'weightKg', label: '体重(kg)', value: '', suggestedValue: null, isEdit_newValue: null },
          { key: 'description', label: '描述', value: '', suggestedValue: null, isEdit_newValue: null }
        ];
        this.mergeSuggestionsToPhysical(suggestionFields);
      } else if (this.activeTab === 'discharge') {
        // 出院记录：从模板获取字段（需要确认chatGroup，可能是5）
        const templateFields = await this.getFieldTemplate(5); // 出院记录的 chatGroup 是 5
        if (templateFields.length > 0) {
          this.dischargeData.fields = templateFields.map(f => ({
            ...f,
            value: '',
            isEdit_newValue: null
          }));
        } else {
          // 如果模板为空，使用空数组（避免显示错误的字段）
          this.dischargeData.fields = [];
        }
        await this.mergeSuggestionsToDischarge(suggestionFields);
      }
    },

    /* 全部接受AI建议 */
    handleAcceptAll() {
      let acceptedCount = 0;
      let fields = [];

      if (this.activeTab === 'admission') {
        fields = this.admissionData.fields || [];
      } else if (this.activeTab === 'progress') {
        fields = this.progressData.fields || [];
      } else if (this.activeTab === 'first_progress') {
        fields = this.firstProgressData.fields || [];
      } else if (this.activeTab === 'daily_progress') {
        fields = this.dailyProgressData.fields || [];
      } else if (this.activeTab === 'doctor_progress') {
        fields = this.doctorProgressData.fields || [];
      } else if (this.activeTab === 'physical') {
        fields = this.physicalExamData.fields || [];
      } else if (this.activeTab === 'discharge') {
        fields = this.dischargeData.fields || [];
      }

      fields.forEach(field => {
        const suggestion = field.isEdit_newValue || field.suggestedValue;
        if (suggestion && suggestion !== '未提供') {
          // 必须同时清空 isEdit_newValue 与 suggestedValue，
          // 否则子组件 deep watch 会用 suggestedValue 把对比框重新渲染出来
          this.$set(field, 'value', suggestion);
          this.$set(field, 'originalValue', suggestion);
          this.$set(field, 'isEdit_newValue', null);
          this.$set(field, 'suggestedValue', null);
          acceptedCount++;
        }
      });

      if (acceptedCount > 0) {
        // 标记当前标签的数据已被修改
        this.markTabAsModified();
        this.$forceUpdate();
        this.saveRecord(); // 保存病历
        this.$message.success(`已接受 ${acceptedCount} 个AI建议并保存`);
      } else {
        this.$message.warning('没有可接受的AI建议');
      }
    },

    /* 全部拒绝AI建议 */
    handleRejectAll() {
      let rejectedCount = 0;
      let fields = [];

      if (this.activeTab === 'admission') {
        fields = this.admissionData.fields || [];
      } else if (this.activeTab === 'progress') {
        fields = this.progressData.fields || [];
      } else if (this.activeTab === 'first_progress') {
        fields = this.firstProgressData.fields || [];
      } else if (this.activeTab === 'daily_progress') {
        fields = this.dailyProgressData.fields || [];
      } else if (this.activeTab === 'doctor_progress') {
        fields = this.doctorProgressData.fields || [];
      } else if (this.activeTab === 'physical') {
        fields = this.physicalExamData.fields || [];
      } else if (this.activeTab === 'discharge') {
        fields = this.dischargeData.fields || [];
      }

      // 使用 $set 确保响应式更新，移除所有建议
      fields.forEach((field) => {
        const suggestion = field.isEdit_newValue || field.suggestedValue;
        if (suggestion && suggestion !== '未提供') {
          this.$set(field, 'isEdit_newValue', null);
          this.$set(field, 'suggestedValue', null);
          rejectedCount++;
        }
      });

      // 强制触发视图更新
      if (this.activeTab === 'admission') {
        this.$forceUpdate();
      } else if (this.activeTab === 'progress') {
        this.$forceUpdate();
      } else if (this.activeTab === 'first_progress') {
        this.$forceUpdate();
      } else if (this.activeTab === 'daily_progress') {
        this.$forceUpdate();
      } else if (this.activeTab === 'doctor_progress') {
        this.$forceUpdate();
      } else if (this.activeTab === 'physical') {
        this.$forceUpdate();
      } else if (this.activeTab === 'discharge') {
        this.$forceUpdate();
      }

      if (rejectedCount > 0) {
        this.$message.success(`已拒绝 ${rejectedCount} 个AI建议`);
      } else {
        this.$message.warning('没有可拒绝的AI建议');
      }
    },

    /* 合并AI建议到体格检查 */
    mergeSuggestionsToPhysical(suggestionFields) {
      // 如果当前没有 fields，先创建标准字段
      if (!this.physicalExamData.fields || this.physicalExamData.fields.length === 0) {
        this.physicalExamData.fields = [
          { key: 'temperatureC', label: '体温(℃)', value: this.physicalExamData.temperature || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'pulseBpm', label: '脉搏(次/分)', value: this.physicalExamData.pulse || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'respirationBpm', label: '呼吸(次/分)', value: this.physicalExamData.respiration || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'bloodPressure', label: '血压', value: this.physicalExamData.bloodPressure || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'heightCm', label: '身高(cm)', value: this.physicalExamData.height || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'weightKg', label: '体重(kg)', value: this.physicalExamData.weight || '', suggestedValue: null, isEdit_newValue: null },
          { key: 'description', label: '描述', value: this.physicalExamData.description || '', suggestedValue: null, isEdit_newValue: null }
        ];
      }

      // 创建字段映射
      const fieldMap = new Map();
      this.physicalExamData.fields.forEach(f => {
        fieldMap.set(f.key, f);
      });

      // 处理AI建议 - 设置 isEdit_newValue 以显示建议替换效果
      suggestionFields.forEach(sf => {
        const fieldKey = sf.key;
        const suggestedValue = sf.suggestedValue || sf.value || '';
        const field = fieldMap.get(fieldKey);

        if (field) {
          // 设置建议值到 isEdit_newValue，用于显示建议替换效果
          this.$set(field, 'isEdit_newValue', suggestedValue);
          // 同时保留 suggestedValue 用于其他用途
          field.suggestedValue = suggestedValue;
        } else {
          // 如果找不到匹配的字段，创建新字段
          this.physicalExamData.fields.push({
            key: fieldKey,
            label: sf.label || fieldKey,
            value: '',
            suggestedValue: suggestedValue,
            isEdit_newValue: suggestedValue
          });
        }
      });

      // 触发视图更新
      this.$forceUpdate();
    },

    getCurrentDateTimeString() {
      return formatDateTime();
    },

    // ========== 录音相关 ==========
    handleUploadRecording(data) {
      console.log('上传录音:', data);
    },

    async handleShibie(audioBlob, chatGroup) {
      if (!audioBlob) {
        return this.$message.warning("没有录音数据");
      }

      // 显示loading状态
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在识别录音，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'large-loading'
      });

      try {
        // 构建上传参数
        const formData = new FormData();
        formData.append('file', audioBlob, `录音_${new Date().getTime()}.webm`);
        formData.append('name', `医患对话录音_${new Date().toLocaleString()}`);
        formData.append('description', '医生与患者对话录音');
        formData.append('category', 'consultation');
        formData.append('tags', '医患对话,症状描述,问诊记录');

        // 添加会话相关信息（此时已经确保有患者ID）
        if (this.itemCacheChatData?.chatId) {
          formData.append('chatId', this.itemCacheChatData.chatId);
        }
        formData.append('medmstrId', this.itemCacheChatData.id);
        // 从患者列表中获取科室ID并上传（后端用于按科室区分录音）
        if (this.itemCacheChatData?.departmentId) {
          formData.append('departmentId', this.itemCacheChatData.departmentId);
        }
        formData.append('role', 'doctor'); // 录音来自医生
        // 住院病历需要 chatGroup（根据标签页传入 1/2/3）
        const finalChatGroup = chatGroup !== undefined && chatGroup !== null && chatGroup !== '' ? chatGroup : this.currentChatGroup;
        if (finalChatGroup !== undefined && finalChatGroup !== null && finalChatGroup !== '') {
          formData.append('chatGroup', finalChatGroup);
        }
        formData.append('visitNum', this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '');

        // 调用统一的上传接口
        const resp = await request({
          url: '/ly/midRecord/upload',
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (resp && resp.success) {
          // 现在接口直接返回字符串，不再是对象
          const audioMessage = resp.result?.audioMessage;
          const extractedMessage = resp.result?.extractedMessage;
          // 保存音频文件路径供对话框使用（PC 播放优先使用 localAudioFilePath，相对 upload 路径）
          this.currentAudioFilePath = this.getAudioUrl(resp.result?.localAudioFilePath || resp.result?.audioFilePath || '');

          // 关闭loading
          loadingInstance.close();

          // 将结果写入本地状态，并打开弹窗，支持后续重新提取
          if (audioMessage || extractedMessage) {
            this.audioMessage = audioMessage || '';
            this.extractedMessage = extractedMessage || audioMessage || '';
            this.dialogFormVisible = true;
            this.$message.success('录音识别成功');
          }
        } else {
          loadingInstance.close();
          this.$message.error("语音识别失败：" + (resp?.message || "未知错误"));
        }
      } catch (error) {
        loadingInstance.close();
        console.error("录音识别过程出错：", error);
        this.$message.error("录音识别失败，请重试");
      }
    },

    /* 修改弹窗（重新编辑按钮点击事件） */
    async updateBtn(payload) {
      this.dialogFormVisible = true;
      // 如果传入的是完整消息对象
      if (payload && typeof payload === 'object') {
        this.audioMessage = payload.content || '';
        this.extractedMessage = payload.content || '';
        // 从消息中提取音频路径（如果存在），PC 播放优先 localAudioFilePath
        this.currentAudioFilePath = this.getAudioUrl(payload.localAudioFilePath || payload.audioFilePath || '');
      } else {
        // 兼容旧的方式，传入的是字符串
        const text = typeof payload === 'string' ? payload : '';
        this.audioMessage = text || '';
        this.extractedMessage = text || '';
        this.currentAudioFilePath = '';
      }
    },

    /* 重新提取录音文本（住院病历专用，isInpatient = true） */
    async reExtractMessage() {
      if (!this.audioMessage || this.audioMessage.trim() === '') {
        this.$message.warning('请先完成一次录音识别，或在文本框中输入内容');
        return;
      }

      if (!this.itemCacheChatData?.chatId) {
        this.$message.warning('请先选择患者并创建会话');
        return;
      }

      try {
        this.extractLoading = true;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: this.audioMessage,
          medmstrId: this.itemCacheChatData?.id || '',
          departmentId: this.itemCacheChatData?.departmentId || '',
          // 住院病历：按当前Tab传 chatGroup（1入院、2病程、3体格检查）
          chatGroup: this.currentChatGroup
        };

        const response = await request({
          url: '/ly/midRecord/extractedMessage',
          method: 'POST',
          data: payload
        });

        if (response && response.success && response.result) {
          this.extractedMessage = response.result;
          this.$message.success('内容提取成功');
        } else {
          this.$message.error(response?.message || '内容提取失败');
        }
      } catch (error) {
        console.error('重新提取内容失败:', error);
        this.$message.error('网络错误，内容提取失败');
      } finally {
        this.extractLoading = false;
      }
    },

    /* 将录音内容引用到当前住院病历（按钮：确定并引用到病历） */
    async handleRecordingApplyToMedical() {
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      if (!this.itemCacheChatData?.chatId) {
        this.$message.warning('请先创建会话');
        return;
      }

      const content = (this.extractedMessage || this.audioMessage || '').trim();
      if (!content) {
        this.$message.warning('录音内容为空');
        return;
      }

      this.recordingApplyLoading = true;
      this.dialogFormVisible = false;

      // 清空输入框
      this.audioMessage = "";
      this.extractedMessage = "";

      try {
        // 1. 先发送消息到聊天（调用 /ly/conversation/send）
        const tabType = this.getTabType();
        const response = await sendMessageLy({
          chatId: this.itemCacheChatData?.chatId,
          message: content, // 改为 message 参数
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.itemCacheChatData?.departmentId || '',
          // 住院病历特有的参数
          tabType: tabType,
          chatGroup: this.currentChatGroup,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        });

        // 格式化当前时间为 "YYYY-MM-DD HH:mm:ss" 格式
        const getCurrentTimeString = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        if (response.success) {
          const userMessage = {
            role: 'user',
            content: content,
            createTime: getCurrentTimeString(),
            senderType: 'doctor'
          };
          this.chatData_doctor.push(userMessage);

          // 处理AI回复
          if (response.result) {
            const aiMessage = {
              role: 'assistant',
              content: response.result.aiReturnMsg || response.result.content || '收到您的消息',
              createTime: getCurrentTimeString(),
              senderType: 'ai',
              id: response.result.messageId
            };
            this.chatData_doctor.push(aiMessage);
          }

          // 确保视图更新并滚动到底部
          this.$nextTick(() => {
            if (this.$refs.chatBoxDoctor && this.$refs.chatBoxDoctor.$refs.chat_dom) {
              const chatDom = this.$refs.chatBoxDoctor.$refs.chat_dom;
              chatDom.scrollTop = chatDom.scrollHeight;
            }
          });
        }

        // 2. 然后同步到病例区（调用 /ly/archive/create 接口）
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: content,
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          departmentId: this.itemCacheChatData?.departmentId || '',
          tabType: tabType,
          dataOrigin: '2',
          // 住院病历：按当前Tab传 chatGroup
          chatGroup: this.currentChatGroup,
          includeMedicalRecords: true,
          includeTestReports: false,
          includeHistoryChat: false,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        };

        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          console.log('API返回的建议字段:', suggestionFields);

          // 检查当前是否没有病历数据
          const hasNoMedicalData = this.checkHasNoMedicalData();

          if (hasNoMedicalData) {
            // 没有病历数据时，创建空字段并填充AI建议
            await this.createEmptyFieldsWithSuggestions(suggestionFields);
            this.$message.success('消息已发送并同步到病例');
          } else {
            // 已有病历数据时，合并AI建议（设置 isEdit_newValue）
            await this.mergeSuggestionsToCurrentTab(suggestionFields);
            this.$message.success('消息已发送并同步到病例');
          }
        } else {
          this.$message.warning(resp?.message || '消息已发送，但同步到病例失败');
        }
      } catch (e) {
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;
        console.error('同步到病例失败:', e);
        this.$message.warning('消息已发送，但同步到病例时出错');
      } finally {
        this.recordingApplyLoading = false;
      }
    },

    /* 将录音内容引用并保存&提交HIS（按钮：全部接受并提交HIS） */
    async handleRecordingAcceptAllAndSubmit() {
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      const content = (this.extractedMessage || this.audioMessage || '').trim();
      if (!content) {
        this.$message.warning('录音内容为空');
        return;
      }

      this.recordingSubmitLoading = true;
      this.dialogFormVisible = false;

      // 清空输入框
      this.audioMessage = "";
      this.extractedMessage = "";

      try {
        // 格式化当前时间为 "YYYY-MM-DD HH:mm:ss" 格式
        const getCurrentTimeString = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        // 1. 先发送消息到聊天
        const tabType = this.getTabType();
        const response = await sendMessageLy({
          chatId: this.itemCacheChatData?.chatId,
          message: content, // 改为 message 参数
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.itemCacheChatData?.departmentId || '',
          // 住院病历特有的参数
          tabType: tabType,
          chatGroup: this.currentChatGroup,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        });

        if (response.success) {
          const userMessage = {
            role: 'user',
            content: content,
            createTime: getCurrentTimeString(),
            senderType: 'doctor'
          };
          this.chatData_doctor.push(userMessage);

          if (response.result) {
            const aiMessage = {
              role: 'assistant',
              content: response.result.aiReturnMsg || response.result.content || '收到您的消息',
              createTime: getCurrentTimeString(),
              senderType: 'ai',
              id: response.result.messageId
            };
            this.chatData_doctor.push(aiMessage);
          }
        }

        // 2. 调用 /ly/archive/create 获取AI建议
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id;
        const payload = {
          chatId: this.itemCacheChatData.chatId,
          content: content,
          medmstrId: this.itemCacheChatData?.id || '',
          professionalId: professionalId,
          departmentId: this.itemCacheChatData?.departmentId || '',
          tabType: tabType,
          dataOrigin: '2',
          // 住院病历：按当前Tab传 chatGroup
          chatGroup: this.currentChatGroup,
          includeMedicalRecords: true,
          includeTestReports: false,
          includeHistoryChat: false,
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
        };

        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = true;
        const resp = await request({
          url: '/ly/archive/create',
          method: 'POST',
          data: payload
        });
        if (this.$refs.chatBoxDoctor) this.$refs.chatBoxDoctor.loading = false;

        if (resp && resp.success) {
          const suggestionFields = (resp.result && resp.result.fields) || [];
          const hasNoMedicalData = this.checkHasNoMedicalData();

          if (hasNoMedicalData) {
            await this.createEmptyFieldsWithSuggestions(suggestionFields);
          } else {
            await this.mergeSuggestionsToCurrentTab(suggestionFields);
          }

          // 3. 全部接受AI建议
          await new Promise(resolve => setTimeout(resolve, 500));
          this.handleAcceptAll();

          // 4. 保存病历
          await new Promise(resolve => setTimeout(resolve, 1000));
          await this.saveRecord();

          // 5. 提交到HIS
          await this.confirmHisSubmit();

          this.$message.success('所有操作已成功完成！');
        } else {
          this.$message.error(resp?.message || '同步到病例失败');
        }
      } catch (error) {
        console.error('录音内容保存并提交HIS失败:', error);
        this.$message.error('操作失败：' + (error.message || '未知错误'));
      } finally {
        this.recordingSubmitLoading = false;
      }
    },

    handleSelectTemplate(template) {
      this.selectedTemplateName = template;
    },

    handleRecordingStateChange(state) {
      this.recordingState = state;
    },

    /* 处理加载录音历史 */
    async handleLoadRecordingHistory(chatGroup) {
      // 检查是否选择了患者
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择一个患者才能查看录音历史');
        return;
      }

      try {
        const resp = await request({
          url: '/ly/conversation/recordingHistory',
          method: 'POST',
          data: {
            medmstrId: this.itemCacheChatData.id,
            professionalId: localStorage.getItem('userId') || this.userInfo?.id,
            pageNo: 1,
            pageSize: 10,
            // 住院病历需要 chatGroup（根据标签页传入 1/2/3）
            // 优先使用传入的 chatGroup，否则使用当前标签页对应的 chatGroup
            chatGroup: (chatGroup !== undefined && chatGroup !== null && chatGroup !== '') ? chatGroup : this.currentChatGroup,
            visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || ''
          }
        });

        if (resp && resp.success && resp.result && Array.isArray(resp.result.records)) {
          this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = resp.result.records);
        } else {
          this.$message.error(resp?.message || '获取录音历史失败');
          this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = []);
        }
      } catch (error) {
        console.error('加载录音历史失败:', error);
        this.$message.error('加载录音历史失败，请稍后重试');
        this.$refs.soundRecording && (this.$refs.soundRecording.recordingHistoryData = []);
      }
    },

    /* 将服务器本地路径转换为可访问的URL */
    convertFilePathToUrl(filePath) {
      if (!filePath || typeof filePath !== 'string') {
        return '';
      }

      // 如果已经是URL格式（http://或https://开头），直接返回
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        return filePath;
      }

      // 如果已经是相对路径（以/开头），直接返回（前端会自动拼接baseURL）
      if (filePath.startsWith('/')) {
        return filePath;
      }

      // 处理Windows路径（如 D:\opt\upFiles\record\...）
      // 或Linux路径（如 /opt/upFiles/record/...）
      let relativePath = filePath;

      // 如果是Windows路径（包含盘符，如 D:\ 或 D:/）
      if (/^[A-Za-z]:[\\/]/.test(filePath)) {
        // 提取相对路径部分（去掉盘符）
        relativePath = filePath.replace(/^[A-Za-z]:[\\/]/, '');
      }

      // 将反斜杠转换为正斜杠
      relativePath = relativePath.replace(/\\/g, '/');

      // 提取 upFiles 之后的部分（如果包含 upFiles）
      const upFilesIndex = relativePath.indexOf('upFiles');
      if (upFilesIndex !== -1) {
        relativePath = relativePath.substring(upFilesIndex);
      } else {
        // 如果没有找到 upFiles，尝试提取 record 之后的部分
        const recordIndex = relativePath.indexOf('record');
        if (recordIndex !== -1) {
          relativePath = 'upFiles/' + relativePath.substring(recordIndex);
        }
      }

      // 确保以 / 开头
      if (!relativePath.startsWith('/')) {
        relativePath = '/' + relativePath;
      }

      console.log('音频路径转换:', {
        原始路径: filePath,
        转换后: relativePath
      });

      return relativePath;
    },

    /* 处理选择录音历史记录（点击录音历史记录时打开录音内容弹窗） */
    handleSelectRecordingHistory(recordingItem) {
      if (!recordingItem || !recordingItem.aiReturnMsg) {
        this.$message.warning('录音内容为空');
        return;
      }

      // 将录音内容设置为当前编辑内容
      this.audioMessage = recordingItem.professionalSendMsg || '';
      // 暂时将两个字段都填充成一样的内容
      this.extractedMessage = recordingItem.aiReturnMsg || '';
      // 从录音记录中提取音频路径（PC 播放优先 localAudioFilePath）
      this.currentAudioFilePath = this.getAudioUrl(recordingItem.localAudioFilePath || recordingItem.audioFilePath || '');
      this.dialogFormVisible = true;

      this.$message.success('已加载录音历史内容');
    },

    /* 清空音频路径（弹窗关闭时调用） */
    clearAudioPath() {
      this.currentAudioFilePath = '';
      this.audioRetryLoading = false;
    },

    /* 重新上传音频 */
    async handleRetryRecording() {
      if (!this.currentAudioFilePath) {
        this.$message.error('没有可重新上传的音频文件');
        return;
      }

      this.audioRetryLoading = true;
      try {
        // 获取音频文件
        const response = await fetch(this.currentAudioFilePath);
        if (!response.ok) {
          throw new Error('获取音频文件失败');
        }
        const audioBlob = await response.blob();
        // 关闭当前对话框
        this.dialogFormVisible = false;

        // 使用原有的录音识别流程上传
        await this.handleShibie(audioBlob);

        this.$message.success('音频重新上传成功');
      } catch (error) {
        console.error('重新上传音频失败:', error);
        this.$message.error('重新上传音频失败：' + (error.message || '未知错误'));
      } finally {
        this.audioRetryLoading = false;
      }
    },

    /* OCR文件选择事件 */
    async handleOcrFileSelect(filesOrEvent) {
      const files = filesOrEvent?.target?.files ?? filesOrEvent;
      if (!files || files.length === 0) {
        return;
      }

      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      // 显示loading
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在上传并识别图片，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'large-loading'
      });

      try {
        // 构建FormData
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
        formData.append('medmstrId', this.itemCacheChatData.id);
        formData.append('professionalId', localStorage.getItem('userId') || this.userInfo?.id || '');
        formData.append('departmentId', this.itemCacheChatData?.departmentId || '');
        formData.append('chatGroup', this.currentChatGroup || '');
        formData.append('visitNum', this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '');
        formData.append('prompt', '帮我把图片内容变成文本'); // 默认提示词

        // 调用上传接口
        const resp = await request({
          url: '/ly/image/upload',
          method: 'POST',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        loadingInstance.close();

        if (resp && resp.success) {
          this.$message.success(`成功上传并识别 ${files.length} 张图片`);
          // 如果历史病历弹窗已打开，刷新图片记录列表
          if (this.historyModalVisible) {
            await this.loadHistoryModalNavigation();
          }
        } else {
          this.$message.error(resp?.message || '图片上传失败');
        }
      } catch (error) {
        loadingInstance.close();
        console.error('OCR上传失败:', error);
        this.$message.error('图片上传失败，请重试');
      }
    },

    /* 处理切换到聊天会话 */
    async handleSwitchToConversation(conversation) {
      if (!conversation || !conversation.id) {
        this.$message.error('会话信息不完整，无法切换。');
        return;
      }

      try {
        // 调用详情接口获取完整的聊天记录
        const res = await request({
          url: `/ly/conversation/detail`,
          method: "POST",
          data: {
            conversationId: conversation.id,
            // 住院病历：按当前Tab传 chatGroup
            chatGroup: this.currentChatGroup
          }
        });

        if (res && res.success && res.result) {
          const messages = res.result.conversationData || [];
          // 转换为chatData_doctor格式
          this.chatData_doctor = messages.map(m => ({
            role: m.senderType === 'doctor' ? 'user' : 'assistant',
            content: m.content,
            createTime: m.createTime,
            senderType: m.senderType,
            id: m.id
          }));

          // 更新当前选中的会话信息
          this.itemCacheChatData = {
            ...this.itemCacheChatData,
            chatId: conversation.id,
            id: conversation.medmstrId || this.itemCacheChatData.id
          };

          this.$message.success(`已切换到会话：${conversation.patientName || conversation.id}`);
        } else {
          this.$message.error(res?.message || '获取会话详情失败');
          this.chatData_doctor = [];
        }
      } catch (error) {
        console.error('切换会话失败:', error);
        this.$message.error('切换会话失败，请稍后再试。');
        this.chatData_doctor = [];
      }
    },

    /* 处理开始新的对话会话 */
    async handleStartNewConversation() {
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }

      try {
        await this.$confirm('开始新会话将清空当前对话记录，是否继续？', '确认开始新会话', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 清空当前对话记录
        this.chatData_doctor = [];

        // 创建新的会话ID
        const result = await createConversationLy({
          medmstrId: this.itemCacheChatData?.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          departmentId: this.itemCacheChatData?.departmentId || '',
          dataOrigin: '2', // 住院病历标识
          visitNum: this.itemCacheChatData?.visitNum || this.itemCacheChatData?.visitNumber || localStorage.getItem('visitNum') || '',
          chatGroup: this.currentChatGroup
        });

        if (result.success && result.code === 200) {
          // 更新chatId
          this.itemCacheChatData.chatId = result.result.chatId;

          // 同时更新classData中对应患者的chatId，确保子组件数据同步
          const patientIndex = this.classData.findIndex(item => item.id === this.itemCacheChatData.id);
          if (patientIndex !== -1) {
            this.$set(this.classData[patientIndex], 'chatId', result.result.chatId);
          }

          console.log('新会话创建成功，chatId:', result.result.chatId);
          this.$message.success('已开始新的对话会话');
        } else {
          this.$message.error(result.message || "创建新会话失败");
        }
      } catch (e) {
        // 用户取消
      }
    },

    // 停止录音详情轮询
    stopRecordingDetailPolling() {
      if (this.recordingDetailPollTimer) {
        clearInterval(this.recordingDetailPollTimer);
        this.recordingDetailPollTimer = null;
      }
      this.recordingDetailPollId = null;
      this.recordingDetailPollCount = 0;
    },

    // 启动录音详情轮询（用于重新识别后自动刷新识别结果）
    startRecordingDetailPolling(recordId) {
      if (!recordId) return;

      // 先停止已有轮询
      this.stopRecordingDetailPolling();

      this.recordingDetailPollId = recordId;
      this.recordingDetailPollCount = 0;

      const pollOnce = async () => {
        if (!this.recordingDetailPollId) return;
        if (!this.historyModalVisible) {
          this.stopRecordingDetailPolling();
          return;
        }

        this.recordingDetailPollCount += 1;
        if (this.recordingDetailPollCount > this.recordingDetailPollMax) {
          this.stopRecordingDetailPolling();
          this.$message.info('录音识别时间较长，请稍后在历史病历中手动刷新查看结果');
          return;
        }

        try {
          const resp = await request({
            url: '/ly/conversation/recordingDetail',
            method: 'POST',
            data: { id: this.recordingDetailPollId }
          });

          if (resp && resp.success && resp.result) {
            const result = resp.result;
            const status = result.recognizeStatus;

            // 仅在识别状态发生变化时更新界面
            if (this.historyModalDetail && this.historyModalDetail.id === this.recordingDetailPollId) {
              this.historyModalDetail = {
                ...this.historyModalDetail,
                ...result,
                extractedMessage: result.aiReturnMsg || this.historyModalDetail.extractedMessage || '',
                audioFilePath: result.audioFilePath || this.historyModalDetail.audioFilePath || '',
                recognizeStatus: status
              };
            }

            // 状态为成功(2)或失败(3)时停止轮询
            if (status === 2 || status === 3) {
              this.stopRecordingDetailPolling();
              // 同步刷新左侧录音列表，让状态一致
              if (this.historyModalVisible) {
                this.loadHistoryModalNavigation && this.loadHistoryModalNavigation();
              }
            }
          }
        } catch (e) {
          console.error('轮询录音详情失败:', e);
        }
      };

      // 立即执行一次，然后每3秒轮询
      pollOnce();
      this.recordingDetailPollTimer = setInterval(pollOnce, 3000);
    },

    // ========== 面板拖拽调整大小 ==========
    startResize(type) {
      this.isResizing = true;
      this.resizeType = type;
      this.startX = event.clientX;
      this.startLeftWidth = this.leftPanelWidth;
      this.startRightWidth = this.rightPanelWidth;
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },

    handleMouseMove(event) {
      if (!this.isResizing) return;
      const deltaX = event.clientX - this.startX;
      if (this.resizeType === 'left') {
        const newW = Math.max(200, Math.min(600, this.startLeftWidth + deltaX));
        const minSpaceForOthers = this.rightPanelWidth + 300;
        if (newW + minSpaceForOthers + 16 <= window.innerWidth) {
          this.leftPanelWidth = newW;
        }
      } else if (this.resizeType === 'middle') {
        const newW = Math.max(300, Math.min(600, this.startRightWidth - deltaX));
        const minSpaceForOthers = this.leftPanelWidth + 300;
        if (newW + minSpaceForOthers + 16 <= window.innerWidth) {
          this.rightPanelWidth = newW;
        }
      }
    },

    handleMouseUp() {
      if (this.isResizing) {
        this.isResizing = false;
        this.resizeType = '';
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      }
    },

    /* 加载标签列表 */
    async loadTabs() {
      try {
        // 从当前选中的患者数据中获取科室ID
        const departmentId = this.itemCacheChatData?.departmentId;
        if (!departmentId) {
          // 如果没有科室ID，直接返回（页面初始化时可能还没有选择患者）
          return;
        }
        const resp = await request({
          url: '/ly/inpatientRecord/tabs',
          method: 'POST',
          data: { department_id: departmentId }
        });
        if (resp && resp.success && Array.isArray(resp.result) && resp.result.length > 0) {
          this.availableTabs = resp.result;
          // 如果当前选中的标签不在新加载的标签列表中，则切换到第一个标签
          const currentTabExists = this.availableTabs.some(tab => tab.name === this.activeTab);
          if (!currentTabExists) {
            this.activeTab = this.availableTabs[0].name;
          }
        } else {
          // 接口返回空或失败时，使用默认标签
          this.availableTabs = [
            { name: 'admission', label: '入院记录' },
            { name: 'progress', label: '病程记录' },
            { name: 'discharge', label: '出院记录' }
          ];
        }
      } catch (error) {
        console.error('加载标签列表失败:', error);
        // 失败时使用默认标签
        this.availableTabs = [
          { name: 'admission', label: '入院记录' },
          { name: 'progress', label: '病程记录' },
          { name: 'discharge', label: '出院记录' }
        ];
      }
    },

    /* 打开历史病历弹窗 */
    async openHistoryModal() {
      if (!this.itemCacheChatData?.id) {
        this.$message.warning('请先选择患者');
        return;
      }
      this.historyModalVisible = true;
      // 先加载科室列表
      await this.loadHistoryModalDepartments();
      // 科室列表加载完成后，根据选中的科室加载就诊号列表
      await this.loadHistoryModalVisitNumbers();
      // 加载病例导航数据
      await this.loadHistoryModalNavigation();
      // 加载当前标签对应的病历模板选项
      await this.loadDocumentTemplateOptions();
    },

    /* 加载历史病历弹窗的科室列表 */
    async loadHistoryModalDepartments() {
      try {
        const requestData = {
          medmstrId: this.itemCacheChatData.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id
        };
        // 如果选择了就诊号，传入visitNum参数，用于将对应科室排在前面
        if (this.selectedVisitNum) {
          requestData.visitNum = this.selectedVisitNum;
        }
        const resp = await request({
          url: '/ly/inpatientRecord/patientDepartments',
          method: 'POST',
          data: requestData
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.historyModalDepartments = resp.result;
          if (resp.result.length > 0) {
            this.selectedDepartment = resp.result[0].id;
          }
        }
      } catch (error) {
        console.error('加载科室列表失败:', error);
      }
    },

    /* 加载历史病历弹窗的急诊号列表 */
    async loadHistoryModalVisitNumbers() {
      try {
        const requestData = {
          medmstrId: this.itemCacheChatData.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id
        };
        // 如果选择了科室，传入departmentId参数，用于按科室过滤就诊号
        if (this.selectedDepartment) {
          requestData.departmentId = this.selectedDepartment;
        }
        const resp = await request({
          url: '/ly/inpatientRecord/visitNumbers',
          method: 'POST',
          data: requestData
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.historyModalVisitNumbers = resp.result;
          if (resp.result.length > 0) {
            this.selectedVisitNum = resp.result[0].visitNum;
          } else {
            // 如果没有就诊号，清空选择
            this.selectedVisitNum = "";
          }
        }
      } catch (error) {
        console.error('加载急诊号列表失败:', error);
      }
    },

    /* 科室切换事件处理 */
    async handleDepartmentChange() {
      // 当科室切换时，重新加载就诊号列表
      await this.loadHistoryModalVisitNumbers();
      // 就诊号列表更新后，重新加载病例导航数据
      await this.loadHistoryModalNavigation();
    },

    /* 就诊号切换事件处理 */
    async handleVisitNumChange() {
      // 当就诊号切换时，重新加载病例导航数据
      await this.loadHistoryModalNavigation();
    },

    /* 加载历史病历弹窗的病例导航 */
    async loadHistoryModalNavigation() {
      try {
        // 从就诊号下拉列表中提取visitNum（取空格前的部分）
        let visitNum = null;
        if (this.selectedVisitNum) {
          // 就诊号格式：visitNum + " " + 时间，需要提取空格前的部分
          const spaceIndex = this.selectedVisitNum.indexOf(' ');
          visitNum = spaceIndex > 0 ? this.selectedVisitNum.substring(0, spaceIndex) : this.selectedVisitNum;
        }

        // 如果就诊号为空，清空数据并直接返回，不调用接口
        if (!visitNum || visitNum.trim() === '') {
          this.historyModalNavigation.outpatientList = [];
          this.historyModalNavigation.admissionList = [];
          this.historyModalNavigation.firstProgressList = [];
          this.historyModalNavigation.dailyProgressList = [];
          this.historyModalNavigation.doctorProgressList = [];
          this.historyModalNavigation.dischargeList = [];
          this.historyModalNavigation.testList = [];
          this.historyModalNavigation.recordingList = [];
          this.historyModalNavigation.imageList = [];
          this.historyModalDetail = null; // 清空详情
          return;
        }

        const baseData = {
          medmstrId: this.itemCacheChatData.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          dataOrigin: 3,
          pageNum: 1,
          pageSize: 100,
          visitNum: visitNum
        };
        // medicalSource：当只选一个来源时才传；两个都选或都不选时不传
        if (this.historySourceHisChecked !== this.historySourceLocalChecked) {
          baseData.medicalSource = this.historySourceHisChecked ? 1 : 2;
        }

        // 加载医生文书列表（包括门诊病历和入院记录）
        const archiveResp = await request({
          url: '/ly/archive/history',
          method: 'POST',
          data: baseData
        });

        // 初始化列表
        this.historyModalNavigation.outpatientList = [];
        this.historyModalNavigation.admissionList = [];

        if (archiveResp && archiveResp.success && Array.isArray(archiveResp.result)) {
          // 根据 dataOrigin 分类：空或1为门诊病历，2为入院记录
          archiveResp.result.forEach(item => {
            const processedItem = {
              ...item,
              displayName: item.primaryDiagnosis || `${this.formatDateForHistory(item.visitDate || item.createTime)}${item.dataOrigin === '2' ? '入院记录' : '门诊病历'}`,
              type: item.dataOrigin === '2' ? '入院记录' : '门诊病历'
            };

            if (item.dataOrigin === '2') {
              // 入院记录
              this.historyModalNavigation.admissionList.push(processedItem);
            } else {
              // 门诊病历（dataOrigin 为空或1）
              this.historyModalNavigation.outpatientList.push(processedItem);
            }
          });
        }

        // 加载病程列表（包括首次病程、日常病程、上级医师查房记录）
        const progressResp = await request({
          url: '/ly/lyInpatientCourseNotes/history',
          method: 'POST',
          data: {
            ...baseData,
            dataOrigin: '' // 设置为空串，查询所有病程类型
          }
        });

        // 初始化病程列表
        this.historyModalNavigation.firstProgressList = [];
        this.historyModalNavigation.dailyProgressList = [];
        this.historyModalNavigation.doctorProgressList = [];

        if (progressResp && progressResp.success && Array.isArray(progressResp.result)) {
          // 根据 dataOrigin 分类：2为首次病程，3为日常病程，4为上级医师查房记录
          progressResp.result.forEach(item => {
            const processedItem = {
              ...item,
              displayName: item.content || `${this.formatDateForHistory(item.noteTime)}病程记录`,
              type: item.dataOrigin === '2' ? '首次病程记录' : (item.dataOrigin === '3' ? '日常病程记录' : '上级医师查房记录')
            };

            if (item.dataOrigin === '2') {
              // 首次病程记录
              this.historyModalNavigation.firstProgressList.push(processedItem);
            } else if (item.dataOrigin === '3') {
              // 日常病程记录
              this.historyModalNavigation.dailyProgressList.push(processedItem);
            } else if (item.dataOrigin === '4') {
              // 上级医师查房记录
              this.historyModalNavigation.doctorProgressList.push(processedItem);
            }
          });
        }

        // 加载出院记录列表
        const dischargeResp = await request({
          url: '/ly/lyInpatientDischargeNotes/history',
          method: 'POST',
          data: baseData
        });

        this.historyModalNavigation.dischargeList = [];

        if (dischargeResp && dischargeResp.success && Array.isArray(dischargeResp.result)) {
          this.historyModalNavigation.dischargeList = dischargeResp.result.map(item => ({
            ...item,
            displayName: item.content || `${this.formatDateForHistory(item.dischargeTime)}出院记录`,
            type: '出院记录'
          }));
        }

        // 加载检验列表
        const testData = {
          departmentId: this.selectedDepartment || this.itemCacheChatData?.departmentId || '',
          medmstrId: this.itemCacheChatData.id,
          pageNum: 1,
          pageSize: 100
        };
        const testResp = await request({
          url: '/ly/healthTestReports/testReports',
          method: 'POST',
          data: testData
        });
        if (testResp && testResp.success && Array.isArray(testResp.result)) {
          console.log('检验列表接口返回数据:', testResp.result);
          const testList = testResp.result.map(item => {
            // 构建显示名称：优先使用 testType，如果有 reviewTime 则加上时间
            let displayName = item.testType || item.reportConclusion || item.testPurpose || '检验报告';
            if (item.reviewTime) {
              const dateStr = this.formatDateForHistory(item.reviewTime);
              displayName = `${dateStr}${displayName}`;
            }
            return {
              ...item,
              type: '检验报告',
              displayName: displayName
            };
          });
          // 使用 $set 确保响应式更新
          this.$set(this.historyModalNavigation, 'testList', testList);
          console.log('处理后的检验列表:', this.historyModalNavigation.testList);
        } else {
          // 使用 $set 确保响应式更新
          this.$set(this.historyModalNavigation, 'testList', []);
          console.log('检验列表接口返回数据为空或格式不正确:', testResp);
        }

        // 加载录音记录列表
        // 历史病历弹窗中加载录音记录时，标记来源于购物车（fromCart = true）
        const recordingData = {
          medmstrId: this.itemCacheChatData.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          pageNo: 1,
          pageSize: 100,
          visitNum: visitNum,
          chatGroup: this.currentChatGroup || '',
          fromCart: true
        };
        try {
          const recordingResp = await request({
            url: '/ly/conversation/recordingHistory',
            method: 'POST',
            data: recordingData
          });
          if (recordingResp && recordingResp.success && Array.isArray(recordingResp.result?.records)) {
            const recordingList = recordingResp.result.records.map(item => ({
              ...item,
              type: '录音记录',
              displayName: `${this.formatRecordingDateTime(item.createTime)}录音记录`
            }));
            this.$set(this.historyModalNavigation, 'recordingList', recordingList);
          } else {
            this.$set(this.historyModalNavigation, 'recordingList', []);
          }
        } catch (error) {
          console.error('加载录音记录失败:', error);
          this.$set(this.historyModalNavigation, 'recordingList', []);
        }

        // 加载图片记录列表
        const imageData = {
          medmstrId: this.itemCacheChatData.id,
          professionalId: localStorage.getItem('userId') || this.userInfo?.id,
          pageNo: 1,
          pageSize: 100,
          visitNum: visitNum,
          chatGroup: this.currentChatGroup || ''
        };
        try {
          const imageResp = await request({
            url: '/ly/image/history',
            method: 'POST',
            data: imageData
          });
          if (imageResp && imageResp.success && Array.isArray(imageResp.result?.records)) {
            const imageList = imageResp.result.records.map(item => ({
              ...item,
              type: '图片记录',
              displayName: item.title || `${this.formatDateForHistory(item.createTime)}图片记录`
            }));
            this.$set(this.historyModalNavigation, 'imageList', imageList);
          } else {
            this.$set(this.historyModalNavigation, 'imageList', []);
          }
        } catch (error) {
          console.error('加载图片记录失败:', error);
          this.$set(this.historyModalNavigation, 'imageList', []);
        }
      } catch (error) {
        console.error('加载病例导航失败:', error);
        // 出错时也清空数据
        this.historyModalNavigation.outpatientList = [];
        this.historyModalNavigation.admissionList = [];
        this.historyModalNavigation.firstProgressList = [];
        this.historyModalNavigation.dailyProgressList = [];
        this.historyModalNavigation.doctorProgressList = [];
        this.historyModalNavigation.dischargeList = [];
        this.historyModalNavigation.testList = [];
        this.historyModalNavigation.recordingList = [];
        this.historyModalNavigation.imageList = [];
        this.historyModalDetail = null;
      }
    },

    /* 格式化日期用于历史记录显示 */
    formatDateForHistory(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    /* 录音记录专用：格式化为 YYYYMMDDHHmm（用于标题前缀） */
    formatRecordingDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      return `${year}${month}${day}${hour}${minute}`;
    },

    /* 获取图片URL（将相对路径转换为可访问的URL） */
    getImageUrl(imagePath) {
      if (!imagePath) return '';

      // PC 本地静态目录直通：/upload/... 或 upload/...
      if (typeof imagePath === 'string') {
        const trimmed = imagePath.trim();
        if (trimmed.startsWith('upload/')) {
          return '/' + trimmed;
        }
        if (trimmed.startsWith('/upload/')) {
          return trimmed;
        }
      }

      // 如果已经是完整URL（http://或https://开头），直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      // 如果是OSS URL（包含OSS域名），直接返回
      if (imagePath.includes('oss-') || imagePath.includes('aliyuncs.com')) {
        return imagePath;
      }

      // 获取基础URL（从配置或环境变量获取）
      const baseUrl = process.env.VUE_APP_BASE_API || '';

      // 确保路径以 / 开头
      let path = imagePath;
      if (!path.startsWith('/')) {
        path = '/' + path;
      }

      // 如果路径包含 upload/opt/upFiles，直接拼接（兼容旧数据）
      if (path.includes('upload/opt/upFiles') || path.startsWith('/upload/opt/upFiles')) {
        return baseUrl + path;
      }

      // 如果路径包含 opt/upFiles，添加 /upload 前缀（新格式）
      if (path.includes('opt/upFiles') || path.startsWith('/opt/upFiles')) {
        return baseUrl + '/upload' + path;
      }

      // 如果路径包含 upFiles，添加 /upload/opt 前缀（兼容格式）
      if (path.includes('upFiles')) {
        // 如果路径是 /upFiles/...，替换为 /upload/opt/upFiles/...
        if (path.startsWith('/upFiles/')) {
          return baseUrl + '/upload/opt' + path;
        }
        return baseUrl + '/upload/opt/upFiles' + path;
      }

      // 如果路径是 image/... 格式（旧格式，缺少 opt/upFiles 前缀），添加完整前缀
      if (path.startsWith('/image/') || path.startsWith('image/')) {
        // 移除开头的 /，然后添加完整前缀
        const cleanPath = path.startsWith('/') ? path.substring(1) : path;
        return baseUrl + '/upload/opt/upFiles/' + cleanPath;
      }

      // 否则添加 /upload/opt/upFiles/ 前缀（默认处理）
      return baseUrl + '/upload/opt/upFiles' + path;
    },

    /* 获取音频URL（将相对路径转换为可访问的URL） */
    getAudioUrl(audioPath) {
      if (!audioPath) return '';

      const trimmed = String(audioPath).trim().replace(/\\/g, '/');
      if (!trimmed) return '';

      // PC / 院内：upload 走同域相对路径（nginx /upload/），勿拼绝对公网域名
      if (trimmed.startsWith('upload/')) {
        return '/' + trimmed;
      }
      if (trimmed.startsWith('/upload/')) {
        return trimmed;
      }

      // 完整 URL / OSS：仅作兜底（院内优先应走 localAudioFilePath 相对路径）
      if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return trimmed;
      }
      if (trimmed.includes('oss-') || trimmed.includes('aliyuncs.com')) {
        return trimmed;
      }

      let path = trimmed.startsWith('/') ? trimmed : '/' + trimmed;

      // EXE ASR 流式代理：库内为 /ly/asrRecordingAsset/stream/xxx.wav
      // 须补 API 上下文（生产 /medisyn-hub，开发 /proxy-server），同域可播；
      // 院内 https://129.x 经 nginx 反代到后端时同样生效。切勿拼 /upFiles。
      const asrMarker = '/ly/asrRecordingAsset/stream';
      const asrIdx = path.indexOf(asrMarker);
      if (asrIdx >= 0) {
        const streamRelative = path.substring(asrIdx);
        const apiBase = String(BASE_URL || '/medisyn-hub').replace(/\/$/, '');
        return apiBase + streamRelative;
      }

      const baseUrl = process.env.VUE_APP_BASE_API || '';

      // 如果是 upFiles 路径，直接拼接
      if (path.includes('upFiles')) {
        return baseUrl + path;
      }

      // 否则添加 /upFiles/ 前缀
      return baseUrl + '/upFiles' + path;
    },

    /** 录音详情 UI 状态：recognizing | failed | success */
    getRecordingUiState(detail) {
      if (!detail) return 'unknown';
      const status = detail.recognizeStatus;
      if (status === 0 || status === 1) return 'recognizing';
      if (status === 3) return 'failed';
      if (status === 2) return 'success';
      return 'unknown';
    },

    getRecordingContentText(detail) {
      if (!detail) return '';
      const text = detail.extractedMessage || detail.aiReturnMsg || '';
      return String(text).trim();
    },

    hasPlayableRecordingAudio(detail) {
      if (!detail) return false;
      const path = detail.localAudioFilePath || detail.audioFilePath || '';
      return String(path).trim().length > 0;
    },

    /* 格式化OCR内容，将 | 分隔的表格或检验结果文本转换为HTML表格 */
    formatOcrContent(content) {
      if (!content) return '';

      // 检查是否是合并内容（包含 "### 第X张：" 标记）
      if (content.includes('### 第')) {
        return this.formatMergedOcrContent(content);
      }

      // 预处理行
      const rawLines = content.split('\n');
      const trimmedLines = rawLines.map(l => l.trim()).filter(l => l);

      // 1）尝试解析处方明细（“破伤风人免疫球蛋白：规格A 250IU 2.5ml/瓶，数量1瓶，医保类别有自付...”）为表格
      const prescriptionLines = trimmedLines.filter(line =>
        line.includes('规格') &&
        line.includes('数量') &&
        (line.includes('用法') || line.includes('单次用量'))
      );
      if (prescriptionLines.length >= 2) {
        const prescriptionRows = prescriptionLines.map(line => this.parsePrescriptionLine(line));
        return this.renderPrescriptionTable(prescriptionRows);
      }

      // 2）优先尝试解析“1 白球比例：1.7，参考范围1.4~2.4”这种检验结果为结构化表格
      const labLines = trimmedLines.filter(line => /^\d+\s+/.test(line) && line.includes('参考范围'));
      if (labLines.length >= 3) {
        const labRows = labLines.map(line => {
          // 提取序号和后半部分
          const m = line.match(/^(\d+)\s+(.+)$/);
          const rest = m ? m[2] : line;

          // 名称 与 “名称：...” 之后内容
          const [namePart, valueAndRefPartRaw] = rest.split('：');
          const itemName = (namePart || '').trim();
          const valueAndRefPart = (valueAndRefPartRaw || '').trim();

          // 结果值 + 单位（可选），例如 "15.2umol/L，参考范围0.0~23.0umol/L"
          const valueMatch = valueAndRefPart.match(/^([\d.]+)([a-zA-Z\/%μ]*)(.*)$/);
          const value = valueMatch ? valueMatch[1] : '';
          const unit = valueMatch ? (valueMatch[2] || '') : '';
          const tail = valueMatch ? valueMatch[3] : valueAndRefPart;

          // 参考范围
          let refRange = '';
          const refMatch = tail.match(/参考范围([^，\n]+)/);
          if (refMatch) {
            refRange = refMatch[1].trim();
          }

          // 异常标记（例如 结果异常（↓））
          let abnormalFlag = '';
          const abnMatch = tail.match(/（(.+?)）/);
          if (abnMatch) {
            abnormalFlag = abnMatch[1].trim();
          }

          return {
            itemName,
            value,
            unit,
            refRange,
            abnormalFlag
          };
        });

        return this.renderLabResultTable(labRows);
      }

      // 3）默认按 | 分隔的 Markdown 表格 + 段落渲染
      const lines = rawLines;
      let result = '';
      let inTable = false;
      let tableRows = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();

        // 检测表格行（包含 | 分隔符）
        if (line.includes('|') && line.split('|').length >= 3) {
          // 跳过分隔行（如 |------|------|）
          if (line.match(/^\|[\s\-:]+\|/)) {
            continue;
          }

          if (!inTable) {
            inTable = true;
            tableRows = [];
          }

          // 解析表格行
          const cells = line.split('|').map(cell => cell.trim()).filter(cell => cell);
          tableRows.push(cells);
        } else {
          // 如果不是表格行，先处理之前的表格
          if (inTable && tableRows.length > 0) {
            result += this.renderTable(tableRows);
            tableRows = [];
            inTable = false;
          }

          // 处理普通文本
          if (line) {
            result += '<p>' + this.escapeHtml(line) + '</p>';
          } else {
            result += '<br>';
          }
        }
      }

      // 处理最后可能存在的表格
      if (inTable && tableRows.length > 0) {
        result += this.renderTable(tableRows);
      }

      return result;
    },

    /* 格式化合并的OCR内容（多张图片合并） */
    formatMergedOcrContent(mergedContent) {
      if (!mergedContent) return '';

      const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      };

      let result = '';
      // 按 "### 第" 分割
      const parts = mergedContent.split('### 第');

      // 第一个元素可能是空字符串或非图片内容
      if (parts[0] && parts[0].trim()) {
        result += '<p>' + escapeHtml(parts[0].trim()) + '</p>';
      }

      // 处理每个图片的内容
      for (let i = 1; i < parts.length; i++) {
        let part = parts[i].trim();
        if (!part) continue;

        // 提取标题（第一行是 "X张：标题"）
        let title = '';
        let content = '';
        const firstNewline = part.indexOf('\n');
        if (firstNewline > 0) {
          title = part.substring(0, firstNewline).trim();
          content = part.substring(firstNewline).trim();
        } else {
          // 如果没有换行，尝试提取到第一个冒号
          const colonIndex = part.indexOf('：');
          if (colonIndex > 0) {
            title = part.substring(0, colonIndex + 1).trim();
            content = part.substring(colonIndex + 1).trim();
          } else {
            content = part;
          }
        }

        // 添加图片标题
        if (title) {
          result += '<div class="image-section">';
          result += '<h4 class="image-title">' + escapeHtml(title) + '</h4>';
        }

        // 处理内容（表格和文本）
        const lines = content.split('\n');
        let inTable = false;
        let tableRows = [];

        for (let j = 0; j < lines.length; j++) {
          const line = lines[j].trim();

          // 检测表格行
          if (line.includes('|') && line.split('|').length >= 3) {
            // 跳过分隔行
            if (line.match(/^\|[\s\-:]+\|/)) {
              continue;
            }

            if (!inTable) {
              inTable = true;
              tableRows = [];
            }

            const cells = line.split('|').map(cell => cell.trim()).filter(cell => cell);
            tableRows.push(cells);
          } else {
            // 处理之前的表格
            if (inTable && tableRows.length > 0) {
              result += this.renderTable(tableRows);
              tableRows = [];
              inTable = false;
            }

            // 处理普通文本
            if (line) {
              result += '<p>' + escapeHtml(line) + '</p>';
            } else {
              result += '<br>';
            }
          }
        }

        // 处理最后可能存在的表格
        if (inTable && tableRows.length > 0) {
          result += this.renderTable(tableRows);
        }

        if (title) {
          result += '</div>';
        }
      }

      return result;
    },

    /* 渲染表格HTML */
    renderTable(rows) {
      if (!rows || rows.length === 0) return '';

      let html = '<table class="ocr-table">';

      // 第一行作为表头
      if (rows.length > 0) {
        html += '<thead><tr>';
        rows[0].forEach(cell => {
          html += '<th>' + this.escapeHtml(cell) + '</th>';
        });
        html += '</tr></thead>';
      }

      // 其余行作为表体
      if (rows.length > 1) {
        html += '<tbody>';
        for (let i = 1; i < rows.length; i++) {
          html += '<tr>';
          rows[i].forEach(cell => {
            html += '<td>' + this.escapeHtml(cell) + '</td>';
          });
          html += '</tr>';
        }
        html += '</tbody>';
      }

      html += '</table>';
      return html;
    },

    /* 将检验结果列表渲染为表格HTML */
    renderLabResultTable(rows) {
      if (!rows || rows.length === 0) return '';

      let html = '<table class="ocr-table lab-result-table">';

      // 表头
      html += '<thead><tr>';
      html += '<th>项目</th>';
      html += '<th>结果</th>';
      html += '<th>参考范围</th>';
      html += '<th>备注</th>';
      html += '</tr></thead>';

      // 表体
      html += '<tbody>';
      rows.forEach(row => {
        html += '<tr>';
        html += '<td>' + this.escapeHtml(row.itemName || '') + '</td>';
        const valueWithUnit = (row.value || '') + (row.unit ? row.unit : '');
        html += '<td>' + this.escapeHtml(valueWithUnit) + '</td>';
        html += '<td>' + this.escapeHtml(row.refRange || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.abnormalFlag || '') + '</td>';
        html += '</tr>';
      });
      html += '</tbody>';

      html += '</table>';
      return html;
    },

    /* 解析处方行文本为结构化数据 */
    parsePrescriptionLine(line) {
      if (!line) return {};

      // 拆分药品名称和后半部分
      const parts = line.split('：');
      const name = (parts[0] || '').trim();
      const rest = (parts.slice(1).join('：') || '').trim();

      const tokens = rest.split('，').map(t => t.trim()).filter(t => t);
      let spec = '';
      let quantity = '';
      let insurance = '';
      let singleDose = '';
      let times = '';
      let usage = '';

      tokens.forEach(token => {
        if (token.startsWith('规格')) {
          spec = token.replace(/^规格[:：]?\s*/, '');
        } else if (token.startsWith('数量')) {
          quantity = token.replace(/^数量[:：]?\s*/, '');
        } else if (token.startsWith('医保类别')) {
          insurance = token.replace(/^医保类别[:：]?\s*/, '');
        } else if (token.startsWith('单次用量')) {
          singleDose = token.replace(/^单次用量[:：]?\s*/, '');
        } else if (token.startsWith('次数')) {
          times = token.replace(/^次数[:：]?\s*/, '');
        } else if (token.startsWith('用法')) {
          usage = token.replace(/^用法[:：]?\s*/, '');
        }
      });

      return {
        name,
        spec,
        quantity,
        insurance,
        singleDose,
        times,
        usage
      };
    },

    /* 将处方明细渲染为表格HTML */
    renderPrescriptionTable(rows) {
      if (!rows || rows.length === 0) return '';

      let html = '<table class="ocr-table prescription-table">';

      // 表头
      html += '<thead><tr>';
      html += '<th>药品名称</th>';
      html += '<th>规格</th>';
      html += '<th>数量</th>';
      html += '<th>医保类别</th>';
      html += '<th>单次用量</th>';
      html += '<th>次数</th>';
      html += '<th>用法</th>';
      html += '</tr></thead>';

      // 表体
      html += '<tbody>';
      rows.forEach(row => {
        html += '<tr>';
        html += '<td>' + this.escapeHtml(row.name || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.spec || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.quantity || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.insurance || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.singleDose || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.times || '') + '</td>';
        html += '<td>' + this.escapeHtml(row.usage || '') + '</td>';
        html += '</tr>';
      });
      html += '</tbody>';

      html += '</table>';
      return html;
    },

    /* 转义HTML */
    escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },

    /* 添加到购物车 */
    addToCart(item) {
      // 检查是否已存在
      const exists = this.referenceCart.find(cartItem =>
        cartItem.id === item.id && cartItem.type === item.type
      );
      if (exists) {
        this.$message.warning('该记录已在购物车中');
        return;
      }

      // 确定分类（用于兼容旧数据，新数据直接使用 type）
      let category = item.type || '未知类型';

      // 提取页名称（直接使用 type 作为页名称）
      let pageName = item.type || '病历记录';

      this.referenceCart.push({
        id: item.id,
        type: item.type || '未知类型',
        category: category,
        title: item.displayName || item.primaryDiagnosis || item.content || '病历记录',
        pageName: pageName,
        time: item.visitDate || item.createTime || item.dischargeTime || item.noteTime,
        createTime: item.createTime || item.visitDate || item.dischargeTime || item.noteTime
      });
      this.$message.success('已添加到购物车');
    },

    /* 切换分类展开/收起 */
    toggleCategory(category) {
      this.historyModalCategories[category].expanded = !this.historyModalCategories[category].expanded;
    },

    /* 获取分类标签（已废弃，购物车直接显示类型名称） */
    getCategoryLabel(category) {
      // 直接返回类型名称，不再使用分类标签
      return category || '未知';
    },

    /* 格式化购物车创建时间 */
    formatCartCreateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    /* 切换购物车收起/展开 */
    toggleCart() {
      this.cartCollapsed = !this.cartCollapsed;
    },

    /* 从购物车删除 */
    removeFromCart(index) {
      this.referenceCart.splice(index, 1);
      this.$message.success('已从购物车移除');
    },

    /* 加载历史病历详情 */
    async loadHistoryModalDetail(item, type = 'outpatient') {
      // 自动展开对应的分类
      if (type === 'outpatient') {
        this.historyModalCategories.outpatient.expanded = true;
      } else if (type === 'admission') {
        this.historyModalCategories.admission.expanded = true;
      } else if (type === 'firstProgress') {
        this.historyModalCategories.firstProgress.expanded = true;
      } else if (type === 'dailyProgress') {
        this.historyModalCategories.dailyProgress.expanded = true;
      } else if (type === 'doctorProgress') {
        this.historyModalCategories.doctorProgress.expanded = true;
      } else if (type === 'discharge') {
        this.historyModalCategories.discharge.expanded = true;
      } else if (type === 'test') {
        this.historyModalCategories.test.expanded = true;
      } else if (type === 'recording') {
        this.historyModalCategories.recording.expanded = true;
      } else if (type === 'image') {
        this.historyModalCategories.image.expanded = true;
      }

      try {
        // 获取 departmentId 和 chatGroup
        const departmentId = this.selectedDepartment || this.itemCacheChatData?.departmentId || '';

        let resp;

        // 根据类型加载对应的详情
        if (type === 'firstProgress' || type === 'dailyProgress' || type === 'doctorProgress') {
          // 病程记录详情（首次病程、日常病程、上级医师查房记录）
          // 使用 item.dataOrigin 作为 chatGroup
          const chatGroup = item.dataOrigin || '';
          resp = await request({
            url: '/ly/lyInpatientCourseNotes/history/detail',
            method: 'POST',
            data: {
              recordId: item.id,
              departmentId,
              chatGroup
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            this.historyModalDetail = {
              ...item,
              type: item.type || '病程记录',
              fields: result.fields || []
            };
          }
        } else if (type === 'discharge' || item.type === '出院记录') {
          // 出院记录详情
          resp = await request({
            url: '/ly/lyInpatientDischargeNotes/history/detail',
            method: 'POST',
            data: {
              recordId: item.id,
              departmentId,
              chatGroup: '5' // 出院记录 chatGroup = 5
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            this.historyModalDetail = {
              ...item,
              type: '出院记录',
              fields: result.fields || []
            };
          }
        } else if (type === 'test' || item.type === '检验报告') {
          // 检验报告详情
          resp = await request({
            url: '/ly/healthTestReports/detail',
            method: 'POST',
            data: {
              recordId: item.id,
              departmentId: this.selectedDepartment || this.itemCacheChatData?.departmentId || ''
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            const fields = result.fields || [];
            this.historyModalDetail = {
              ...item,
              type: '检验报告',
              fields: fields
            };
          }
        } else if (type === 'recording' || item.type === '录音记录') {
          // 录音记录详情（在中间区域显示）——通过单条详情接口获取最新状态
          resp = await request({
            url: '/ly/conversation/recordingDetail',
            method: 'POST',
            data: {
              id: item.id
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            this.historyModalDetail = {
              ...item,
              ...result,
              type: '录音记录',
              displayName: item.displayName || item.title || `${this.formatRecordingDateTime(item.createTime || item.time)}录音记录`,
              extractedMessage: result.aiReturnMsg || item.aiReturnMsg || item.extractedMessage || '',
              audioFilePath: result.audioFilePath || item.audioFilePath || item.audioPath || '',
              recognizeStatus: result.recognizeStatus != null ? result.recognizeStatus : item.recognizeStatus,
              fields: []
            };
          }
        } else if (type === 'image' || item.type === '图片记录') {
          // 图片记录详情
          resp = await request({
            url: '/ly/image/history/detail',
            method: 'POST',
            data: {
              recordId: item.id,
              departmentId: this.selectedDepartment || this.itemCacheChatData?.departmentId || ''
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            const fields = result.fields || [];
            this.historyModalDetail = {
              ...item,
              type: '图片记录',
              fields: fields,
              // PC 优先使用 pcImagePath（/upload/...），小程序/兼容兜底仍保留 imageUrl（OSS）
              pcImagePath: result.pcImagePath || item.pcImagePath,
              localImagePath: result.localImagePath || item.localImagePath,
              imageUrl: result.imageUrl || item.imageUrl,
              content: result.content || item.content,
              ocrResult: result.ocrResult || item.ocrResult,
              ocrStatus: result.ocrStatus
            };
          }
        } else {
          // 门诊病历或入院记录详情
          resp = await request({
            url: '/ly/archive/history/detail',
            method: 'POST',
            data: {
              recordId: item.id,
              departmentId: this.selectedDepartment || this.itemCacheChatData?.departmentId || ''
            }
          });
          if (resp && resp.success) {
            const result = resp.result || {};
            const fields = result.fields || [];
            const medicalDetail = result.medicalDetail || {};
            // 将medicalDetail转换为fields格式
            const convertedFields = fields.length > 0 ? fields : Object.keys(medicalDetail).map(key => ({
              key: key,
              label: key,
              value: medicalDetail[key] || ''
            }));
            this.historyModalDetail = {
              ...item,
              type: item.type || (type === 'admission' ? '入院记录' : '门诊病历'),
              fields: convertedFields
            };
          }
        }
      } catch (error) {
        console.error('加载病历详情失败:', error);
        this.$message.error('加载病历详情失败');
      }
    },

    /* 生成病历 */
    /* 根据类型获取 typeCode */
    getTypeCode(type, pageName, title) {
      // 优先使用 title（displayName）来判断，因为它包含完整信息
      const titleStr = title || '';
      const typeStr = pageName || type || '';

      // 0：门诊病历
      if (typeStr === '门诊病历' || typeStr === '门诊' || titleStr.includes('门诊病历')) {
        return '0';
      }
      // 1：住院病历
      else if (typeStr === '住院病历' || typeStr === '入院记录' || titleStr.includes('入院记录')) {
        return '1';
      }
      // 5：出院记录
      else if (typeStr === '出院记录' || titleStr.includes('出院记录')) {
        return '5';
      }
      // 7：检验报告
      else if (typeStr === '检验报告' || typeStr === '检验' || titleStr.includes('检验') || titleStr.includes('检验报告')) {
        return '7';
      }
      // 8：录音记录
      else if (typeStr === '录音记录' || titleStr.includes('录音记录')) {
        return '8';
      }
      // 9：图片记录
      else if (typeStr === '图片记录' || titleStr.includes('图片记录')) {
        return '9';
      }
      // 病程记录：根据 title 判断具体类型
      else if (typeStr === '病程记录' || titleStr.includes('病程') || titleStr.includes('上级医师')) {
        // 2：首次病程记录
        if (titleStr.includes('首次病程')) {
          return '2';
        }
        // 3：日常病程
        else if (titleStr.includes('日常病程')) {
          return '3';
        }
        // 4：上级医师查房记录
        else if (titleStr.includes('上级医师查房记录') || titleStr.includes('上级医师')) {
          return '4';
        }
        // 如果区分不开，统一使用 2
        else {
          return '2';
        }
      }

      // 默认返回空字符串
      return '';
    },

    // 生成文书期间阻止用户关闭弹层（X 按钮）
    handleHistoryModalBeforeClose(done) {
      if (this.generateDocumentLoading) {
        this.$message.warning('正在生成文书，请等待完成后再关闭...');
        return; // 不调用 done()，阻止关闭
      }
      done(); // 正常关闭
    },

    // 切换历史病历来源筛选（HIS / 本地）
    handleHistorySourceChange() {
      // 如果两个都被取消，则恢复都选中，避免出现“无来源”状态
      if (!this.historySourceHisChecked && !this.historySourceLocalChecked) {
        this.historySourceHisChecked = true;
        this.historySourceLocalChecked = true;
      }
      // 重新加载病例导航
      this.loadHistoryModalNavigation();
    },

    /** 加载生成病历模板下拉选项 */
    async loadDocumentTemplateOptions() {
      const medmstrId = this.itemCacheChatData?.id || '';
      const departmentId = this.itemCacheChatData?.departmentId || '';
      if (!medmstrId || !departmentId) {
        this.documentTemplateOptions = [];
        this.selectedTemplateId = '';
        return;
      }
      this.templateOptionsLoading = true;
      try {
        const resp = await request({
          url: '/ly/inpatientRecord/templateOptions',
          method: 'POST',
          data: {
            departmentId,
            medicalType: this.currentMedicalType,
            medmstrId
          }
        });
        if (resp && resp.success && Array.isArray(resp.result)) {
          this.documentTemplateOptions = resp.result;
          const unused = resp.result.find((opt) => opt.itemType === 'UNUSED');
          this.selectedTemplateId = unused ? unused.id : (resp.result[0]?.id || '');
        } else {
          this.documentTemplateOptions = [];
          this.selectedTemplateId = '';
          this.$message.error(resp?.message || '加载病历模板失败');
        }
      } catch (error) {
        console.error('加载病历模板失败:', error);
        this.documentTemplateOptions = [];
        this.selectedTemplateId = '';
        this.$message.error('加载病历模板失败，请重试');
      } finally {
        this.templateOptionsLoading = false;
      }
    },

    onDocumentTemplateChange() {
      // 切换模板时关闭预览弹窗，避免展示过期内容
      if (this.templatePreviewVisible) {
        this.templatePreviewVisible = false;
        this.templatePreviewText = '';
      }
    },

    async previewSelectedTemplate() {
      if (!this.canPreviewTemplate || this.templatePreviewLoading) {
        return;
      }
      const opt = this.selectedDocumentTemplate;
      if (!opt || opt.itemType === 'UNUSED') {
        this.$message.info('当前选项无可预览内容');
        return;
      }
      const medmstrId = this.itemCacheChatData?.id || '';
      if (!medmstrId) {
        this.$message.warning('请先选择患者');
        return;
      }
      this.templatePreviewLoading = true;
      this.templatePreviewVisible = true;
      this.templatePreviewText = '';
      try {
        const resp = await request({
          url: '/ly/inpatientRecord/templatePreview',
          method: 'POST',
          data: {
            id: opt.id,
            medicalType: opt.medicalType || this.currentMedicalType,
            medmstrId,
            itemType: opt.itemType,
            recordSource: opt.recordSource || ''
          }
        });
        if (resp && resp.success && resp.result) {
          this.templatePreviewText = resp.result.previewText || '';
        } else {
          this.templatePreviewVisible = false;
          this.$message.error(resp?.message || '模板预览失败');
        }
      } catch (error) {
        console.error('模板预览失败:', error);
        this.templatePreviewVisible = false;
        this.$message.error('模板预览失败，请重试');
      } finally {
        this.templatePreviewLoading = false;
      }
    },

    buildGenerateDocumentTemplatePayload() {
      const opt = this.selectedDocumentTemplate;
      if (!opt || opt.itemType === 'UNUSED') {
        return {};
      }
      const payload = {
        templateId: opt.id,
        useHistoricalRecord: opt.itemType === 'RECENT_RECORD'
      };
      return payload;
    },

    /**
     * 将 generateDocument 返回结果规范化为 suggestion fields。
     * 兼容两种结构：
     * 1) result.fields: [{ key, label, value/suggestedValue }]
     * 2) result.record: { chief_complaint: '...', present_illness: '...', ... }
     */
    normalizeGenerateDocumentFields(result) {
      if (!result || typeof result !== 'object') {
        return [];
      }

      if (Array.isArray(result.fields) && result.fields.length > 0) {
        return result.fields
          .map((f) => {
            const suggestedValue = f.suggestedValue != null && f.suggestedValue !== ''
              ? f.suggestedValue
              : (f.value || '');
            return {
              key: f.key,
              label: f.label || f.title || commonRecord[f.key] || GENERATE_RECORD_LABELS[f.key] || f.key,
              value: '',
              suggestedValue
            };
          })
          .filter((f) => f.key && f.suggestedValue !== '' && f.suggestedValue !== '未提供');
      }

      const record = result.record;
      if (!record || typeof record !== 'object' || Array.isArray(record)) {
        return [];
      }

      return Object.keys(record)
        .map((key) => {
          const raw = record[key];
          const suggestedValue = raw == null ? '' : String(raw).trim();
          return {
            key,
            label: commonRecord[key] || GENERATE_RECORD_LABELS[key] || key,
            value: '',
            suggestedValue
          };
        })
        .filter((f) => f.suggestedValue !== '' && f.suggestedValue !== '未提供');
    },

    async generateDocument() {
      if (!this.canGenerateDocument) {
        this.$message.warning('请先选择病历模板或添加记录到购物车');
        return;
      }
      this.generateDocumentLoading = true;
      try {
        const items = this.referenceCart.map(item => ({
          id: item.id,
          type: item.type,
          typeCode: this.getTypeCode(item.type, item.pageName, item.title)
        }));

        // generateDocument 新入参：必须使用"当前挂号"的信息（而不是历史弹窗筛选的科室/就诊号）
        const chatId = (this.itemCacheChatData?.chatId || '').trim();
        const medmstrId = this.itemCacheChatData?.id || '';
        const professionalId = localStorage.getItem('userId') || this.userInfo?.id || '';
        const departmentId = this.itemCacheChatData?.departmentId || '';
        const visitNum =
          this.itemCacheChatData?.visitNum ||
          this.itemCacheChatData?.visitNumber ||
          localStorage.getItem('visitNum') ||
          '';
        const chatGroup = this.currentChatGroup; // chatGroup 即当前标签对应的值
        const templatePayload = this.buildGenerateDocumentTemplatePayload();

        const resp = await request({
          url: '/ly/inpatientRecord/generateDocument',
          method: 'POST',
          data: {
            chatId,
            medmstrId,
            professionalId,
            departmentId,
            visitNum,
            chatGroup,
            attachContent: this.attachContent || '',
            items,
            ...templatePayload
          }
        });
        if (resp && resp.success) {
          const suggestionFields = this.normalizeGenerateDocumentFields(resp.result);
          if (Array.isArray(suggestionFields) && suggestionFields.length > 0) {
            await this.mergeSuggestionsToCurrentTab(suggestionFields);
            this.$message.success('已根据生成病历结果更新病历内容');
          } else {
            this.$message.success('生成病历成功');
          }

          // 成功后清空购物车（因为内容已经引用到主病历区域）
          this.referenceCart = [];

          // 成功后关闭弹窗（历史病历弹窗）
          this.historyModalVisible = false;
        } else {
          this.$message.error(resp?.message || '生成病历失败');
        }
      } catch (error) {
        console.error('生成病历失败:', error);
        this.$message.error('生成病历失败，请重试');
      } finally {
        this.generateDocumentLoading = false;
      }
    },

    // 录音重新识别
    async handleRecordingReIdentify(record) {
      if (!record || !record.id) {
        this.$message.error('记录信息缺失，无法重新识别');
        return;
      }

      const medmstrId = record.medmstrId || (this.itemCacheChatData && this.itemCacheChatData.id) || '';
      const professionalId = record.professionalId || localStorage.getItem('userId') || (this.userInfo && this.userInfo.id) || '';
      const visitNum = record.visitNum || (this.itemCacheChatData && (this.itemCacheChatData.visitNum || this.itemCacheChatData.visitNumber)) || localStorage.getItem('visitNum') || '';
      const departmentId = (this.itemCacheChatData && this.itemCacheChatData.departmentId) || record.departmentId || '';
      const chatGroup = record.chatGroup || '';

      if (!professionalId || !visitNum) {
        this.$message.error('当前就诊信息不完整，无法重新识别');
        return;
      }

      const payload = {
        id: record.id,
        content: '', // 重新识别模式下可为空
        professionalId,
        medmstrId,
        visitNum,
        departmentId,
        chatGroup,
        reIdentify: true
      };

      try {
        const resp = await request({
          url: '/ly/conversation/update',
          method: 'POST',
          data: payload
        });

        if (resp && resp.success) {
          this.$message.success('已重新发起识别，将在后台自动刷新识别结果');
          if (this.historyModalDetail && this.historyModalDetail.id === record.id) {
            this.historyModalDetail.recognizeStatus = 1; // 重置为识别中
          }
          // 启动录音详情轮询，自动刷新识别结果
          this.startRecordingDetailPolling && this.startRecordingDetailPolling(record.id);
        } else {
          this.$message.error((resp && resp.message) || '重新识别失败，请稍后重试');
        }
      } catch (error) {
        console.error('重新识别失败:', error);
        this.$message.error('重新识别失败，请稍后重试');
      }
    },

    // 图片重新识别
    async handleReIdentify(record) {
      if (!record || !record.id) {
        this.$message.error('记录信息缺失，无法重新识别');
        return;
      }

      // 从当前挂号信息中获取必要参数（与生成病历逻辑保持一致）
      const medmstrId = this.itemCacheChatData?.id || '';
      const professionalId = localStorage.getItem('userId') || this.userInfo?.id || '';
      const visitNum =
        this.itemCacheChatData?.visitNum ||
        this.itemCacheChatData?.visitNumber ||
        localStorage.getItem('visitNum') ||
        '';

      if (!medmstrId || !professionalId || !visitNum) {
        this.$message.error('当前就诊信息不完整，无法重新识别');
        return;
      }

      const payload = {
        id: record.id,
        content: record.content || '',
        professionalId,
        medmstrId,
        visitNum,
        title: record.title || record.displayName || '',
        recordTime: record.recordTime || this.getItemTimeDisplay(record, 'image') || '',
        reIdentify: true
      };

      try {
        this.$message.loading && this.$message.loading.close?.();
      } catch (e) {
        // ignore
      }

      try {
        const resp = await request({
          url: '/ly/image/update',
          method: 'POST',
          data: payload
        });

        if (resp && resp.success) {
          this.$message.success('已重新发起识别，请稍后在列表中刷新查看结果');
          // 前端先更新状态，避免仍显示为失败
          if (this.historyModalDetail && this.historyModalDetail.id === record.id) {
            this.historyModalDetail.ocrStatus = 2; // 置为“处理中/待更新”
          }
        } else {
          this.$message.error(resp?.message || '重新识别失败，请稍后重试');
        }
      } catch (error) {
        console.error('重新识别失败:', error);
        this.$message.error('重新识别失败，请稍后重试');
      }
    },

    /* ============================================================
     * 历史病历弹层：拖拽功能
     * ============================================================ */
    initDialogDrag() {
      this.$nextTick(() => {
        const dlg = document.querySelector('.history-modal-dialog');
        const hdr = document.querySelector('.history-modal-dialog .el-dialog__header');
        if (!dlg || !hdr) return;

        if (this._dragCleanup) this._dragCleanup();

        hdr.style.cursor = 'move';
        hdr.style.userSelect = 'none';

        let startX = 0, startY = 0, currentX = 0, currentY = 0, dragging = false;

        const onMousedown = (e) => {
          if (e.button !== 0 || e.target.closest('.el-dialog__headerbtn')) return;
          dragging = true;
          startX = e.clientX - currentX;
          startY = e.clientY - currentY;
          document.body.style.userSelect = 'none';
          e.preventDefault();
        };

        const onMousemove = (e) => {
          if (!dragging) return;
          currentX = e.clientX - startX;
          currentY = e.clientY - startY;
          dlg.style.transform = `translate(${currentX}px, ${currentY}px)`;
        };

        const onMouseup = () => {
          dragging = false;
          document.body.style.userSelect = '';
        };

        hdr.addEventListener('mousedown', onMousedown);
        document.addEventListener('mousemove', onMousemove);
        document.addEventListener('mouseup', onMouseup);

        this._dragCleanup = () => {
          hdr.removeEventListener('mousedown', onMousedown);
          document.removeEventListener('mousemove', onMousemove);
          document.removeEventListener('mouseup', onMouseup);
          dlg.style.transform = '';
          currentX = 0;
          currentY = 0;
        };
      });
    },

    /* ============================================================
     * 导航列表：获取用于排序的时间值（Date 对象）
     * ============================================================ */
    getItemTimeValue(item, category) {
      let raw = null;
      if (category === 'outpatient' || category === 'admission') {
        raw = item.visitDate || item.createTime;
      } else if (category === 'firstProgress' || category === 'dailyProgress' || category === 'doctorProgress') {
        raw = item.noteTime;
      } else if (category === 'discharge') {
        raw = item.dischargeTime;
      } else if (category === 'test') {
        raw = item.reviewTime;
      } else {
        // recording / image
        raw = item.createTime;
      }
      return raw ? new Date(raw) : new Date(0);
    },

    /* ============================================================
     * 导航列表：获取用于显示的时间字符串
     * ============================================================ */
    getItemTimeDisplay(item, category) {
      const d = this.getItemTimeValue(item, category);
      if (!d || d.getTime() === 0) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${y}-${m}-${day} ${h}:${min}`;
    },

    /* ============================================================
     * 导航列表：获取用于模糊搜索的文本
     * ============================================================ */
    getNavItemSearchText(item) {
      const parts = [
        item.displayName,
        item.primaryDiagnosis,
        item.content,
        item.testType,
        item.reportConclusion,
        item.testPurpose,
        item.aiReturnMsg,
        item.extractedMessage,
        item.title
      ];
      return parts.filter(Boolean).join(' ').toLowerCase();
    },

    /* ============================================================
     * 导航列表：过滤（搜索）+ 排序
     * ============================================================ */
    /* ============================================================
     * 历史病历弹层三栏调宽（独立于主面板 resize 逻辑）
     * ============================================================ */
    startDlgResize(side, e) {
      const startX = e.clientX;
      const startLeft = this.dlgLeftWidth;
      const startRight = this.dlgRightWidth;
      const MIN = 280;

      // 拖拽右面板时临时禁用 transition，避免跟随延迟
      const rightEl = document.querySelector('.history-modal-right');
      if (side === 'right' && rightEl) rightEl.style.transition = 'none';

      const onMove = (ev) => {
        const dx = ev.clientX - startX;
        if (side === 'left') {
          this.dlgLeftWidth = Math.max(MIN, startLeft + dx);
        } else {
          this.dlgRightWidth = Math.max(MIN, startRight - dx);
        }
      };
      const onUp = () => {
        if (side === 'right' && rightEl) rightEl.style.transition = '';
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },

    getFilteredCount(list, category) {
      const kw = (this.navSearchKeyword || '').trim().toLowerCase();
      if (!kw) return list.length;
      return list.filter(item => this.getNavItemSearchText(item).includes(kw)).length;
    },

    getNavList(list, category) {
      let result = list;

      // 搜索过滤
      const kw = (this.navSearchKeyword || '').trim().toLowerCase();
      if (kw) {
        result = result.filter(item => this.getNavItemSearchText(item).includes(kw));
      }

      // 时间排序（复制数组避免污染原数据）
      result = result.slice().sort((a, b) => {
        const ta = this.getItemTimeValue(a, category).getTime();
        const tb = this.getItemTimeValue(b, category).getTime();
        return this.navSortOrder === 'desc' ? tb - ta : ta - tb;
      });

      return result;
    }
  }
};
</script>

<style lang="less" scoped>
.content_son {
  height: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
}

/* 中间滚动区域背景色，与门诊保持一致，用于区分顶部和底部吸顶框 */
::v-deep .center {
  // 未选择患者时：白色背景
  &.center-empty {
    background: #fff;
  }

  // 选择患者后：浅灰色背景
  &.center-with-content {
    background: #f2f2f7;
  }

  .el-tabs {
    background: #f2f2f7;

    .el-tabs__header {
      margin: 0 1.25rem;
      background: #f2f2f7;
      display: none; // 隐藏center区域内的标签头，因为已经在顶部显示了
    }

    .el-tabs__content {
      background: #f2f2f7;
    }

    &.tabs-content {
      .el-tabs__header {
        display: none;
      }
    }
  }

  // 图标样式（参考门诊）
  .icoBox {
    display: flex;
    justify-content: center;
    align-items: center;

    .ico {
      width: 96px;
      height: 96px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f2f2f7;
      border-radius: 50%;
      margin-bottom: 1rem;
      font-size: 2.5rem;
      color: #c7c7cc;
    }
  }

  .text {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 500;
    color: #2c2c2c;
    text-align: center;
  }

  .text2 {
    color: #c7c7cc;
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-top: 0.5rem;
    text-align: center;
  }
}

/* 顶部标签页样式 */
::v-deep .top {
  .tabs-wrapper {
    flex: 1;
    display: flex;
    align-items: center;

    .el-tabs {
      width: 100%;

      &.tabs-in-top {
        .el-tabs__header {
          margin: 0;
          padding: 0;
          border-bottom: none;
          background: transparent;
        }

        .el-tabs__nav-wrap {
          &::after {
            display: none; // 隐藏默认的下划线
          }
        }

        .el-tabs__item {
          padding: 0 1.25rem;
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }
}

.hisDia {
  p {
    margin: 0 0 8px 0;
    font-weight: 600;
  }
  span {
    color: #999;
    font-size: 12px;
  }
}
/* OCR上传按钮样式 - 与右侧按钮保持一致 */
.soundRecording {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem; /* 与右侧按钮间距一致 */
  padding-left: 0; /* 移除左边距，使用gap统一间距 */
  overflow: visible !important; /* 移除滚动条 */
  white-space: nowrap; /* 防止换行 */

  ::v-deep .ocr-upload-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    background-color: transparent !important;
    color: #4169e1 !important;
    border: 1px solid #d1d1d6 !important;
    border-radius: 9999px !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    cursor: pointer;
    flex-shrink: 0;
    margin-right: 0.5rem;

    i {
      font-size: 18px !important;
      line-height: 1 !important;
      color: #4169e1 !important;
    }

    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18) !important;
      transform: translateY(-3px) scale(1.1) !important;
    }
  }

  /* 覆盖SoundRecording组件的overflow-x: auto */
  ::v-deep .sound-recording {
    overflow-x: visible !important;
    overflow: visible !important;
  }
}

/* 对齐门诊病历的底部按钮区域间距 */
.bottom {
  padding: 0.5rem 0.75rem !important;
  position: relative;
  min-height: 60px;
}

/* 全部接受和全部拒绝按钮样式 - 与门诊保持一致 */
.accept-reject-buttons {
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 12px;
  z-index: 100;

  .accept-all-btn,
  .reject-all-btn {
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    border: none;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.20);
    }

    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .accept-all-btn {
    background-color: #4ade80;
    color: #fff;

    &:hover {
      background-color: #4ade80;
      opacity: 0.9;
    }
  }

  .reject-all-btn {
    background-color: #d32f2f;
    color: #fff;

    &:hover {
      background-color: #d32f2f;
      opacity: 0.9;
    }
  }
}

/* 重新启用历史病历弹窗按钮样式 - 与门诊保持一致 */
::v-deep .medical-history-dialog {
  z-index: 2002 !important;

  .el-dialog__wrapper {
    z-index: 2002 !important;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      flex-wrap: wrap;

      .el-button {
        padding: 12px 28px !important;
        font-size: 15px;
        min-height: 44px !important;
        border-radius: 10px;
        font-weight: 500;
        line-height: 1.5;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-1px);
        }

        &.el-button--primary {
          background-color: #4169e1;
          border-color: #4169e1;
          box-shadow: 0 4px 12px rgba(65, 105, 225, 0.25);

          &:hover {
            background-color: #4169e1;
            opacity: 0.9;
            box-shadow: 0 6px 16px rgba(65, 105, 225, 0.35);
          }
        }
      }
    }
  }
}

/* 录音内容弹窗按钮样式 - 与门诊保持一致 */
::v-deep .recording-dialog {
  .el-dialog__footer {
    padding: 16px 24px 24px;

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      flex-wrap: wrap;

      .el-button {
        padding: 12px 28px !important;
        font-size: 15px;
        min-height: 44px !important;
        border-radius: 10px;
        font-weight: 500;
        line-height: 1.5;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-1px);
        }

        &.el-button--primary {
          background-color: #4169e1;
          border-color: #4169e1;
          box-shadow: 0 4px 12px rgba(65, 105, 225, 0.25);

          &:hover {
            background-color: #4169e1;
            opacity: 0.9;
            box-shadow: 0 6px 16px rgba(65, 105, 225, 0.35);
          }
        }

        &.accept-all-submit-btn {
          background-color: #52c41a;
          border-color: #52c41a;
          box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25);
          color: white !important;
          font-weight: 600;
          font-size: 15px;

          &:hover {
            background-color: #389e0d;
            border-color: #389e0d;
            color: white !important;
            box-shadow: 0 6px 16px rgba(82, 196, 26, 0.35);
          }

          i {
            color: white !important;
            margin-right: 6px;
            font-size: 16px;
          }
        }
      }
      }
    }
  }

// 历史病历弹窗样式（全面升级版）
::v-deep .history-modal-dialog {
  z-index: 2001 !important;
  // CSS 原生 resize：不依赖任何 JS 角柄，浏览器原生处理光标变换和拖拽
  // overflow: hidden 是 resize: both 生效的必要条件（CSS 规范要求）
  overflow: hidden !important;
  resize: both;
  // Flex 布局：让 body 自动填满弹层剩余高度（配合 resize 使用）
  display: flex !important;
  flex-direction: column !important;
  // 初始尺寸（宽度通过 CSS 控制，el-dialog :width="" 不干预 style.width）
  // 注意：width/height 不加 !important，否则会覆盖浏览器原生 resize 设置的内联样式
  width: 90%;
  height: 85vh;
  // margin-bottom 必须清零：El UI 默认 .el-dialog 有 50px 底部 margin，
  // top(2vh) + height(85vh) + margin-bottom(50px) = 87vh+50px，会让 wrapper 出现滚动条
  margin-bottom: 0 !important;
  min-width: 50vw;
  max-width: 98vw;
  min-height: 400px;
  max-height: 98vh;
  box-sizing: border-box !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.22), 0 8px 20px rgba(65, 105, 225, 0.12) !important;
  position: relative;

  .el-dialog__wrapper {
    z-index: 2001 !important;
  }

  // 标题栏渐变升级
  .el-dialog__header {
    background: linear-gradient(135deg, #4169e1 0%, #6b9df5 100%);
    padding: 18px 24px;
    // 头部自己承担圆角，避免依赖父级 overflow:hidden
    border-radius: 16px 16px 0 0;

    .el-dialog__title {
      color: #fff;
      font-size: 17px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    .el-dialog__headerbtn {
      top: 12px;
      right: 16px;
      width: 40px;
      height: 40px;

      .el-dialog__close {
        color: rgba(255, 255, 255, 0.85);
        font-size: 36px;
        transition: all 0.2s;

        &:hover {
          color: #fff;
          transform: rotate(90deg);
        }
      }
    }
  }

  .el-dialog__body {
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    // flex: 1 配合父级 display:flex 自动填满弹层高度（支持 resize: both 动态高度）
    flex: 1 !important;
    height: 0 !important;      // 必须设为 0，flex: 1 才能正确接管高度
    max-height: none !important;
    overflow: hidden;
    background: #f5f7fb;
    border-radius: 0 0 16px 16px;
  }

  .history-modal-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    gap: 12px;

    // 顶部筛选栏升级
    .history-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      background: #fff;
      border-radius: 12px;
      border-left: 3px solid #4169e1;
      box-shadow: 0 2px 8px rgba(65, 105, 225, 0.08);
      flex-shrink: 0;

      .header-left {
        display: flex;
        align-items: center;
        gap: 10px;

        // Element UI Select 内联样式覆盖
        .el-select {
          .el-input__inner {
            border-radius: 9999px;
            border-color: #d0d7f0;
            font-size: 13px;
            height: 34px;
            line-height: 34px;
            transition: all 0.25s;

            &:focus {
              border-color: #4169e1;
              box-shadow: 0 0 0 3px rgba(65, 105, 225, 0.12);
            }
          }
        }

        // 急诊号选择：输入框更友好（下拉项样式在 :global 里）
        .history-visitnum-select {
          width: 420px;
          max-width: 45vw;
          min-width: 260px;
        }
      }

      .header-right {
        .patient-info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;

          span {
            display: inline-flex;
            align-items: center;
            padding: 3px 10px;
            background: #eef2ff;
            border: 1px solid #d0d7f0;
            border-radius: 9999px;
            color: #3d5cc9;
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;
          }
        }
      }
    }

    .history-modal-body {
      display: flex;
      gap: 0;
      flex: 1;
      min-height: 0;
      overflow: hidden;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

      // 左侧导航树升级
      .history-modal-left {
        min-width: 280px;
        flex-shrink: 0;
        border-right: 1px solid #eef0f8;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
        background: #fafbff;
        border-radius: 12px 0 0 12px;

        // 工具栏：搜索 + 排序
        .nav-toolbar {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 12px 8px;
          border-bottom: 1px solid #eef0f8;
          flex-shrink: 0;
          background: #fafbff;

          .nav-search {
            flex: 1;

            .el-input--mini .el-input__inner {
              border-radius: 9999px;
              border-color: #d0d7f0;
              background: #fff;
              font-size: 12px;
              height: 28px;
              line-height: 28px;
              padding-left: 28px;
              transition: all 0.25s;

              &:focus {
                border-color: #4169e1;
                box-shadow: 0 0 0 2px rgba(65, 105, 225, 0.12);
              }
            }

            .el-input__prefix {
              line-height: 28px;

              .el-input__icon {
                line-height: 28px;
                font-size: 13px;
                color: #aab0cc;
              }
            }
          }

          .sort-toggle-btn {
            flex-shrink: 0;
            width: 28px;
            height: 28px;
            border: 1px solid #d0d7f0;
            border-radius: 8px;
            background: #fff;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
            color: #8a96c0;
            font-size: 14px;

            &:hover {
              border-color: #4169e1;
              color: #4169e1;
              background: #eef2ff;
            }
          }
        }

        .navigation-tree {
          flex: 1;
          overflow-y: auto;
          min-height: 0;
          padding: 8px 0;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-track {
            background: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background: #d0d7f0;
            border-radius: 4px;
          }

          .navigation-category {
            margin-bottom: 2px;

            .category-header {
              display: flex;
              align-items: center;
              padding: 10px 14px;
              background: transparent;
              border-radius: 0;
              cursor: pointer;
              transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
              font-weight: 600;
              font-size: 13px;
              color: #2c2c2c;
              border-left: 3px solid transparent;

              &:hover {
                background: #eef2ff;
                color: #4169e1;
                border-left-color: #c5d0f5;
              }

              i {
                margin-right: 6px;
                font-size: 12px;
                color: #8a96c0;
                transition: color 0.2s;
              }

              .category-icon {
                font-size: 15px;
                color: #4169e1;
                margin-right: 8px;
              }

              .category-label {
                flex: 1;
              }

              .category-count {
                font-size: 11px;
                color: #b0b8d8;
                font-weight: 500;
                background: #eef2ff;
                padding: 1px 6px;
                border-radius: 9999px;

                .count-filtered {
                  color: #FF9500;
                  font-weight: 700;
                }
              }
            }

            .category-items {
              margin-top: 0;
              padding-left: 0;

              .navigation-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 6px;
                padding: 8px 10px 8px 34px;
                cursor: pointer;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                font-size: 12px;
                color: #666;
                border-left: 3px solid transparent;
                line-height: 1.5;

                &:hover {
                  background: #f0f4ff;
                  color: #4169e1;
                  border-left-color: #c5d0f5;
                }

                &.active {
                  background: linear-gradient(to right, #eef2ff, #f8faff);
                  color: #4169e1;
                  font-weight: 600;
                  border-left-color: #4169e1;
                }

                .nav-item-label {
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  min-width: 0;
                }

                .nav-item-time {
                  flex-shrink: 0;
                  font-size: 10px;
                  color: #b0b8d8;
                  white-space: nowrap;
                  margin-left: 2px;
                }
              }

              .navigation-item-empty {
                padding: 12px 14px 12px 38px;
                text-align: left;
                color: #c0c4cc;
                font-size: 12px;
                font-style: italic;
              }
            }
          }
        }
      }

      // 中间详情区升级
      .history-modal-center {
        flex: 1;
        padding: 16px 20px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
        min-height: 0;
        background: #fff;

        &.cart-collapsed {
          margin-right: 0;
        }

        .cart-expand-btn {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 88px;
          background: linear-gradient(180deg, #4169e1, #6b9df5);
          border: none;
          border-radius: 8px 0 0 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 10;
          box-shadow: -3px 0 12px rgba(65, 105, 225, 0.25);

          &:hover {
            width: 36px;
            box-shadow: -4px 0 16px rgba(65, 105, 225, 0.4);
          }

          i {
            font-size: 16px;
            color: #fff;
            margin-bottom: 6px;
          }

          span {
            writing-mode: vertical-lr;
            text-orientation: upright;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 600;
            letter-spacing: 2px;
          }
        }

        .detail-content {
          display: flex;
          flex-direction: column;
          height: 100%;
          // 不设 overflow:hidden，让 detail-body 自己负责滚动
          // 避免 detail-header 内按钮的 hover transform 被裁剪

          .detail-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 14px;
            padding-bottom: 14px;
            border-bottom: 1px solid #eef0f8;
            flex-shrink: 0;
            position: relative;
            z-index: 5;
            overflow: visible;

            h3 {
              margin: 0;
              font-size: 15px;
              font-weight: 700;
              color: #1a1a2e;
              padding-left: 12px;
              border-left: 4px solid #4169e1;
              line-height: 1.4;
            }

            // 加入购物车按钮升级
            .el-button--primary.el-button--small {
              background: linear-gradient(135deg, #4169e1, #6b9df5) !important;
              border: none !important;
              border-radius: 9999px !important;
              padding: 7px 16px !important;
              font-weight: 600 !important;
              font-size: 13px !important;
              box-shadow: 0 3px 10px rgba(65, 105, 225, 0.3) !important;
              transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;

              &:hover {
                transform: translateY(-2px) !important;
                box-shadow: 0 6px 18px rgba(65, 105, 225, 0.42) !important;
              }

              &:active {
                transform: translateY(0) !important;
              }
            }
          }

          .detail-body {
            flex: 1;
            overflow-y: auto;
            min-height: 0;

            &::-webkit-scrollbar {
              width: 5px;
            }
            &::-webkit-scrollbar-track {
              background: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background: #d0d7f0;
              border-radius: 4px;
            }

            .image-preview {
              margin-bottom: 16px;

              .preview-image {
                max-width: 100%;
                max-height: 400px;
                border: 1px solid #eef0f8;
                border-radius: 10px;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
              }
            }

            .ocr-content {
              margin-top: 16px;

              .ocr-table {
                width: 100%;
                border-collapse: collapse;
                margin: 10px 0;
                font-size: 13px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                overflow-x: auto;
                display: block;
                border-radius: 8px;
                overflow: hidden;

                @media (min-width: 768px) {
                  display: table;
                }

                th, td {
                  border: 1px solid #eef0f8;
                  padding: 10px 14px;
                  text-align: left;
                  word-break: break-word;
                }

                thead {
                  background-color: #eef2ff;
                  display: table-header-group;

                  th {
                    font-weight: 700;
                    color: #4169e1;
                    background-color: #eef2ff;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                  }
                }

                tbody {
                  display: table-row-group;

                  tr {
                    &:nth-child(even) {
                      background-color: #fafbff;
                    }

                    &:hover {
                      background-color: #f0f4ff;
                    }
                  }

                  td {
                    color: #555;
                  }
                }

                @media (max-width: 767px) {
                  display: block;
                  overflow-x: auto;
                  white-space: nowrap;

                  th, td {
                    white-space: nowrap;
                    min-width: 80px;
                  }
                }
              }

              p {
                margin: 8px 0;
                line-height: 1.7;
                color: #444;
              }

              .image-section {
                margin: 16px 0;
                padding: 14px 16px;
                background: #fafbff;
                border-radius: 10px;
                border-left: 3px solid #4169e1;

                .image-title {
                  margin: 0 0 10px 0;
                  font-size: 14px;
                  font-weight: 700;
                  color: #4169e1;
                }
              }
            }

            .detail-field {
              margin-bottom: 12px;
              padding: 12px 14px;
              background: #fafbff;
              border-radius: 10px;
              border: 1px solid #eef0f8;
              transition: box-shadow 0.2s;

              &:hover {
                box-shadow: 0 3px 10px rgba(65, 105, 225, 0.08);
              }

              &:nth-child(even) {
                background: #fff;
              }

              .field-label {
                display: inline-flex;
                align-items: center;
                font-weight: 700;
                font-size: 12px;
                color: #4169e1;
                background: #eef2ff;
                padding: 2px 10px;
                border-radius: 9999px;
                margin-bottom: 8px;
              }

              .field-value {
                color: #444;
                line-height: 1.7;
                white-space: pre-wrap;
                font-size: 13px;
              }
            }

            /* 录音记录特殊样式 */
            .recording-player {
              .field-value {
                padding: 6px 0;
              }

              .recording-audio-player {
                height: 40px;
                width: 100%;
                border-radius: 8px;
              }
            }

            .recording-content,
            .recording-original {
              .recording-text {
                padding: 14px;
                background: #fff;
                border-radius: 8px;
                border: 1px solid #eef0f8;
                line-height: 1.8;
                white-space: pre-wrap;
                word-break: break-word;
                max-height: 400px;
                overflow-y: auto;
                font-size: 13px;
                color: #444;
              }
            }
          }
        }

        .detail-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          color: #c0c4cc;
          gap: 10px;

          i {
            font-size: 40px;
            opacity: 0.4;
          }
        }
      }

      // 右侧购物车区域升级
      .dlg-resize-handle {
        width: 5px;
        flex-shrink: 0;
        cursor: col-resize;
        background: transparent;
        transition: background 0.2s;
        position: relative;
        z-index: 10;

        &:hover, &:active {
          background: rgba(65, 105, 225, 0.25);
        }
      }

      .dlg-corner-resize {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 18px;
        height: 18px;
        cursor: nwse-resize;
        z-index: 100;
        background: linear-gradient(135deg, transparent 40%, rgba(65, 105, 225, 0.35) 40%);
        border-radius: 0 0 12px 0;
      }

      .history-modal-right {
        min-width: 280px;
        flex-shrink: 0;
        border-left: 1px solid #eef0f8;
        display: flex;
        flex-direction: column;
        transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s, opacity 0.3s;
        height: 100%;
        overflow: hidden;
        min-height: 0;
        background: #fff;
        border-radius: 0 12px 12px 0;

        &.collapsed {
          width: 0;
          min-width: 0;
          padding: 0;
          opacity: 0;
          border: none;
          overflow: hidden;
          pointer-events: none;
        }

        .cart-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 16px;
          background: linear-gradient(135deg, #eef2ff 0%, #f8faff 100%);
          border-bottom: 1px solid #e0e7ff;
          flex-shrink: 0;
          border-radius: 0 12px 0 0;

          h4 {
            margin: 0;
            font-size: 14px;
            font-weight: 700;
            color: #4169e1;
            letter-spacing: 0.3px;
          }

          .cart-toggle-btn {
            padding: 0;
            font-size: 15px;
            color: #8a96c0;
            transition: all 0.2s;

            &:hover {
              color: #4169e1;
              transform: scale(1.15);
            }
          }
        }

        .cart-body {
          flex: 1;
          overflow-y: auto;
          min-height: 0;
          padding: 12px;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-track {
            background: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background: #d0d7f0;
            border-radius: 4px;
          }

          .cart-list {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .cart-item {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 10px 12px;
              background: #fafbff;
              border-radius: 10px;
              border: 1px solid #eef0f8;
              border-left: 3px solid #4169e1;
              transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              cursor: default;

              &:hover {
                box-shadow: 0 4px 14px rgba(65, 105, 225, 0.14);
                background: #f5f8ff;
                transform: translateX(2px);
              }

              .cart-item-content {
                flex: 1;
                min-width: 0;

                .cart-item-line1 {
                  font-weight: 600;
                  color: #2c2c2c;
                  margin-bottom: 4px;
                  font-size: 12px;
                  line-height: 1.5;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .cart-item-line2 {
                  font-size: 11px;
                  color: #aab0cc;
                }
              }

              .cart-item-delete {
                color: #c0c4cc;
                padding: 0;
                margin-left: 6px;
                flex-shrink: 0;
                font-size: 14px;
                transition: all 0.2s;

                &:hover {
                  color: #f56c6c;
                  transform: scale(1.2);
                }
              }
            }
          }

          .cart-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 160px;
            color: #c0c4cc;
            gap: 8px;
            text-align: center;
            padding: 0 12px;

            i {
              font-size: 36px;
              opacity: 0.45;
              display: block;
              margin-bottom: 4px;
            }

            .empty-text {
              font-size: 12px;
              line-height: 1.6;
              color: #b0b8d8;
            }
          }
        }

        .cart-footer {
          padding: 12px;
          border-top: 1px solid #eef0f8;
          flex-shrink: 0;
          background: #fff;
          border-radius: 0 0 12px 0;

          .cart-attach-input {
            margin-bottom: 8px;
          }

          .cart-template-select {
            margin-bottom: 10px;

            .cart-template-label-row {
              display: flex;
              align-items: baseline;
              justify-content: space-between;
              margin-bottom: 4px;
              line-height: 1.2;
            }

            .cart-template-label {
              font-size: 13px;
              color: #606266;
              font-weight: 500;
            }

            .cart-template-preview-link {
              flex-shrink: 0;
              font-size: 12px;
              line-height: 1.2;
              color: #4169e1;
              text-decoration: none;
              cursor: pointer;
              user-select: none;

              &:hover:not(.is-disabled) {
                color: #6b9df5;
                text-decoration: underline;
              }

              &.is-disabled {
                color: #c0c4cc;
                cursor: not-allowed;
                pointer-events: none;
              }
            }
          }

          // 生成病历按钮升级（仅主按钮，避免影响模板预览链接）
          > .el-button.el-button--primary {
            background: linear-gradient(135deg, #4169e1, #6b9df5) !important;
            border: none !important;
            border-radius: 9999px !important;
            height: 42px !important;
            font-weight: 700 !important;
            font-size: 14px !important;
            letter-spacing: 0.5px !important;
            box-shadow: 0 4px 14px rgba(65, 105, 225, 0.32) !important;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
            color: #fff !important;

            &:hover:not(.is-disabled) {
              transform: translateY(-2px) !important;
              box-shadow: 0 8px 22px rgba(65, 105, 225, 0.44) !important;
            }

            &:active:not(.is-disabled) {
              transform: translateY(0) !important;
              box-shadow: 0 3px 10px rgba(65, 105, 225, 0.3) !important;
            }

            &.is-disabled {
              background: linear-gradient(135deg, #b8c4e8, #c8d5f5) !important;
              box-shadow: none !important;
              cursor: not-allowed !important;
            }
          }
        }
      }
    }
  }
}

// 下拉选项弹层在 body 下，必须使用全局选择器
:global(.history-visitnum-popper) {
  min-width: 420px;
  max-width: 75vw;

  .el-select-dropdown__item {
    height: auto;
    line-height: 1.4;
    padding-top: 8px;
    padding-bottom: 8px;
    white-space: normal;
  }

  .history-visitnum-option {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
}
</style>

<style lang="less">
.template-preview-dialog {
  .template-preview-content {
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 60vh;
    overflow-y: auto;
    line-height: 1.7;
    font-size: 14px;
    color: #303133;
    padding: 4px 0;
  }
}
</style>

<style lang="less" src="@/assets/style/pages/management/aiService/index.less"></style>
